import { SvgIcon } from '@mui/material';
import * as React from 'react';
import { SVGProps } from 'react';
import logo from './logo/Spark_800x400_avec_baseline_sans_logo_blanc.png';
import logoTangram from './logo/Logo_TANGRAM.png';
import { AvatarAccessory, AvatarAccessorySvg } from '../contexts/Contexts.types';

// Shared SVG/icon exports used across navbar, popups, and profile/game UI.
const styles = {
	icons: {
		overflow: 'visible'
	},
	iconsBox: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	}
};

/**
 * NAVBAR
 */
export const PracticeIcon = (
	<SvgIcon sx={styles.icons}>
		<g id="profile">
			<g id="profil_group">
				<path
					id="practice_path_6"
					className="cls-1"
					d="M22.54 8.15c0-3.95-2.95-7.15-6.6-7.15h-.26v7.31H8.32V1h-.26c-3.65 0-6.6 3.2-6.6 7.15v.38c0 3.95 2.95 7.15 6.6 7.15h.25v7.31h7.43v-7.31h.2c3.65 0 6.6-3.2 6.6-7.15v-.38Z"
				/>
			</g>
		</g>
	</SvgIcon>
);
export const ChallengeIcon = (
	<SvgIcon sx={styles.icons}>
		<g id="Challenge">
			<g id="challenge_group">
				<polygon
					id="challenge_path_6"
					className="cls-1"
					points="24 6.5 20.65 9.94 20.63 9.93 20.54 3.16 20.55 3.14 24 6.5"
				/>
				<polygon
					id="challenge_path_5"
					className="cls-1"
					points="0 6.47 3.35 9.93 3.36 9.91 3.47 3.14 3.45 3.13 0 6.47"
				/>
				<rect
					id="challenge_path_4"
					className="cls-1"
					x="8.97"
					y="17.73"
					width="6.29"
					height="3.14"
					transform="translate(.02 -.01) rotate(.06)"
				/>
				<rect
					id="challenge_path_3"
					className="cls-1"
					x="8.97"
					y="13.1"
					width="6.29"
					height="3.14"
					transform="translate(26.8 2.57) rotate(90.06)"
				/>
				<path
					id="challenge_path_2"
					className="cls-1"
					d="m11.75,11.69c.11,0,.21,0,.32,0l-.08-8.44-8.45.08v.32c.04,4.49,3.72,8.1,8.2,8.06Z"
				/>
				<path
					id="challenge_path_1"
					className="cls-1"
					d="m12.39,11.68c-.11,0-.21,0-.32,0l-.08-8.44,8.45-.08v.32c.04,4.49-3.56,8.16-8.05,8.2Z"
				/>
			</g>
		</g>
	</SvgIcon>
);
export const HomeIcon = (
	<SvgIcon sx={styles.icons}>
		<g id="home">
			<g id="home_group">
				<polygon
					id="home_path_5"
					className="cls-1"
					points="12.23 .51 15.41 7.12 12.18 7.09 12.23 .51"
				/>
				<polygon
					id="home_path_4"
					className="cls-1"
					points="12.15 .49 12.09 7.09 8.81 7.07 12.11 .49 12.15 .49"
				/>
				<polygon
					id="home_path_3"
					className="cls-1"
					points="5 19.74 8.71 16.09 8.73 16.11 8.67 23.44 8.65 23.45 5 19.74"
				/>
				<polygon
					id="home_path_2"
					className="cls-1"
					points="19 19.86 15.35 16.15 15.33 16.17 15.27 23.49 15.29 23.51 19 19.86"
				/>
				<rect
					id="home_path_1"
					className="cls-1"
					x="5.45"
					y="10.4"
					width="13.21"
					height="6.6"
					transform="translate(-1.75 25.63) rotate(-89.51)"
				/>
			</g>
		</g>
	</SvgIcon>
);
export const GameIcon = (
	<SvgIcon sx={styles.icons}>
		{/* Composite game icon with grouped paths so style classes can target parts consistently. */}
		<g id="game">
			<g id="game_group">
				<path
					id="game_path_9"
					className="cls-1"
					d="m3.4,11.19v.77s0,0,0,0h-.47s-2.81-.01-2.81-.01c0-.07,0-.15,0-.23.01-3.17,2.6-5.74,5.77-5.72h.16s.07,0,.07,0v2.87s-.08,0-.08,0h-.3s0,2.33,0,2.33h-2.33Z"
				/>
				<path
					id="game_path_8"
					className="cls-1"
					d="m6.08,17.94h-.08s-.15,0-.15,0c-3.17,0-5.74-2.59-5.74-5.76,0-.08,0-.15,0-.23h2.81s.47,0,.47,0v.78s2.33.01,2.33.01v2.33s.29,0,.29,0h.07s0,2.86,0,2.86Z"
				/>
				<path
					id="game_path_7"
					className="cls-1"
					d="m23.88,11.82c.01-3.18-2.55-5.76-5.73-5.77h-.23s-.03,5.97-.03,5.97h0s2.76.01,2.76.01h3.2c0-.06,0-.14,0-.21Zm-4.48-2.19h.03s0-.01,0-.01h.03c.57-.21,1.2.09,1.4.67,0,.01,0,.03.01.04,0,.01.01.03.02.04.2.57-.11,1.2-.68,1.4h-.03s0,.01,0,.01h-.03c-.57.21-1.2-.09-1.4-.67,0-.01,0-.03-.01-.04,0-.01-.01-.03-.02-.04-.2-.57.1-1.2.68-1.4Z"
				/>
				<path
					id="game_path_6"
					className="cls-1"
					d="m23.89,12.28c0-.08,0-.15,0-.23l-5.97-.04-.04,5.97h.23c3.17.02,5.76-2.54,5.78-5.71Z"
				/>
				<rect
					id="game_path_5"
					className="cls-1"
					x="11.94"
					y="6.04"
					width="5.97"
					height="5.97"
					transform="translate(.04 -.06) rotate(.24)"
				/>
				<path
					id="game_path_4"
					className="cls-1"
					d="m17.88,17.99v-3.09s.01-.22.01-.22v-2.66s-5.89-.02-5.89-.02h-.07s-.02,5.97-.02,5.97h.07s5.9.03,5.9.03h0Zm-.77-3.38h-.03s0,.01,0,.01h-.03c-.58.21-1.2-.09-1.4-.67,0-.01,0-.03-.01-.04s0-.03-.01-.04c-.2-.57.1-1.2.68-1.4h.03s0-.01,0-.01h.03c.57-.21,1.2.09,1.4.67,0,.01.01.03.01.04,0,.01.01.03.01.04.2.57-.1,1.2-.68,1.4Z"
				/>
				<polygon
					id="game_path_3"
					className="cls-1"
					points="12 12 11.93 12 9.61 11.99 9.61 11.21 7.28 11.2 7.29 8.87 6.11 8.87 6.04 8.87 6.05 6 6.12 6 11.96 6.03 12.03 6.03 12 12"
				/>
				<polygon
					id="game_path_2"
					className="cls-1"
					points="6.1 11.98 6.09 11.98 6.1 11.97 6.1 11.98"
				/>
				<polygon
					id="game_path_1"
					className="cls-1"
					points="11.98 17.97 11.91 17.97 6 17.95 6 17.94 6.01 15.08 6.08 15.08 7.27 15.09 7.28 12.76 9.61 12.77 9.61 11.99 11.93 12 12 12 11.98 17.97"
				/>
			</g>
		</g>
	</SvgIcon>
);
export const LearningIcon = (
	<SvgIcon sx={styles.icons}>
		<g id="learning">
			<g id="learning_group">
				<polygon
					id="learning_path_4"
					className="cls-1"
					points="20.4 2.45 23 13.03 22.95 13.05 9.83 5.11 9.82 5.06 20.4 2.45"
				/>
				<rect
					id="learning_path_3"
					className="cls-1"
					x="4.44"
					y="11.83"
					width="10.9"
					height="5.45"
					transform="translate(8.96 -3.02) rotate(31.18)"
				/>
				<rect
					id="learning_path_2"
					className="cls-1"
					x="8.18"
					y="10.91"
					width="10.9"
					height="5.45"
					transform="translate(-5.09 18.24) rotate(-58.82)"
				/>
				<rect
					id="learning_path_1"
					className="cls-1"
					x=".7"
					y="12.75"
					width="10.9"
					height="5.45"
					transform="translate(-10.27 12.73) rotate(-58.82)"
				/>
			</g>
		</g>
	</SvgIcon>
);
export const NavbarIcon = (
	<SvgIcon sx={styles.icons}>
		{/* Generic frame used by multiple navbar button states. */}
		<g id="Calque_1-2">
			<polygon
				className="nav-icon-cls-1"
				points="375 0 375 80 0 80 0 0 62 0 79.01 8 295.99 8 313 0 375 0"
			/>
			<polygon
				className="nav-icon-cls-2"
				points="375 5 375 85 0 85 0 5 62 5 79.01 13 295.99 13 313 5 375 5"
			/>
		</g>
	</SvgIcon>
);

/**
 * ICONS
 */

// Semantic icons exposed as React components so callers can style through SVGProps.

export const ConferenceIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 157.66 134.1" {...props}>
		<defs>
			<style>{'.Conference-1{fill:#fff}'}</style>
		</defs>
		<g id="Conference">
			<path
				className="Conference-1"
				d="M157.63 43.11h.03v1.64c0 18.18-11.66 33.64-27.91 39.32l7.35 32.7-.21.17-24.57-30.54H90.65c0-.21 0-.41-.01-.62h.02v-1.16c0-16.21-13.14-29.35-29.35-29.35-.3 0-.6.01-.9.02v-.02H30.34A41.95 41.95 0 0 1 29 44.75c0-.49 0-.97.03-1.46H29v-1.64C29 18.65 47.65 0 70.65 0c.43 0 .85.01 1.28.02V0h44.08c23 0 41.65 18.65 41.65 41.65 0 .49-.01.97-.03 1.46Z"
			/>
			<path
				className="Conference-1"
				d="M86.66 85.81c0-14.76-12.56-26.72-28.06-26.72-.29 0-.57 0-.86.01v-.02H28.05C12.56 59.08-.01 71.04-.01 85.8c0 .31 0 .62.02.93h-.02v1.05c0 11.67 7.85 21.58 18.8 25.22l-4.95 20.98.14.11 16.55-19.59H58.59c15.49 0 28.06-11.96 28.06-26.72 0-.31 0-.62-.02-.93h.02V85.8Z"
			/>
		</g>
	</svg>
);

export const VideoIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 102.22 120.61" {...props}>
		<path
			d="M0 0v75.61h38.31V95H0v25.61h102.22V95h-38.3V75.61h38.3V0H0Zm43.57 63.07-.12-.12-.15-48.79.12-.12 24.59 24.59-24.44 24.44Z"
			style={{
				fill: '#fff'
			}}
		/>
	</svg>
);

/**
 * AVATAR
 */
interface AvatarSvgProps extends React.SVGProps<SVGSVGElement> {
	userid?: number;
}

export const AvatarModelSvg = (props: AvatarSvgProps) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 200" {...props}>
		<defs>
			<linearGradient
				id="D\xE9grad\xE9_sans_nom_4"
				x1={68.48}
				y1={27.26}
				x2={75.4}
				y2={58.51}
				gradientUnits="userSpaceOnUse"
			>
				<stop offset={0} stopColor="#091135" />
				<stop offset={1} stopColor="#282828" />
			</linearGradient>
			<style>
				{
					'.cls-3{isolation:isolate;fill:#fff}.cls-6{fill:#d3e3eb}.cls-8{fill:#5c7784;mix-blend-mode:multiply;opacity:.46}'
				}
			</style>
		</defs>
		<g
			style={{
				isolation: 'isolate'
			}}
		>
			<g id="Layer_2">
				<g id="character">
					<ellipse
						id="shadow"
						cx={75.94}
						cy={178.01}
						rx={57.35}
						ry={10.03}
						style={{
							fill: '#282828',
							mixBlendMode: 'overlay',
							opacity: 0.45
						}}
					/>
					<g id="body">
						<path
							id="casque_arriere_blanc"
							className="cls-3"
							d="M85 59.07c1.24-1.5 4.81-6.23 4.12-12.08C88.06 37.9 77.3 30.8 67.61 32.55c-7.28 1.32-14.92 7.8-14.73 16.06.16 6.88 5.66 11.32 6.63 12.08L85 59.07Z"
						/>
						<path
							id="cou"
							className="cls-6"
							d="m88.83 62.61-.35-1.42a4.665 4.665 0 0 0-3.51-3.43c-2.22-.49-4.73-.88-7.48-1.05-6.73-.41-12.49.68-16.81 1.96a4.692 4.692 0 0 0-3.37 4.49v.48c3.52-1.03 7.9-1.97 12.96-2.36 7.54-.57 13.93.3 18.56 1.33Z"
						/>
						<path
							id="visiere_casque"
							d="M83.84 37.52c-2.11-.92-5.16-1.91-8.91-2.06-8.72-.35-15.02 4.13-17.09 5.75-.45 1.42-1.21 4.48-.44 8.25.85 4.17 3.1 6.87 4.12 7.96 3.36-1.32 8.69-2.92 15.32-2.8 3.72.07 6.92.66 9.43 1.33.83-1.18 2.32-3.66 2.5-7.07.36-6.45-4.25-10.73-4.94-11.34Z"
							style={{
								fill: '#000'
							}}
						/>
						<path
							id="light_casque"
							d="M84.21 38.94a50 50 0 0 1-7.37 2.26c-7.24 1.62-13.59 1.33-18.17.69 1.96-1.39 5.11-3.24 9.33-4.22 7.49-1.75 13.69.28 16.21 1.28Z"
							style={{
								fill: '#d7f1ff',
								mixBlendMode: 'screen',
								opacity: 0.21
							}}
						/>
						<path
							id="shadow_casque"
							className="cls-8"
							d="M87.94 49.45a62.44 62.44 0 0 1-7.07 1.96c-8.33 1.81-15.77 1.66-21.51.98.05.49.2 1.4.79 2.36.53.87 1.18 1.39 1.57 1.67 3.27-1.26 8.26-2.7 14.44-2.75 3.79-.03 7.06.48 9.62 1.08.44-.47 1.02-1.22 1.47-2.26.54-1.24.67-2.35.69-3.04Z"
						/>

						<path
							id="amr2"
							className="cls-3"
							d="M94.57 63.3s19.64 11.79 24.95 18.86c5.3 7.07-8.46 27.3-8.46 27.3l-13.34 1.18-3.14-47.34Z"
						/>
						<path
							id="arm1"
							className="cls-3"
							d="M53.43 64.03c-.68.23-2.43.31-3.42 1.11-.7.56-1.2 1.15-1.55 1.62-5.73 3.87-9.77 7.8-12.45 10.75-4.48 4.95-5.15 7.18-5.4 8.37-.92 4.34.85 8 2.92 12.28 0 0 1.64 3.39 9.31 13.55 4.13-.52 8.26-1.05 12.39-1.57l-6.78-19.59 6.63-11.79c-.82-5.03-.85-9.71-1.66-14.73Z"
						/>
						<path
							id="torso"
							className="cls-3"
							d="M105.1 114.21c-.27.38-.58.79-.91 1.22-2.42 3.12-6.48 7.44-12.65 10.76a39.42 39.42 0 0 1-10.8 3.93c-3.87.16-10.61-.1-18.07-3.34-4.82-2.09-8.4-4.75-10.8-6.87.22-2.35.41-4.78.56-7.3a24.499 24.499 0 0 0 .4-11.61c.04-3.65-.02-7.43-.18-11.34A229.42 229.42 0 0 0 50.3 65.1c7.68-2.92 20.25-6.29 34.96-3.73 3.36.59 6.45 1.02 9.23 1.97 2.62 6.45 5.22 14.57 7.19 23.44-.14.21-.28.42-.41.62.34 1.23.69 2.46 1.03 3.68.1.03.2.07.3.1.26 1.37.5 2.76.73 4.17.17 1.05.32 2.09.46 3.12.78 5.64 1.17 10.92 1.31 15.74Z"
						/>
						<path
							id="poche_avant"
							className="cls-6"
							d="M96.98 91.88c.3 1.36.57 2.81.79 4.32.57 3.97.7 7.61.59 10.8a35.519 35.519 0 0 1-5.5 5.5c-3.74 3-7.42 4.71-10.12 5.7-3.16-.89-6.94-2.23-11-4.32a58.318 58.318 0 0 1-8.05-5.01 65.525 65.525 0 0 1-1.18-15.13c2.66-1.49 6.19-3.06 10.51-4.03 10.81-2.41 19.86.52 23.96 2.16Z"
						/>
						<path
							id="leg2"
							className="cls-3"
							d="M52.73 108.67a2838.252 2838.252 0 0 1-10.9 67.96h25.63c2.26-9.39 4.43-19.09 6.48-29.07 1.49-7.26 2.86-14.4 4.13-21.41l-25.34-17.48Z"
						/>
						<path
							id="leg1"
							className="cls-3"
							d="M104.42 104.86c2.74 9.07 4.94 20.04 6.06 33.47.95 11.32.62 21.39-.2 29.76-.69-.1-5.47-.75-9.23 2.65-2.41 2.17-3.12 4.85-3.34 5.89h-5.36c.13-.59.62-3.17-.92-5.7-1.11-1.81-2.68-2.64-3.34-2.95 0-4.41-.22-9.21-.79-14.34a129.262 129.262 0 0 0-5.89-26.71c7.53-7.53 15.48-14.55 23.01-22.08Z"
						/>
						<path
							id="flag"
							className="cls-6"
							d="M45 68.5a14.011 14.011 0 0 1 5.74 4.57c-1.33 1.38-2.65 2.75-3.98 4.12-.69-.88-1.69-1.98-3.09-3.02-1.16-.86-2.26-1.44-3.17-1.84a11.372 11.372 0 0 1 4.49-3.83Z"
						/>
						<path
							id="visiere"
							className="cls-6"
							d="M88.38 43.09c-.31-.8-.68-1.53-1.07-2.19-1.22-2.07-2.61-3.41-3.08-3.83-.04-.04-.1-.07-.15-.1a25.639 25.639 0 0 0-9.13-2.11c-8.29-.33-14.54 3.58-17.47 5.87-.1.07-.17.17-.2.29a17.04 17.04 0 0 0-.46 8.54c.8 3.9 2.76 6.64 4.27 8.24.12.13.27.19.43.19.07 0 .15-.01.22-.04 4.64-1.83 9.49-2.76 14.4-2.76h.69c3.13.06 6.25.5 9.29 1.31.24.06.49-.03.63-.23 1.09-1.55 2.43-4.09 2.61-7.38.12-2.19-.31-4.14-.98-5.8Zm-.19 5.73c-.16 2.79-1.22 4.99-2.17 6.43-3.01-.76-6.09-1.18-9.17-1.24h-.71c-4.93 0-9.79.9-14.46 2.7a15.937 15.937 0 0 1-3.71-7.38c-.65-3.22-.17-5.98.38-7.78 2.86-2.21 8.78-5.83 16.55-5.51 2.95.12 5.84.78 8.62 1.98.99.9 4.99 4.95 4.67 10.8Z"
						/>
					</g>
					<path
						id={`avatar_custom_color_${props.userid}`}
						className="cls-3"
						d="M77.63 135.24c-.51 1.7-1.33 2.93-1.92 3.68a84.112 84.112 0 0 0-25.78-14.29c-.28-2.12-.39-5.44.88-9.13.43-1.24.95-2.32 1.47-3.24 5.43 2.1 12.34 5.55 19.15 11.34 2.5 2.12 4.65 4.28 6.48 6.33.19 1.04.4 3.01-.29 5.3Zm30.56-18.51c-.16-.95-.37-1.96-.65-3-.4-1.48-.86-2.83-1.34-4.03-.34-.84-.68-1.6-1.02-2.3-.11.14-.21.28-.32.42-.01.01-.02.03-.03.04-3.14 4.09-7.14 8.65-12.17 13.24-3.71 3.37-7.33 6.15-10.66 8.44-.02 1.08.06 2.55.49 4.23.5 1.94 1.29 3.43 1.92 4.42 4.33-1.89 9.41-4.53 14.73-8.25 3.75-2.63 6.93-5.31 9.57-7.81-.03-1.54-.16-3.36-.52-5.4ZM54.9 56.22c-1.1.21-2.67-2.24-3.14-4.42-.5-2.31.03-5.25 1.18-5.5 1.04-.23 2.47 1.81 3.04 3.53.9 2.72.14 6.16-1.08 6.39Zm67.47 31.13c.19.34.93 1.83.45 3.68-.57 2.16-2.37 3.1-2.66 3.24-2.54-.07-5.47-.31-8.69-.88-3.36-.59-6.32-1.4-8.83-2.26-.1-.03-.2-.07-.3-.1-.34-1.22-.69-2.45-1.03-3.68.13-.2.27-.41.41-.62 1.79-2.64 4.57-5.93 8.72-8.66 1.38-.91 2.72-1.63 3.98-2.21.26-.03 1.99-.23 3.39 1.03 1.05.95 1.27 2.14 1.32 2.51.43.12 2.21.69 3.24 2.5 1.49 2.58.1 5.27 0 5.45Zm-8.1 24.7c.58.98-1.03 3.2-2.8 4.13-1.06.56-2.21.67-3.32.54-.16-.95-.37-1.96-.65-3-.67-2.51-1.53-4.63-2.36-6.33-.11.14-.21.28-.32.42-.69-2.95-1.6-6.03-2.05-9.29 1.2-.05 3.71-.08 5.31.27 3.87.84 6.51 2.83 7.81 3.98-.54 1.52-1.08 3.04-1.62 4.57-.69.54-1.37 1.08-2.06 1.62-.34.88-.69 1.77-1.03 2.65.67-.12 2.6-.39 3.09.44ZM49.89 90.3c-.21.96-.94 1.46-1.1 1.56a59.418 59.418 0 0 1-8.71 3.62c-3.1 1.02-5.97 1.67-8.48 2.11-.3-.1-2.21-.78-3.08-2.84-.74-1.76-.21-3.34-.08-3.71-.12-.16-1.88-2.63-.77-5.39.77-1.94 2.45-2.76 2.85-2.94 0-.37.06-1.58.96-2.67 1.2-1.44 2.95-1.49 3.21-1.5 1.33.4 2.76.93 4.25 1.63 4.86 2.29 8.22 5.45 10.35 7.9.09.09.87 1.01.6 2.23Zm3.24 19.15c-.16 1.12-.39 2.16-.66 3.11-.29 1-.61 1.89-.94 2.67-.34.33-4.41 4.17-8.23 2.81-1.87-.67-3.78-2.64-3.35-3.69.37-.89 2.32-.89 3-.87-.46-.83-.93-1.66-1.4-2.48-.75-.44-1.51-.88-2.27-1.32l-2.25-4.29c1.28-1.35 3.63-3.5 7.17-5.04 3.29-1.43 6.23-1.75 8.05-1.8.21.67.43 1.48.62 2.4.46 2.24.75 5.17.26 8.5Zm13.85 49.06c-.47.43-4.46 4.02-9.72 2.94-5.43-1.11-7.68-6.27-7.96-6.92-2.7-6.49.56-16.01 7.52-18.12 3.63-1.11 7.74-.03 10.46 2.36 5.57 4.89 4.86 14.95-.3 19.74Zm38.4 1.42c-4.39.96-9.5-3.09-11.39-7.66-2.61-6.32.28-15.21 6.09-16.7 4.3-1.09 9.1 2.15 11.2 5.9 3.75 6.69.12 17.14-5.9 18.46Zm11.35 16.7H87.46l.59-8.65 22.2.1 5.59 2.26.89 6.29Zm-51.07 0H45.03c.69-1.92 1.38-3.83 2.06-5.75a20.005 20.005 0 0 1 17.68 0c.3 1.92.59 3.83.89 5.75Z"
					/>
					<path
						id="shadow_arm"
						className="cls-8"
						d="M107.83 92.62c-.54 5.69-1.09 11.39-1.63 17.08-.34-.84-.68-1.6-1.02-2.3-.11.14-.21.28-.32.42-.01.01-.02.03-.03.04-2.78-12.39-5.56-24.76-8.34-37.15 2.67 4.13 5.35 8.25 8.03 12.38-.2.81-.64 3.05.36 5.6.85 2.14 2.27 3.4 2.95 3.93Z"
					/>
				</g>
			</g>
		</g>
	</svg>
);

export const AvatarAccessoryAngelSvg = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 200" {...props}>
		<defs>
			<filter id="a" filterUnits="userSpaceOnUse">
				<feOffset />
				<feGaussianBlur result="blur" stdDeviation={1} />
				<feFlood floodColor="#ffe652" floodOpacity={0.75} />
				<feComposite in2="blur" operator="in" />
				<feComposite in="SourceGraphic" />
			</filter>
		</defs>
		<path
			d="M62.62 21.93c-9.61 1.21-17.18 3.99-16.9 6.21s8.29 3.05 17.91 1.84 17.17-3.99 16.89-6.21-8.29-3.05-17.9-1.85Zm.74 5.92c-8.52 1.07-15.55.86-15.72-.45-.16-1.31 6.51-3.92 15.04-4.99s15.64-.19 15.8 1.12c.16 1.31-6.61 3.25-15.12 4.32Z"
			style={{
				fill: '#edde2b',
				filter: 'url(#a)'
			}}
		/>
	</svg>
);

export const AvatarAccessoryCapeSvg = (props: SVGProps<SVGSVGElement>) => (
	<svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 200" {...props}>
		<defs>
			<style>{'.cape_path_2{fill:#b20808}'}</style>
		</defs>
		<g id="Accessory">
			<g id="cape">
				<path
					className="cape_path_2"
					d="M50.4 116.12c-.58 1.84-.82 3.58-.88 5.1-43.16 4.01-38.87-32.33-38.87-32.33 5.4.74 11.7-1.43 17.88-4.82-.4.43-.79.97-1.07 1.67-1.11 2.76.65 5.24.77 5.4-.13.36-.66 1.95.08 3.71.87 2.05 2.78 2.73 3.08 2.83.54-.09 1.09-.19 1.66-.31.07.16.15.33.23.49 0 0 .88 1.82 4.37 6.79-.31.3-.59.58-.83.84l2.25 4.29c.76.44 1.52.88 2.27 1.31.47.83.93 1.66 1.4 2.48-.68-.02-2.64-.01-3 .88-.43 1.05 1.48 3.01 3.35 3.69 2.84 1.01 5.83-.86 7.31-2.02ZM52.65 101.01c-.19-.91-.4-1.7-.61-2.37-.28.01-.58.02-.91.05-.79-2.29-1.58-4.57-2.38-6.86.28-.21.76-.68.93-1.44.2-.91-.18-1.65-.42-2l2.88-5.13c.14 1.98.25 3.99.34 6.05.17 4.04.22 7.93.17 11.7Z"
				/>
				<ellipse className="cape_path_2" cx={75.53} cy={61.07} rx={2.13} ry={1.81} />
				<path
					className="cape_path_2"
					d="M76.44 60.78s4.5-.2 5.62 2.1c0 0-5.62.64-5.92-1.05s.29-1.05.29-1.05Z"
				/>
				<path
					className="cape_path_2"
					d="M74.88 60.78c-.15.14-2.01 3.32-1.08 4.49 0 0 2.57-2.49 2.27-3.86s-1.19-.63-1.19-.63ZM74.5 59.91c-.2 0-18.41-.36-21.88 2.54s-.32 1.51-.32 1.51l22.19-4.06ZM76.09 59.9s14.19-1.39 18.23 3.49c0 0-17.94-3.63-18.23-3.49Z"
				/>
			</g>
		</g>
	</svg>
);

export const AvatarAccessoryDivingMaskSvg = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 200" {...props}>
		<defs>
			<style>
				{
					'.divingmask_path_3{fill:#d7f1ff;mix-blend-mode:screen;opacity:.21}.divingmask_path_6{fill:#39acc9}.divingmask_path_7{fill:#3aacc7}.divingmask_path_8{fill:#267784}.divingmask_path_10,.divingmask_path_9{fill:#5c7784}.divingmask_path_10{mix-blend-mode:multiply;opacity:.46}'
				}
			</style>
		</defs>
		<g
			style={{
				isolation: 'isolate'
			}}
		>
			<g id="Layer_2">
				<g id="Accessory">
					<g id="diving_mask">
						<path
							className="divingmask_path_7"
							d="M86.96 44.85c-.23-.64-.52-1.27-.85-1.88-.76-1.44-1.78-2.77-2.97-3.96L81.05 24.7l1.41-.2 1.49-.22.07.49 2.94 20.08ZM88.81 57.49l-.56.08-2.34.34-.17-1.16c.69-1.26 1.35-2.8 1.72-4.54.14-.62.24-1.28.29-1.95l1.06 7.23Z"
						/>
						<path
							d="M84.81 23.62a.53.53 0 0 1-.45.6l-.41.06-1.49.22-1.41.2-.42.06a.527.527 0 0 1-.6-.44l-.11-.79c-.04-.29.16-.56.45-.61l3.72-.54c.28-.04.54.15.59.42.01.01.01.02.01.03l.12.79Z"
							style={{
								fill: '#9af7fe'
							}}
						/>
						<g
							style={{
								mixBlendMode: 'multiply',
								opacity: 0.46
							}}
						>
							<path
								className="divingmask_path_9"
								d="m84.02 24.77 2.94 20.08c-.23-.64-.52-1.27-.85-1.88l-2.65-18.12.56-.08ZM88.81 57.49l-.56.08-.79-5.36c.14-.62.24-1.28.29-1.95l1.06 7.23Z"
							/>
							<path
								className="divingmask_path_9"
								d="M84.81 23.62a.53.53 0 0 1-.45.6l-.41.06.07.49-.56.08-.41.06a.51.51 0 0 1-.59-.41c-.01 0-.01-.02-.01-.03l-.12-.8c-.04-.28.16-.55.45-.6l1.9-.27s.01.02.01.03l.12.79Z"
							/>
						</g>
						<path
							className="divingmask_path_7"
							d="m88.82 57.63-.05.46s0 .03-.01.05a9.84 9.84 0 0 1-1.35 4.42c-.37.6-.79 1.16-1.26 1.65h-.01c-1.63 1.7-3.85 2.68-6.22 2.54-1.89-.12-3.6-.94-4.92-2.24h-.01c-1.05-1.03-1.86-2.36-2.33-3.87.77-.05 1.57-.42 2.34-.47.98 2.35 2.66 4.26 4.69 4.39 2.8.17 6.57-2.29 6.22-6.65-.07-.87.48-1.41.54-2.35v-.13l1.45-.21.56-.09h.02c.2.87.38 1.56.34 2.5Z"
						/>
						<rect
							className="divingmask_path_8"
							x={71.23}
							y={59.16}
							width={4.77}
							height={1.28}
							rx={0.38}
							ry={0.38}
							transform="rotate(-11.46 73.575 59.778)"
						/>
						<path
							className="divingmask_path_8"
							d="M77.63 56.32c.01.1.01.18 0 .27-.03.23-.16.42-.33.55-.35.67-.86 1.26-1.52 1.73-.62.44-1.35.77-2.16.93-.82.16-1.63.15-2.38-.01-.74-.18-1.42-.49-1.98-.96h-.02a.888.888 0 0 1-.5-.35.906.906 0 0 1-.13-.26c-.1-.39.07-.84.44-1.12.35-.25.78-.28 1.1-.11.13.05.23.14.32.27v.03c.77.63 1.77.94 2.77.73 1.01-.2 1.82-.87 2.27-1.75.01-.01.01-.02.02-.03.05-.11.11-.21.14-.33.21-.31.61-.48 1.04-.41.25.04.48.15.64.31.14.14.24.32.27.51ZM76.26 48.93c-.36 1.07-.95 1.99-1.69 2.68-.74.68-1.63 1.12-2.63 1.24-1.26.15-2.48-.25-3.51-1.03-.51-.39-.98-.87-1.37-1.44-.75-1.04-1.27-2.35-1.44-3.81-.45-3.83 1.65-7.22 4.69-7.58 3.04-.36 5.87 2.45 6.32 6.28.15 1.31.01 2.56-.37 3.66Z"
						/>
						<path
							className="divingmask_path_10"
							d="M76.26 48.93c-.36 1.07-.95 1.99-1.69 2.68-1.28-1.1-3.58-5.09-3.58-5.09-.09.87-1.68 3.76-2.56 5.3-.51-.39-.98-.87-1.37-1.44.85-1.63 2.62-5.04 2.58-5.36-.05-.43 1.37-.82 1.59-.96.22-.14 2.57 2.36 3.04 2.61.32.17 1.37 1.46 1.99 2.26Z"
						/>
						<path
							className="divingmask_path_6"
							d="M89.14 42.27A9.04 9.04 0 0 1 87.63 48c-1.47 2.2-3.91 3.92-6.78 3.96-3.17.04-5.58-.96-7.32-2.87-1.1-1.21-1.91-2.7-2.24-4.38-.23-.02-.48 0-.72.01h-.06a8.87 8.87 0 0 1-1.54 4.72c-1.49 2.2-3.93 3.74-6.78 3.96s-5.51-.92-7.32-2.87a8.978 8.978 0 0 1-2.37-5.43c-.36-4.63 2.85-8.72 7.31-9.56l20.66-1.59c4.53.15 8.32 3.7 8.67 8.33Z"
						/>
						<path
							d="M87.47 42.42c.14 1.88-.39 3.83-1.37 5.28-1.32 1.96-2.89 2.7-5.43 2.9s-5.13-.44-6.73-2.17c-.59-.63-1.09-1.63-1.46-2.64-.25-.67-.44-1.36-.55-1.96-.21-.02-1.9.15-2.11.16h-.06c-.05 1.55-.78 3.7-1.61 4.92-.01.01-.02.02-.02.03a7.31 7.31 0 0 1-2.81 2.43c-.92.45-1.98.73-3.11.82-2.54.2-4.48-.62-6.08-2.35-1.19-1.29-1.68-2.98-1.83-4.86-.32-4.11 2.79-7.64 6.75-8.39l18.37-1.41c4.03.13 7.74 3.14 8.06 7.25Z"
							style={{
								fill: '#a4efed'
							}}
						/>
						<path
							className="divingmask_path_3"
							d="m70.01 35.9-4.7 15.47c-.92.45-1.98.73-3.11.82-2.54.2-4.48-.62-6.08-2.35-1.19-1.29-1.68-2.98-1.83-4.86-.32-4.11 2.79-7.64 6.75-8.39l8.97-.69ZM75.61 35.47l-3.14 10.32c-.25-.67-.44-1.36-.55-1.96-.21-.02-1.9.15-2.11.16h-.06c-.05 1.55-.78 3.7-1.61 4.92-.01.01-.02.02-.02.03l3.99-13.21 3.49-.27Z"
						/>
						<path
							className="divingmask_path_6"
							d="M48.88 49.18h6.39v2.28h-6.39c-.36 0-.65-.29-.65-.65v-.98c0-.36.29-.65.65-.65Z"
							transform="rotate(-34.86 51.75 50.328)"
						/>
						<path
							className="divingmask_path_10"
							d="M77.63 56.32c.01.1.01.18 0 .27-.03.23-.16.42-.33.55-.35.67-.86 1.26-1.52 1.73-.62.44-1.35.77-2.16.93-.82.16-1.63.15-2.38-.01-.74-.18-1.42-.49-1.98-.96.36.16 5.43 2.36 8.1-3.02.14.14.24.32.27.51ZM88.48 55.13l-.58.09c.06.31.23 1.38.26 2.71C85.6 70.1 75.42 64.68 75 64.51c1.32 1.3 3.03 2.12 4.92 2.24 2.37.14 4.59-.84 6.22-2.53h.01c.47-.5.89-1.06 1.26-1.66a9.892 9.892 0 0 0 1.36-4.47l.05-.46c.04-.94-.14-1.63-.34-2.5Z"
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
);
export const AvatarAccessoryTieSvg = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 200" {...props}>
		<defs>
			<style>
				{
					'.tie_path_2{fill:#0d87b7}.tie_path_4{fill:none;stroke:#5c7784;stroke-linecap:round;stroke-miterlimit:10;stroke-width:.25px}.tie_path_5{fill:#5c7784;mix-blend-mode:multiply;opacity:.46}'
				}
			</style>
		</defs>
		<g
			style={{
				isolation: 'isolate'
			}}
		>
			<g id="Layer_2">
				<g id="Accessory">
					<g id="tie">
						<path
							className="tie_path_5"
							d="M78.29 63.8c.03.11 8.66 12.57 9.64 19.32l-6.33 6.47-7.69-7.84s3.08-14.23 2.18-17.36c-.9-3.13 2.2-.59 2.2-.59Z"
						/>
						<path
							className="tie_path_2"
							d="m88.51 82.63-6.32 6.46-7.69-7.83s2.17-10.02 2.33-15.1c.04-.98-.01-1.77-.15-2.27-.9-3.13 2.2-.58 2.2-.58 0 .03.4.61 1.03 1.59 2.33 3.58 7.84 12.42 8.6 17.73Z"
						/>
						<path
							className="tie_path_5"
							d="M79.91 64.9c-.47.81-1.35 1.36-2.36 1.36-.25 0-.49-.03-.72-.1.04-.98-.01-1.77-.15-2.27-.9-3.13 2.2-.58 2.2-.58 0 .03.4.61 1.03 1.59Z"
						/>
						<circle className="tie_path_2" cx={77.23} cy={62.83} r={2.74} />
						<path className="tie_path_4" d="M78.37 64.66s.39-3.03-2.12-3.88" />
						<path className="tie_path_4" d="M78.07 62.49c.23-.48.33-1.55.32-1.71" />
					</g>
				</g>
			</g>
		</g>
	</svg>
);
export const AvatarAccessoryBagSvg = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 200" {...props}>
		<defs>
			<style>
				{
					'.cls-2{fill:#282828}.cls-2,.cls-3,.cls-4{isolation:isolate}.cls-7{fill:#d0c5bf}.cls-4{fill:#818586}.cls-8{fill:#051039}.cls-10{fill:red}'
				}
			</style>
		</defs>
		<g className="cls-3">
			<g id="Layer_2">
				<g id="Accessory">
					<g id="bag">
						<path
							id="bag_path_16"
							className="cls-2"
							d="M55.92 62.03c1.58.36 3.3.86 5.11 1.57 5.49 2.17 9.44 5.35 11.98 7.86l-3.54 4.32c-2.77-1.83-5.72-3.67-8.84-5.5a195.58 195.58 0 0 0-10.8-5.89c.35-.46 1.17-1.38 2.55-1.96 1.57-.66 2.97-.49 3.54-.39Z"
						/>
						<path
							id="bag_path_15"
							className="cls-2"
							d="M85.63 68.27c.88-2.28 1.77-4.57 2.65-6.85.52-.19 1.45-.44 2.58-.29 2.19.28 3.46 1.83 3.76 2.21-.96 2.16-1.92 4.32-2.87 6.48-2.04-.52-4.08-1.03-6.11-1.55Z"
						/>
						<path
							id="bag_path_14"
							className="cls-2"
							d="M52.19 105.25a58.15 58.15 0 0 1 4.71-5.11c4.59-4.4 9.26-7.39 13.16-9.43-.79-1.51-1.57-3.01-2.36-4.52-1.75.5-3.77 1.24-5.89 2.36-4.74 2.49-7.91 5.72-9.82 8.05-.23 1.1-.41 2.5-.39 4.12.02 1.81.29 3.35.59 4.52Z"
						/>
						<path
							id="bag_path_13"
							className="cls-2"
							d="M90.93 84.62c1.63.43 3.76 1.18 6.04 2.5 2.96 1.72 4.99 3.75 6.26 5.23a14.515 14.515 0 0 1 .66 8.92 30.11 30.11 0 0 0-7.22-7.73 30.406 30.406 0 0 0-6.63-3.76c.29-1.72.59-3.44.88-5.16Z"
						/>
						<path
							id="bag_path_12"
							className="cls-2"
							d="M88.72 65.03 65.44 66.8c-.62.41-1.49 1.1-2.21 2.21-1.49 2.29-1.28 4.69-1.18 5.45.98 6.14 1.96 12.28 2.95 18.42.07.45.31 1.51 1.18 2.5.82.94 1.78 1.33 2.21 1.47 8.02-.44 16.04-.88 24.06-1.33a4.41 4.41 0 0 0 1.77-1.38c.7-.92.85-1.86.88-2.26-1.34-8.58-2.68-17.15-4.03-25.73-.79-.38-1.57-.75-2.36-1.13Z"
						/>
						<g id="bag_path_11">
							<g className="cls-3">
								<path
									className="cls-7"
									d="M94.22 72.92c-.05 3.58-2.07 6.45-4.51 6.42s-4.38-2.96-4.33-6.54c.05-3.58 2.07-6.45 4.51-6.42 2.44.03 4.38 2.96 4.33 6.54Z"
								/>
								<path
									className="cls-7"
									d="M93.86 91.43a3.094 3.094 0 0 1-2.44 2.37c-1.27.23-2.57-.37-3.22-1.51l-1.86-12.85-.12-.84-.84-5.81 6.08.63.66 4.94c.04.33.09.65.13.98.54 4.03 1.07 8.06 1.61 12.09Z"
								/>
								<path
									className="cls-7"
									d="m89.89 66.38-21.95 1.18-.2 14.57 2.55 12.75 21.13-1.08-1.07-11.35-.46-16.07z"
								/>
							</g>
							<path
								className="cls-4"
								d="M73.09 74c-.05 3.58-2.07 6.45-4.51 6.42-2.44-.03-4.38-2.96-4.33-6.54.05-3.58 2.07-6.45 4.51-6.42s4.38 2.96 4.33 6.54Z"
							/>
							<path
								className="cls-4"
								d="m64.25 73.88 2.82 19.49c.65 1.14 1.95 1.75 3.22 1.51a3.081 3.081 0 0 0 2.44-2.37l-2.4-18.01-6.08-.63Z"
							/>
						</g>
						<path
							id="bag_path_10"
							d="M75.46 80.58c0 .69-.41 1.24-.92 1.24s-.92-.56-.92-1.24.41-1.24.92-1.24.92.56.92 1.24Z"
							style={{
								fill: '#ee332d',
								isolation: 'isolate'
							}}
						/>
						<path
							id="bag_path_9"
							d="M75.91 84.62c0 .69-.41 1.24-.92 1.24s-.92-.56-.92-1.24.41-1.24.92-1.24.92.56.92 1.24Z"
							style={{
								fill: '#7ad6ff'
							}}
						/>
						<path
							id="bag_path_7"
							className="cls-4"
							d="m72 71.66 6.54-.44s.43.26.45.74c.01.33-.16.64-.45.81-2 .25-4.01.49-6.01.74L72 71.67Z"
						/>
						<path
							id="bag_path_6"
							className="cls-2"
							d="m91.42 86.88-7.31.34c.1.67.2 1.34.29 2.01 2.42-.15 4.85-.29 7.27-.44-.08-.64-.17-1.28-.25-1.92Z"
						/>
						<g id="bag_path_5">
							<path
								className="cls-10"
								d="M85.7 85.33c.09 0 .16.02.23.03h.1c.05 0 .1.02.16.02.13 0 .27.01.4 0 .17 0 .34-.02.5-.04.12-.01.23-.03.35-.06.14-.03.27-.06.41-.1.19-.05.38-.13.56-.21.14-.06.27-.13.4-.21.12-.08.24-.16.35-.25.16-.13.3-.29.42-.45.05-.06.1-.12.13-.2 0-.02.01-.02.03-.02.01 0 0 .02 0 .03 0 .01 0 .03-.02.04-.06.09-.12.18-.18.26-.09.13-.2.25-.3.36l-.24.24c-.14.13-.29.23-.44.35-.09.07-.19.11-.28.17-.18.12-.37.2-.57.29-.17.07-.35.14-.53.19-.14.04-.28.08-.42.11-.13.03-.27.06-.41.08-.12.02-.24.03-.36.05h-.02c-.17 0-.34.02-.5.01-.05 0-.11-.02-.16-.02-.08 0-.15-.03-.23-.04-.06 0-.04-.03-.02-.05.03-.05.07-.09.11-.14.09-.09.17-.2.26-.29.06-.05.12-.11.18-.17.03-.03.07 0 .09-.01ZM86.62 80.28c-.08-.02-.17-.02-.25-.03-.07-.01-.14-.01-.21-.02-.25-.01-.5-.02-.75 0-.09 0-.19 0-.28.03-.11.03-.22.02-.33.07-.07.03-.14.03-.21.05-.2.06-.39.12-.58.2-.17.08-.35.15-.5.26-.12.08-.24.15-.35.24-.07.05-.13.11-.19.18-.05.06-.11.1-.15.16-.08.1-.17.2-.23.31 0 .02-.02.04-.03.03-.02 0 0-.03 0-.04.07-.12.15-.23.23-.34.08-.1.16-.19.24-.29.06-.08.14-.14.21-.21.08-.08.17-.15.26-.22.13-.1.26-.2.4-.28.18-.1.36-.21.55-.3.11-.05.21-.09.32-.14.14-.06.29-.1.43-.15.06-.02.14-.03.2-.05.16-.05.32-.08.49-.1.1-.02.2-.03.3-.04.13-.01.26 0 .39-.03.03 0 .06.01.09.01.11 0 .22 0 .33.02.07 0 .14.02.21.03.04 0 .04.03.02.05-.09.12-.18.23-.28.33-.09.09-.18.17-.27.26-.02.02-.03.03-.06.02Z"
							/>
							<path
								className="cls-8"
								d="M90.09 82.42v.12c0 .21.03.42.03.63v.18c0 .02 0 .04-.03.04-.08 0-.17.02-.25.01-.03 0-.04-.01-.04-.04 0-.12 0-.23-.01-.35 0-.17-.01-.34-.02-.51 0-.16-.02-.32-.02-.49v-.02c-.01-.09 0-.1.09-.1h.23c.02 0 .02.01.03.02.12.18.23.36.35.54l.12.18c.01.02.03.02.04 0 .03-.09.08-.16.13-.24.04-.09.09-.18.14-.27.04-.08.1-.16.13-.24.01-.03.04-.03.06-.03h.26c.02 0 .03 0 .03.03v.08c0 .14 0 .28.01.42 0 .16.01.32.02.49 0 .15.01.3.02.45 0 .04-.01.05-.05.05h-.27v-.21c0-.14-.01-.29-.02-.43v-.26c0-.01 0-.03-.01-.03-.02 0-.02.02-.03.03-.09.15-.17.31-.26.47-.05.09-.11.19-.16.28-.02.05-.04.02-.05 0-.04-.08-.1-.16-.15-.24-.1-.14-.2-.29-.29-.44-.02-.03-.04-.05-.06-.08ZM83.36 82.97c0-.06.04-.09.06-.13.05-.1.1-.21.16-.31.05-.09.09-.19.16-.27.01-.01 0-.03 0-.04.03-.04.05-.08.11-.07h.22c.03 0 .04 0 .04.04.02.18.02.37.03.55 0 .14.01.29.02.43 0 .15.01.3.01.44 0 .02 0 .04-.03.04h-.25c-.03 0-.04 0-.04-.03 0-.18-.01-.36-.02-.54 0-.12 0-.25-.03-.38-.04.05-.05.1-.08.15-.08.14-.16.28-.24.43-.04.07-.09.14-.12.22-.01.03-.03.04-.05 0-.07-.11-.15-.22-.22-.33-.05-.07-.09-.14-.14-.21-.05-.06-.09-.13-.14-.2h-.02c.02.18.02.37.03.55 0 .12 0 .24.02.36 0 .01.01.04-.02.04-.09 0-.18.03-.27.02-.02 0-.03 0-.03-.03 0-.04-.01-.07 0-.11 0-.13-.01-.26-.01-.39 0-.19-.01-.37-.02-.56 0-.12 0-.25-.02-.37 0-.02 0-.03.03-.04.07-.02.13 0 .2 0h.05c.07-.03.1.02.12.07.05.09.11.17.17.26.07.11.14.23.21.34.02.04.05.06.09.1ZM89.39 82.34s-.09 0-.14.01c-.02 0-.04 0-.05-.02-.01-.1-.08-.12-.16-.12-.2 0-.4 0-.6.04-.03 0-.06.03-.07.05-.02.05-.05.1-.02.16v.05c0 .14.01.28.01.41 0 .06 0 .14.06.19.03.03.08.04.12.04.13 0 .27 0 .4-.01.07 0 .15 0 .22-.01.07-.02.09-.04.09-.14v-.09c0-.06 0-.07-.07-.06-.12.02-.23 0-.35.02-.02 0-.03 0-.03-.02 0-.06-.02-.13-.01-.19 0-.02 0-.03.03-.03s.06-.01.09-.01c.13 0 .27-.01.4-.01h.21c.02 0 .03 0 .03.03 0 .16.02.32 0 .48 0 .16-.09.26-.25.3-.09.02-.17.03-.26.03-.18 0-.35.01-.53.02-.12 0-.23-.01-.33-.09a.334.334 0 0 1-.14-.24c-.01-.12-.01-.23-.02-.35-.01-.1 0-.21-.02-.31-.01-.14 0-.29.12-.4.07-.06.16-.1.26-.11.13-.02.27-.01.4-.02h.28c.09 0 .19 0 .28.05.1.05.14.13.16.23 0 .03 0 .06.01.09.02.05 0 .05-.04.05h-.11ZM85.96 83.57h-.35c-.02 0-.03-.02-.03-.03-.02-.07-.07-.12-.09-.2 0-.02-.02-.01-.03-.01-.17 0-.34 0-.51.01h-.21c-.03 0-.04 0-.04.04 0 .05-.03.09-.05.14-.01.03 0 .07-.03.09-.03.01-.07 0-.1 0h-.22c-.02 0-.04 0-.02-.03.05-.12.1-.25.14-.38.04-.13.09-.25.13-.38.05-.13.1-.26.15-.4.02-.07.05-.14.08-.21 0-.03.01-.05.02-.08.01-.04.04-.05.08-.05.12 0 .24 0 .36-.01.03 0 .05 0 .06.04.03.08.06.15.1.22.07.12.11.25.17.37.07.12.11.26.18.38.08.14.12.31.21.45v.03Zm-1.15-.51c.17 0 .34-.01.51-.02.03 0 .03-.02.02-.04-.05-.15-.14-.29-.19-.44-.03-.07-.05-.15-.1-.21-.08.23-.16.46-.23.7ZM87.66 82.42h-.05c-.05 0-.09 0-.11-.06-.02-.06-.07-.07-.13-.07-.15 0-.3 0-.46.01-.16 0-.23.11-.2.26v.02c0 .14.02.29 0 .43 0 .11.05.19.14.22.04.01.09 0 .13 0h.24c.07 0 .13-.01.2-.01.04 0 .1-.06.1-.11 0-.04.02-.06.07-.06h.24c.01 0 .03 0 .03.02.02.1 0 .2-.05.29-.05.1-.15.12-.25.14-.1.02-.2.01-.3.02-.15.01-.29.02-.44.02-.15 0-.28-.05-.36-.17-.05-.07-.06-.15-.07-.23-.01-.09 0-.18-.01-.26-.01-.09 0-.17-.01-.25-.02-.09 0-.18 0-.27 0-.03.02-.06.04-.1.07-.14.19-.19.33-.21.23-.03.45-.03.68-.03.1 0 .2.01.29.07.06.05.08.11.1.18.01.04 0 .09.02.13 0 .02 0 .03-.03.03-.06 0-.12.02-.17 0ZM82.11 82.66h-.04c-.04 0-.09.01-.1-.06 0-.06-.07-.07-.12-.07-.16 0-.31 0-.47.01-.05 0-.1.02-.14.04-.03.02-.05.05-.06.1-.01.15.01.3.01.45v.19c.01.13.11.16.23.15h.03c.13.01.27-.02.4-.01.08 0 .14-.04.15-.12 0-.04.03-.04.06-.04h.23c.05-.01.07 0 .06.06-.01.05 0 .09-.01.14 0 .08-.09.19-.17.21-.11.03-.21.05-.32.06-.18 0-.36.02-.53.02-.12 0-.23-.03-.32-.12-.05-.05-.07-.12-.09-.18-.03-.06-.02-.13-.02-.19 0-.16-.02-.32-.02-.48 0-.12-.01-.23.05-.34.06-.11.15-.16.27-.19.11-.02.23-.02.34-.03.13-.01.26 0 .39 0 .11 0 .22.01.3.09.06.05.08.12.1.19v.02c0 .11 0 .11-.11.12h-.1Z"
							/>
						</g>
						<path
							id="bag_path_4"
							className="cls-4"
							d="M63.29 64.19c-.48.43-.98.92-1.47 1.47a17.836 17.836 0 0 0-2.85 4.32 5.44 5.44 0 0 1-2.16-.59 5.482 5.482 0 0 1-2.06-1.87c.16-.67.54-1.86 1.47-3.04a7.877 7.877 0 0 1 2.85-2.26c.52.02 1.39.13 2.36.59.91.43 1.52 1 1.87 1.38Z"
						/>
						<path
							id="bag_path_3"
							className="cls-4"
							d="M63.09 95.6c-.11-.59-.29-1.27-.59-1.99-.91-2.15-2.41-3.46-3.31-4.13-.51.19-1.13.46-1.77.88a8.886 8.886 0 0 0-2.36 2.28c.27.73.68 1.63 1.33 2.58a11.49 11.49 0 0 0 3.17 3.09c.59-.24 1.4-.65 2.21-1.33.58-.49 1.01-.98 1.33-1.4Z"
						/>
						<path
							id="bag_path_2"
							className="cls-4"
							d="M100.44 97.07c.36-.49.75-1.16 1.03-1.99.73-2.12.32-4.02.07-4.86-.1-.31-.36-1.01-1.03-1.62a3.59 3.59 0 0 0-1.84-.88c-.25.72-.49 1.56-.66 2.5-.33 1.86-.29 3.48-.15 4.71.12.3.42.94 1.1 1.47.58.45 1.16.6 1.47.66Z"
						/>
						<path
							id="bag_path_1"
							d="m92.25 79.34-5.91.1-14.92.65c.12 0 .22-.47.36-.75.04-.1 8.42-.47 14.44-.74 2.96-.12 5.35-.22 5.9-.24.04.33.09.65.13.98Z"
							style={{
								mixBlendMode: 'overlay',
								opacity: 0.5
							}}
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
);
export const AvatarAccessoryBlackBeltSvg = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 200" {...props}>
		<defs>
			<style>
				{
					'.black_ninja{fill:#0f0f0f}.black_belt_01{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10}.black_belt_02{fill:#2b2b2b}.black_belt_03{mix-blend-mode:overlay;opacity:.6}.black_ninja_red{fill:#ee332d}'
				}
			</style>
		</defs>
		<g
			style={{
				isolation: 'isolate'
			}}
		>
			<g id="Layer_2">
				<g id="Accessory">
					<g id="black_belt">
						<path
							id="black_belt_path_10"
							d="M103.93 104.14c.03.16-.1.3-.23.23-1.09-.6-5.29-2.57-13.86-2.94-.68-.04-1.39-.06-2.13-.06-.78-.01-1.58-.01-2.42 0-.84.01-1.7.04-2.6.09-7.78.41-17.99 2.01-31.11 5.9-.23.07-.47-.14-.47-.42v-5.68c0-.29.16-.55.4-.62 2.54-.79 16.83-5.1 30.62-5.84 1.02-.06 2.05-.09 3.06-.1.43-.01.85-.01 1.27 0 1.25.01 2.49.06 3.71.14 4.76.35 9.14 1.34 12.54 3.34.12.07.21.21.24.37l.98 5.58Z"
							className="black_belt_02"
						/>
						<path
							id="black_belt_path_9"
							d="M85.29 101.38c-.84.01-1.7.04-2.6.09-2.6-2.71-1.39-5.41-.56-6.66 1.02-.06 2.05-.09 3.06-.1l.1 6.67Z"
							className="black_belt_03"
						/>
						<path
							id="black_belt_path_8"
							d="M89.84 101.43c-.68-.04-1.39-.06-2.13-.06l-1.25-6.66c1.25.01 2.49.06 3.71.14.69.76 2.23 3.07-.33 6.58Z"
							className="black_belt_03"
						/>
						<path
							id="black_belt_path_7"
							d="m97.49 110.43-3.3.63s-1.08-5.91-3.68-9.19c-.49-.64-1.05-1.18-1.68-1.54-.31-.2-.64-.35-.99-.45l1.72-1.74.02-.02s1.16.79 2.6 2.12c2.44 2.26 5.68 6.07 5.31 10.19Z"
							className="black_belt_02"
						/>
						<path
							id="black_belt_path_6"
							d="M84.93 99.98c-.81.39-1.57 1.06-2.27 1.9-3.03 3.63-4.93 10.38-4.93 10.38l-4.04-.16c-.46-4.91 3.39-9.03 6.47-11.5 1.96-1.58 3.61-2.48 3.61-2.48l1.16 1.86Z"
							className="black_belt_02"
						/>
						<path
							id="black_belt_path_5"
							d="M92.18 100.24c-.39.7-1.01 1.23-1.67 1.63-.49-.64-1.05-1.18-1.68-1.54l.73-2.19.02-.02s1.16.79 2.6 2.12Z"
							className="black_belt_03"
						/>
						<path
							id="black_belt_path_4"
							d="M84.93 99.98c-.81.39-1.57 1.06-2.27 1.9-.67-.24-1.69-.68-2.5-1.28 1.96-1.58 3.61-2.48 3.61-2.48l1.16 1.86Z"
							className="black_belt_03"
						/>
						<ellipse
							id="black_belt_path_3"
							cx={86.24}
							cy={97.64}
							className="black_belt_02"
							rx={4.68}
							ry={4.27}
						/>
						<path
							id="black_belt_path_2"
							d="M87.48 94.07c3.29 4.28.54 6.12-.85 7.28"
							className="black_belt_01"
						/>
						<path
							id="black_belt_path_1"
							d="M82.7 99.61s1.94-2.94 5.71-2.28"
							className="black_belt_01"
						/>
					</g>
					<g id="ninja">
						<path
							d="M54.55 42.29s-5.56 1.3-7.26-.34-5.12 0-5.12 0 .57 3.73.76 3.66 2.08-1.89 3.73-.95 6.38-.73 7.45-1.25.44-1.13.44-1.13Z"
							className="black_ninja"
						/>
						<path
							d="M54.73 42.29s-4.35-1.44-4.83-3.28-3.5-2.15-3.5-2.15-1.17 2.79-1.02 2.82 2.22-.42 2.95.91 4.67 2.18 5.62 2.27.77-.59.77-.59Z"
							className="black_ninja"
						/>
						<path
							d="M86.88 40.21c-4.1-.54-16.61-1.86-34.45 6.17.59-3.67 2.49-6.61 4.98-9.17 5-3 11.62-5.09 20.19-3.87 3.53 1.51 7.13 3.74 9.28 6.87Z"
							className="black_ninja_red"
						/>
						<path
							d="M86.65 39.69c-3.95-.48-18.97-1.15-34.22 6.31.57-3.27 1.99-6 4.39-8.28 4.82-2.67 13.09-5.15 21.35-4.07 3.4 1.35 6.39 3.26 8.47 6.05Z"
							className="black_ninja"
						/>
						<ellipse
							cx={73.08}
							cy={36.54}
							className="black_ninja_red"
							rx={3.44}
							ry={2.51}
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
);
export const AvatarAccessoryBobSvg = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 200" {...props}>
		<defs>
			<style>{'.bob_cls-3{fill:#ffff45;opacity:.5}.bob_cls-4{fill:#88c14c}'}</style>
		</defs>
		<g
			style={{
				isolation: 'isolate'
			}}
		>
			<g id="Layer_2">
				<g id="Accessory">
					<g id="bob_path_1">
						<path
							id="bob_path_1-2"
							className="bob_cls-4"
							d="M86.06 34.33c-1.15.88-2.3 1.68-3.46 2.41-1.01.63-2.02 1.21-3.03 1.74-.08.04-.15.08-.23.12-.01.01-.02.02-.04.03-.04.02-.08.04-.12.07-.03.02-.07.03-.11.05-.09.04-.18.09-.27.13-.14.07-.27.14-.4.2-.01.01-.02.01-.02.01-.04.02-.07.03-.1.05-.05.02-.09.04-.13.06-.05.03-.11.05-.16.08h-.01c-.05.03-.1.05-.15.07h-.01c-.06.04-.13.07-.19.09s-.01.01-.01.01h-.02c-.1.05-.19.09-.29.14-.01 0-.02.01-.03.01l-.54.24c-5.17 2.29-10.2 3.35-14.5 3.77-2.1.21-4.03.26-5.72.23-.09 0-.18 0-.26-.01-.18 0-.34 0-.51-.01-.16 0-.32 0-.47-.02h-.05c-.09 0-.17-.01-.25-.01h-.01c-.08-.01-.16-.01-.24-.01h-.01c-.09-.01-.18-.02-.27-.02h-.08c-.11 0-.21-.01-.31-.02h-.03c-.22-.01-.43-.03-.64-.05-1.43-.12-2.55-.29-3.26-.41-.59-.11-.91-.18-.91-.18 2.93-.5 4.9-6.59 4.9-6.59l.64-.13.2-.04.48-.1.22-.05 2.58-.53 1.02-.21.81-.17.07-.02h.01l.34-.07.16-.03h.03l.04-.02h.01l.24-.05.24-.05h.01l.23-.05h.01l.21-.04.1-.02h.03l.01-.01.54-.11h.01l.23-.05h.01l.63-.13.7-.15 3.5-.72 1.47-.31 1.97-.4.48-.1.59-.13h.08l.38-.09h.06v-.02l.18-.03h.01l.18-.04.19-.04h.01l.14-.03.08-.02h.03l.43-.09.18-.04.46-.09 3.47-.72.38-.08s.05.1.08.15c.22.31.67.61 1.25.88.35.17.75.32 1.17.47 2.31.8 5.37 1.3 5.37 1.3Z"
						/>
						<path
							id="bob_path_1-3"
							className="bob_cls-4"
							d="m79.63 35.51-12.3 2.08-10.82 1.83h-.01l-1.26.21-1.36.23.23-3.35v-.17l.07-.85v-.12l.04-.53v-.03l.01-.03.02-.28v-.19l.01-.06v-.15l.02-.05v-.23h.01l.02-.18v-.27l.06-.85.11-1.63.25-3.61c.03-.47.15-.91.36-1.31.06-.15.15-.3.24-.43.02-.04.05-.08.08-.11.09-.13.19-.25.3-.36l.01-.02h.01v-.02c.1-.1.19-.17.29-.26.1-.07.2-.15.31-.21h.01l.01-.01c.1-.07.21-.13.32-.18h.01c.12-.07.25-.13.39-.17.02-.01.03-.02.05-.02.15-.06.31-.1.47-.13h.01s.03-.01.05-.01l.22-.04h.01l.3-.05.1-.02.55-.09 1.2-.2.66-.11 1.85-.31.66-.12 1.77-.29.65-.11 1.85-.32h.06l.43-.08.13-.03h.03l.39-.06.08-.02.41-.07.13-.02.44-.07.11-.02.42-.07s.02-.01.02 0h.07s.01-.01.02-.01l.13-.03 1.18-.2c.23-.04.46-.06.68-.05.24.01.48.04.71.09 1.13.26 2.09 1.08 2.51 2.23l.35.96.2.55.09.25.36.99v.04l.1.24.19.52s0 .01.01.02l.73 2.01.67 1.85.05.13.06.17.78 2.17.04.09.05.16.04.09.47 1.3Z"
						/>
						<path
							id="bob_path_1-4"
							d="m80.69 33.03-1.66.84c-10.5 4.99-22.18 4.5-23.13 4.2-1.09-.34.02-.49.02-.49 9.09.18 17.42-3.3 22.33-5.88.01-.01.01-.02.02-.02.22.31.67.61 1.25.88.35.17.75.32 1.17.47Z"
							style={{
								fill: '#5c7784',
								mixBlendMode: 'multiply',
								opacity: 0.46
							}}
						/>
						<g id="bob_path_1-5">
							<path
								id="bob_path_1-6"
								className="bob_cls-3"
								d="M77.47 29.55c-.31.36-.77.59-1.29.59-.95 0-1.72-.77-1.72-1.72s.77-1.73 1.72-1.73c.09 0 .17.01.26.03v.04l.1.24.19.52s0 .01.01.02l.73 2.01Z"
							/>
							<circle
								id="bob_path_1-7"
								className="bob_cls-3"
								cx={65.24}
								cy={32.03}
								r={2.78}
							/>
							<circle
								id="bob_path_1-8"
								className="bob_cls-3"
								cx={71.38}
								cy={25.1}
								r={1.03}
							/>
							<circle
								id="bob_path_1-9"
								className="bob_cls-3"
								cx={69.84}
								cy={33.06}
								r={1.03}
							/>
							<circle
								id="bob_path_1-10"
								className="bob_cls-3"
								cx={61.53}
								cy={26.13}
								r={1.03}
							/>
							<circle
								id="bob_path_1-11"
								className="bob_cls-3"
								cx={56.01}
								cy={40.31}
								r={1.03}
							/>
							<circle
								id="bob_path_1-12"
								className="bob_cls-3"
								cx={64.03}
								cy={41.6}
								r={1.03}
							/>
							<circle
								id="bob_path_1-13"
								className="bob_cls-3"
								cx={71.89}
								cy={38.47}
								r={1.03}
							/>
							<circle
								id="bob_path_1-14"
								className="bob_cls-3"
								cx={78.06}
								cy={36.27}
								r={0.62}
							/>
							<circle
								id="bob_path_1-15"
								className="bob_cls-3"
								cx={70.98}
								cy={23.15}
								r={0.62}
							/>
							<circle
								id="bob_path_1-16"
								className="bob_cls-3"
								cx={56.24}
								cy={36.09}
								r={0.62}
							/>
							<circle
								id="bob_path_1-17"
								className="bob_cls-3"
								cx={59.07}
								cy={34.08}
								r={1.8}
							/>
							<path
								id="bob_path_1-18"
								className="bob_cls-3"
								d="M82.6 36.74c-1.01.63-2.02 1.21-3.03 1.74-.31-.32-.48-.74-.48-1.21 0-.99.8-1.8 1.8-1.8.8 0 1.49.53 1.71 1.27Z"
							/>
							<circle
								id="bob_path_1-19"
								className="bob_cls-3"
								cx={66.96}
								cy={26.13}
								r={1.8}
							/>
							<path
								id="bob_path_1-20"
								className="bob_cls-3"
								d="M57.98 27.93a3.009 3.009 0 0 1-3.49 2.96l.25-3.61c.03-.47.15-.91.36-1.31.06-.15.15-.3.24-.43.02-.04.05-.08.08-.11.09-.13.19-.25.3-.36l.01-.02h.01v-.02c1.28.34 2.23 1.51 2.23 2.9Z"
							/>
							<path
								id="bob_path_1-21"
								className="bob_cls-3"
								d="M62.24 43.57v.05c-2.1.21-4.03.26-5.72.23-.09 0-.18 0-.26-.01-.02-.09-.02-.18-.02-.27 0-1.65 1.34-3 3-3s3 1.35 3 3Z"
							/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
);
export const AvatarAccessoryBowTieSvg = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 200" {...props}>
		<defs>
			<style>
				{
					'.bow_cls-1{fill:#c67100},.bow_cls-4,.bow_cls-5{opacity:.2;mix-blend-mode:overlay}.bow_cls-4,.bow_cls-5{stroke-width:.38px;fill:none;opacity:.3;stroke:#000;stroke-linecap:round}.bow_cls-4{stroke-linejoin:round}.bow_cls-5{stroke-miterlimit:10}'
				}
			</style>
		</defs>
		<g
			style={{
				isolation: 'isolate'
			}}
		>
			<g id="Layer_2">
				<g id="Accessory">
					<g id="bowTie">
						<path
							id="bowTie_path_10"
							className="bow_cls-1"
							d="m80.18 59.11-1.71.88-1.85.95-9.14 4.71c-.22.12-.49-.05-.49-.3v-9.12c0-.6.58-1.03 1.16-.85l8.38 2.61 1.92.59 1.73.54Z"
						/>
						<path
							id="bowTie_path_9"
							className="bow_cls-1"
							d="M90.88 57.52c-.05 2.04-.04 7.22-.62 7.44-.36.14-4.17-2.34-6.9-4.16-.33-.22-.64-.43-.92-.61l-1.86-1.27 2.13-.44.83-.17 6.65-1.36c.36-.08.7.2.69.57Z"
						/>
						<path id="bowTie_path_8" className="bow_cls-5" d="m75.54 59.11-6.53-1.2" />
						<path id="bowTie_path_7" className="bow_cls-5" d="m75.29 60.53-6.51 2.53" />
						<path
							id="bowTie_path_6"
							className="bow_cls-4"
							d="M87.91 58.61c-.17.1-4.7.71-4.7.71l5.89 3.24"
						/>
						<path
							id="bowTie_path_5"
							className="bow_cls-3"
							d="m78.47 59.99-1.85.95c-.35-1.03-.24-2.18-.09-2.96l1.92.59.02 1.42Z"
						/>
						<path
							id="bowTie_path_4"
							className="bow_cls-3"
							d="M83.36 60.79c-.33-.21-.64-.42-.92-.6l.27-1.71.83-.17c.1.58.2 1.63-.18 2.48Z"
						/>
						<circle
							id="bowTie_path_3"
							className="bow_cls-1"
							cx={80.19}
							cy={59.11}
							r={3.2}
						/>
						<path
							id="bowTie_path_2"
							className="bow_cls-4"
							d="M80.86 55.99c1.93 2.65.58 5.2-.18 6.27"
						/>
						<path
							id="bowTie_path_1"
							d="M77.56 60.95c1.26-1.86 3.95-2.29 3.95-2.29"
							style={{
								strokeWidth: '.35px',
								strokeLinejoin: 'round',
								fill: 'none',
								opacity: 0.3,
								stroke: '#000',
								strokeLinecap: 'round',
								mixBlendMode: 'overlay'
							}}
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
);
export const AvatarAccessoryCapSvg = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 200" {...props}>
		<defs>
			<style>
				{
					'.cap_cls-2,.cap_cls-3{mix-blend-mode:multiply;opacity:.46}.cap_path_9{fill:#89d8f7}.cap_cls-2{fill:none;stroke:#5c7784;stroke-miterlimit:10;stroke-width:.25px}.cap_cls-3{fill:#5c7784}'
				}
			</style>
		</defs>
		<g
			style={{
				isolation: 'isolate'
			}}
		>
			<g id="Layer_2">
				<g id="Accessory">
					<g id="cap">
						<circle
							id="cap_path_12"
							cx={62.78}
							cy={25.61}
							r={0.79}
							style={{
								fill: '#d3b900'
							}}
						/>
						<path
							id="cap_path_11"
							className="cap_path_9"
							d="M55.41 40.12c-1.22 1.7-2.11 3.61-2.52 5.68-.09.2-.19.39-.28.57-.5.21-.88.95-1.07 1.91-.19-.01-3.51.51-5.05.24-.54-.09-.86-.28-.76-.62.4-1.32 8.76-9.44 8.76-9.64l.47.95.45.91Z"
						/>
						<path
							id="cap_path_10"
							className="cap_cls-3"
							d="M55.41 40.12c-1.22 1.7-2.11 3.61-2.52 5.68-.09.2-.19.39-.28.57-.5.21-.88.95-1.07 1.91-.19-.01-3.51.51-5.05.24.35-1.18 7.03-7.76 8.47-9.31l.45.91Z"
						/>
						<path
							id="cap_path_9"
							className="cap_path_9"
							d="M74.36 27.62c-2.18-1.65-4.82-2.7-7.53-2.74h-.15c-5.44 0-10.08 3.47-11.82 8.32-.47 1.32-.73 2.75-.73 4.23 0 1.05 0 3.35.24 4.33l.68-.69c3.06-2.89 7.02-5.79 12.29-6.95.58-.13 1.17-.22 1.77-.28 3.55-.4 7.32.16 10.23.71-.79-2.67-2.62-5.15-4.98-6.93Zm-1.81 2.86c-.47-.06-.94-.09-1.42-.08-1.74.04-3.26.59-4.42 1.49.03-.16.07-.3.09-.4.33-1.78 1.73-3.25 3.55-3.38 1.18-.08 2.34.29 3.21.97.63.49 1.11 1.13 1.33 1.88-.75-.24-1.54-.41-2.34-.48Z"
						/>
						<path
							id="cap_path_8"
							className="cap_path_9"
							d="M74.89 30.96c-1.19-.38-2.46-.58-3.76-.56-1.74.04-3.26.59-4.42 1.49.03-.16.07-.3.09-.4.33-1.78 1.73-3.25 3.55-3.38 2.04-.14 4.01 1.08 4.54 2.85Z"
						/>
						<path
							id="cap_path_7"
							d="M74.89 30.96c-1.19-.38-2.46-.58-3.76-.56-1.74.04-3.26.59-4.42 1.49.03-.16.07-.3.09-.4.33-1.78 1.73-3.25 3.55-3.38 2.04-.14 4.01 1.08 4.54 2.85Z"
							style={{
								mixBlendMode: 'multiply',
								opacity: 0.46,
								fill: '#33474f'
							}}
						/>
						<path
							id="cap_path_6"
							className="cap_cls-2"
							d="M75.59 33.47c-3.33-1-8.54.46-8.54.46-1.96-.13-.33-2.04-.33-2.04s3.43-2.59 8.45-.9"
						/>
						<circle
							id="cap_path_5"
							className="cap_cls-2"
							cx={67.87}
							cy={32.6}
							r={0.34}
						/>
						<circle
							id="cap_path_4"
							className="cap_cls-2"
							cx={70.49}
							cy={31.97}
							r={0.34}
						/>
						<circle
							id="cap_path_3"
							className="cap_cls-2"
							cx={73.74}
							cy={31.89}
							r={0.34}
						/>
						<path
							id="cap_path_2"
							className="cap_cls-3"
							d="M79.34 34.55c-2.91-.55-6.68-1.11-10.23-.71 1.48-1.17 2.59-2.3 3.44-3.36.39-.48.72-.95 1.01-1.4.33-.52.59-1.01.8-1.46 2.36 1.78 4.19 4.26 4.98 6.93Z"
						/>
						<path
							id="cap_path_1"
							d="M66.83 24.88c-.51 2.31-7.57 6.14-11.97 8.32 1.74-4.85 6.38-8.32 11.82-8.32h.15Z"
							style={{
								fill: '#d7f1ff',
								mixBlendMode: 'screen',
								opacity: 0.21
							}}
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
);
export const AvatarAccessoryHatSvg = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 200" {...props}>
		<path d="m69.76 32.62-9.65 2.6-.22-.81-.46-1.7-4.61-17.13 9.64-2.6 4.62 17.13.46 1.7.22.81z" />
		<path
			style={{
				fill: '#fff'
			}}
			d="m69.54 31.81-9.65 2.6-.46-1.7 9.65-2.6.46 1.7z"
		/>
		<path d="m53.197 36.013 22.921-6.18.458 1.698-22.921 6.18z" />
	</svg>
);
export const AvatarAccessoryLeafSvg = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 200" {...props}>
		<defs>
			<style>
				{
					'.cls-1{mix-blend-mode:overlay;opacity:.3}.cls-4{fill:#35912d}.cls-5{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:.26px}'
				}
			</style>
		</defs>
		<g
			style={{
				isolation: 'isolate'
			}}
		>
			<g id="Layer_2">
				<g id="Accessory">
					<g id="leaf">
						<path
							id="leaf_path_6"
							className="cls-4"
							d="M68.4 32.42c-.32.03-.65.08-.97.14-.4.07-.8.16-1.2.26l-1.18-5.4-.6-2.77v-.03l.22-.05c.01-.01.02-.01.03-.01l1.81-.39.08-.02.02.09.67 3.06 1.12 5.12Z"
						/>
						<path
							id="leaf_path_5"
							className="cls-1"
							d="M67.28 27.3c-.75-.08-1.19-.43-1.19-.43-.04.22-.52.41-1.04.55l-.6-2.77c.06-.03.14-.05.22-.08.01-.01.02-.01.03-.01l1.81-.39.1.07.67 3.06Z"
						/>
						<path
							id="leaf_path_4"
							className="cls-4"
							d="M64.55 25.12s-.18-5.45 9.5-5.84c9.68-.39 9.21-.98 9.21-.98s-10.83 12.02-18.71 6.81Z"
						/>
						<path
							id="leaf_path_3"
							className="cls-4"
							d="M67.5 24.96s-1.94 3.53-8.24.12c-6.3-3.41-6.22-2.85-6.22-2.85s11.42-3.55 14.46 2.73Z"
						/>
						<path
							id="leaf_path_2"
							className="cls-1"
							d="M65.86 24.75c-.04-.24-.7-.52-.7-.52.2-.17.45-.83.45-.83s.25.53.44.58l-.2.77Z"
						/>
						<g id="leaf_path_1" className="cls-1">
							<path
								className="cls-5"
								d="M70.6 22.16c-3.65.7-4.23 1.76-4.23 1.76M79.93 20.11s-2.58 1.13-7.7 1.79c-.6.08-1.14.17-1.63.26M64.21 24.07s-1.07-.49-2.49-.99M61.71 23.08c-1.7-.59-3.91-1.19-5.48-.97M68.49 22.44c-.28-.48 1.96-2.12 1.96-2.12M70.59 22.16s0 0 0 0"
							/>
							<path
								className="cls-5"
								d="M73.67 24.41s-1.64-2.56-3.07-2.24M74.03 21.64c1-.16 1.85-1.77 1.85-1.77M78.45 21.9s-1.24-1.03-2.19-.7M62.11 21.82c.06-.01 1.27 1.46 1.14 1.76M61.71 23.08c-.85.06-2.33 1.35-2.33 1.35M61.72 23.08s0 0 0 0M58.56 21.43s1.29.8 1.24 1.06"
							/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
);
export const AvatarAccessoryRedCapSvg = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 200" {...props}>
		<defs>
			<style>{'.cls-1{fill:#f4f4f4}'}</style>
		</defs>
		<g
			style={{
				isolation: 'isolate'
			}}
		>
			<g id="Layer_2">
				<g id="Accessory">
					<g id="red_cap_path_1">
						<path
							id="red_cap_path_5"
							className="cls-1"
							d="M67.43 25.31c0-.92-.71-1.65-1.61-1.74-.11-.88-.82-1.56-1.73-1.56-.16 0-.31.05-.46.09-.32-.36-.78-.6-1.31-.6-.6 0-1.11.32-1.43.78-.11-.02-.22-.07-.34-.07-.94 0-1.69.74-1.75 1.66-.75.2-1.32.86-1.32 1.68 0 .48.19.91.5 1.23a1.767 1.767 0 0 0 1.27 3c.05 0 .09-.02.13-.03.26.65.89 1.12 1.64 1.12.53 0 1-.25 1.32-.62h.07c.06 0 .11-.01.16-.02.3.23.66.39 1.06.39.96 0 1.74-.77 1.76-1.73.03-.04.07-.08.1-.12.78-.19 1.37-.85 1.37-1.69 0-.16-.05-.3-.09-.44.38-.32.63-.79.63-1.33Z"
						/>
						<path
							id="red_cap_path_4"
							d="M81.85 35.91c-5.33-2.11-11.51-2.35-17.93.55-4.61 2.09-8.3 5.25-10.73 8.87-.13-.92-.19-1.84-.19-2.75.03-8.07 5.2-15.07 12.66-16.4 2.33-.42 4.57-.19 6.63.55 3.48 1.23 6.46 3.91 8.58 7.4.36.57.68 1.17.98 1.78Z"
							style={{
								fill: '#d60d56'
							}}
						/>
						<path
							id="red_cap_path_3"
							d="M80.87 34.13c-.51-.03-17.31.01-17.31.01 10.09-2.18 10-5.44 8.73-7.41 3.48 1.23 6.46 3.91 8.58 7.4Z"
							style={{
								fill: '#5c7784',
								mixBlendMode: 'multiply',
								opacity: 0.46
							}}
						/>
						<path
							id="red_cap_path_2"
							className="cls-1"
							d="M82.42 36.31c-5.33-2.11-12.08-2.76-18.5.14-4.61 2.09-8.61 6.19-11.04 9.81-.09-.66-.35-1.66-.49-2.51-.08-.52.01-1.06.31-1.5 3.4-5.15 9.18-9.12 15.36-10.22 4.38-.78 9.18.02 12.96 1.88.43.21.74.59.9 1.04s.31.98.49 1.36Z"
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
);
export const AvatarAccessoryScarfSvg = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 200" {...props}>
		<defs>
			<style>
				{
					'.cls-1,.cls-2{opacity:.3;mix-blend-mode:overlay}.cls-2{fill:none;opacity:.2;stroke:#000;stroke-linecap:round;stroke-miterlimit:10}.cls-5{fill:#b577c9}'
				}
			</style>
		</defs>
		<g
			style={{
				isolation: 'isolate'
			}}
		>
			<g id="Layer_2">
				<g id="Accessory">
					<g id="scarf">
						<path
							id="scarf_path_11"
							className="cls-5"
							d="M54.82 64.33c-.33.1-.64.2-.95.31-.01-.01-.01-.03-.01-.04-.14.05-.32.09-.52.13-.02-.23-.06-.46-.1-.7-.67.23-2.43.31-3.42 1.11-.7.56-1.2 1.14-1.55 1.62-.99.67-1.93 1.35-2.82 2.01-.19-.1-.38-.19-.56-.27-.68.33-1.58.84-2.5 1.62-.92.79-1.56 1.59-1.99 2.21.14.06.29.13.44.21l-.02.02-.1.09a17.563 17.563 0 0 1-1.63-.33c-3.79-.97-8.08 5.9-10.92 5.84-2.43-.06-4.12-4.34-4.56-5.57a.967.967 0 0 1-.01-.65c1.29-3.61 9.61-8.05 15.49-7.19 6.06.89 15.35-3.44 15.35-3.44l.38 3.02Z"
						/>
						<path
							id="scarf_path_10"
							className="cls-1"
							d="M54.82 64.33c-.33.1-.64.2-.95.31-.01-.01-.01-.03-.01-.04-.14.05-.32.09-.52.13-.02-.23-.06-.46-.1-.7-.67.23-2.43.31-3.42 1.11-.7.56-1.2 1.14-1.55 1.62-1 .68-1.95 1.36-2.85 2.03-.21-.11-.41-.2-.61-.29-.68.33-1.58.84-2.5 1.62-.92.79-1.56 1.59-1.99 2.21.16.07.33.15.5.23l-.1.09a17.563 17.563 0 0 1-1.63-.33c-3.79-.97-8.08 5.9-10.92 5.84-2.43-.06-4.12-4.34-4.56-5.57a.967.967 0 0 1-.01-.65c1.29-3.61 9.61-8.05 15.49-7.19 6.06.89 15.35-3.44 15.35-3.44l.38 3.02Z"
						/>
						<g id="scarf_path_9">
							<rect
								className="cls-5"
								x={23.09}
								y={71.23}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(69.26 23.397 72.647)"
							/>
							<rect
								className="cls-5"
								x={23.7}
								y={72.06}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(62.85 23.997 73.468)"
							/>
							<rect
								className="cls-5"
								x={23.93}
								y={73.11}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(62.85 24.238 74.524)"
							/>
							<rect
								className="cls-5"
								x={24.76}
								y={73.81}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(54.14 25.06 75.23)"
							/>
							<rect
								className="cls-5"
								x={24.94}
								y={74.93}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(54.14 25.237 76.349)"
							/>
							<rect
								className="cls-5"
								x={25.81}
								y={75.39}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(32.63 26.118 76.812)"
							/>
							<rect
								className="cls-5"
								x={26.37}
								y={76.58}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(32.63 26.666 77.987)"
							/>
							<rect
								className="cls-5"
								x={27.48}
								y={76.65}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(16.2 27.776 78.057)"
							/>
						</g>
						<g id="scarf_path_8" className="cls-1">
							<rect
								x={23.09}
								y={71.23}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(69.26 23.397 72.647)"
							/>
							<rect
								x={23.7}
								y={72.06}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(62.85 23.997 73.468)"
							/>
							<rect
								x={23.93}
								y={73.11}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(62.85 24.238 74.524)"
							/>
							<rect
								x={24.76}
								y={73.81}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(54.14 25.06 75.23)"
							/>
							<rect
								x={24.94}
								y={74.93}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(54.14 25.237 76.349)"
							/>
							<rect
								x={25.81}
								y={75.39}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(32.63 26.118 76.812)"
							/>
							<rect
								x={26.37}
								y={76.58}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(32.63 26.666 77.987)"
							/>
							<rect
								x={27.48}
								y={76.65}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(16.2 27.776 78.057)"
							/>
						</g>
						<g id="scarf_path_7">
							<rect
								className="cls-5"
								x={96.04}
								y={80.42}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(-15.71 96.366 81.84)"
							/>
							<rect
								className="cls-5"
								x={96.94}
								y={79.94}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(-27.42 97.22 81.35)"
							/>
							<rect
								className="cls-5"
								x={93.85}
								y={80.56}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(-7.07 94.06 81.939)"
							/>
							<rect
								className="cls-5"
								x={92.49}
								y={81.02}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(-7.07 92.73 82.425)"
							/>
							<rect
								className="cls-5"
								x={91.26}
								y={80.96}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
							/>
							<rect
								className="cls-5"
								x={90.03}
								y={81.27}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(7.69 90.378 82.706)"
							/>
							<rect
								className="cls-5"
								x={88.95}
								y={80.93}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(17.91 89.269 82.381)"
							/>
							<rect
								className="cls-5"
								x={95.05}
								y={80.7}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(-15.71 95.368 82.109)"
							/>
						</g>
						<g id="scarf_path_6" className="cls-1">
							<rect
								x={96.04}
								y={80.42}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(-15.71 96.366 81.84)"
							/>
							<rect
								x={96.94}
								y={79.94}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(-27.42 97.22 81.35)"
							/>
							<rect
								x={93.85}
								y={80.56}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(-7.07 94.06 81.939)"
							/>
							<rect
								x={92.49}
								y={81.02}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(-7.07 92.73 82.425)"
							/>
							<rect
								x={91.26}
								y={80.96}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
							/>
							<rect
								x={90.03}
								y={81.27}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(7.69 90.378 82.706)"
							/>
							<rect
								x={88.95}
								y={80.93}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(17.91 89.269 82.381)"
							/>
							<rect
								x={95.05}
								y={80.7}
								width={0.6}
								height={2.83}
								rx={0.21}
								ry={0.21}
								transform="rotate(-15.71 95.368 82.109)"
							/>
						</g>
						<path
							id="scarf_path_5"
							className="cls-5"
							d="M97.54 80.49c.05.61-.35 1.16-.94 1.3-2.23.51-7.18 1.34-8.23.26-1.51-1.56-1.6-9.72-2.47-13.56-.15-.68-.32-1.22-.53-1.57a1.12 1.12 0 0 0-.29-.34l6.95-1.05s.24.39.61 1.08c.24.43.54.99.86 1.63 1.53 3.01 3.74 8.01 4.04 12.25Z"
						/>
						<path
							id="scarf_path_4"
							className="cls-1"
							d="M93.5 68.24c-1.8-.03-5.14-.04-7.6.25-.15-.68-.32-1.22-.53-1.57l7.27-.31c.24.43.54.99.86 1.63Z"
						/>
						<path
							id="scarf_path_3"
							className="cls-5"
							d="M94.72 66.95c4.52.06 2.41-1.23 2.93-5.35.41-3.23 2.25-6.33-1.56-7.24-2.41-.57-14.41 3.32-24.66 3.13-3.87-.07-18.17-.75-20.36-.91-1.07-.08-2.32.11-1.45 3.87s-2.54 4.69-.98 6.68 15.71.73 20.95 1.11 24.49-1.28 25.13-1.27Z"
						/>
						<path
							id="scarf_path_2"
							className="cls-2"
							d="M97.15 61.66c-.33.47-1.03 1.19-5.14 1.66"
						/>
						<path
							id="scarf_path_1"
							className="cls-2"
							d="M50.16 60.52s-.32 4.33 30.25 2.15"
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
);
export const AvatarAccessoryTshirtSvg = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 200" {...props}>
		<defs>
			<style>
				{'.tshirt_cls_1{fill:#9ac3e5}.tshirt_cls_6{fill:#051039}.tshirt_cls_7{fill:red}'}
			</style>
		</defs>
		<g
			style={{
				isolation: 'isolate'
			}}
		>
			<g id="Layer_2">
				<g id="Accessory">
					<g id="tshirt">
						<path
							id="tshirt_path_6"
							className="tshirt_cls_1"
							d="m110.5 71.71-18.06-9.55 5.39 22.88 12.67-13.33z"
						/>
						<path
							id="tshirt_path_5"
							style={{
								opacity: 0.3,
								fill: '#282828',
								mixBlendMode: 'overlay'
							}}
							d="m110.5 71.71-18.06-9.55 5.39 22.88 12.67-13.33z"
						/>
						<path
							id="tshirt_path_7"
							className="tshirt_cls_1"
							d="m89.51 61.17-.12-.03s.07-.02.12.03Z"
						/>
						<path
							id="tshirt_path_4"
							className="tshirt_cls_1"
							d="M104.88 107.01h-.02l-34.31.84c-6.04.14-12.07.29-18.11.44l-.65-45.37 3.15-1.22s12.08 6.85 22.54 5.84c10.46-1.01 9.38-1.97 11.02-4.28 1.13-1.6 1.13-2 1.01-2.09l2.94.77c1.38 2.74 2.72 5.66 3.98 8.75 5.39 13.31 7.65 25.85 8.45 36.32Z"
						/>
						<path
							id="tshirt_path_3"
							className="tshirt_cls_1"
							d="M39.32 69.99c.24-.05 12.47-7.08 12.47-7.08l3.4 19.77s-3.55 6.73-4.14 6.11-17.03-15.3-17.03-15.3l5.31-3.51Z"
						/>
						<g id="tshirt_path_2">
							<path
								className="tshirt_cls_7"
								d="M79.01 86.59c-.19.02-.38.06-.57.07-.39.03-.78.04-1.15 0-.11-.02-.13-.05-.05-.14.27-.29.54-.58.85-.84.1-.08.21-.18.29-.27.18-.21.4-.25.65-.22.29.02.6.01.89 0 .5 0 1.01-.04 1.52-.11.4-.06.8-.11 1.2-.2.75-.15 1.47-.36 2.18-.62.63-.23 1.22-.51 1.79-.83.54-.3 1.01-.65 1.44-1.02.17-.15.31-.31.44-.47.02-.02.03-.07.08-.05.05.02 0 .06-.02.08-.15.17-.3.35-.47.51-.25.25-.51.49-.79.72-.35.28-.73.56-1.13.81-.51.33-1.04.63-1.61.9-.73.35-1.48.66-2.25.92-.5.17-1 .3-1.5.44-.25.07-.5.11-.75.16-.35.08-.69.12-1.04.17ZM81.47 75.13c-.21-.03-.4-.06-.59-.09-.16-.02-.32-.05-.48-.07-.39-.04-.78-.09-1.17-.12-.22-.02-.44-.04-.65-.01h-.24c-.3 0-.59.03-.88.05-.47.03-.92.11-1.37.2-.43.08-.85.2-1.26.35-.52.18-1.02.42-1.49.7-.39.24-.76.52-1.09.84-.2.2-.38.41-.53.64-.02.03-.04.08-.08.06-.05-.03-.01-.06.01-.1a8.056 8.056 0 0 1 1.46-1.57 8.3 8.3 0 0 1 1.54-1c.3-.15.61-.3.93-.42.88-.35 1.8-.58 2.75-.72.31-.04.62-.09.93-.11.3-.02.6-.03.9-.04.43-.02.85 0 1.28.03.48.04.96.1 1.44.22.13.03.14.08.06.15-.42.37-.88.7-1.36 1.02-.04.02-.07.02-.1.02Z"
							/>
							<path
								className="tshirt_cls_6"
								d="M74.58 79.82c-.11.18-.23.36-.34.54-.25.39-.51.78-.77 1.18-.03.05-.06.07-.11 0-.32-.46-.64-.92-.96-1.39-.06-.09-.1-.19-.19-.27.03.69 0 1.37.02 2.05 0 .06-.03.07-.08.07-.19 0-.37.01-.56.03-.1.01-.11-.02-.11-.11v-3.15c0-.07.02-.09.09-.09.21 0 .42 0 .63-.01.09 0 .13.03.17.09.16.25.33.5.49.75.17.27.34.53.52.79.04.06.08.07.12 0 .2-.33.41-.65.61-.97.14-.22.28-.44.42-.65.02-.03.04-.04.08-.04.23 0 .46 0 .7-.01.09 0 .08.04.08.09v2.99c0 .08-.03.11-.12.11-.18 0-.37.01-.55.03-.09 0-.11-.02-.11-.09v-1.94h-.03ZM91.87 79.31c-.15.18-.29.37-.45.55-.21.26-.44.52-.65.78-.06.07-.09.05-.13 0-.17-.19-.34-.39-.51-.58-.19-.21-.38-.42-.55-.64-.01-.02-.03-.04-.06-.03-.03 0-.01.03-.01.05 0 .24.01.49.02.73v.78c0 .06-.02.08-.1.08-.19 0-.37.02-.56.03-.08 0-.1-.01-.1-.07 0-.83-.01-1.66-.02-2.48 0-.06.03-.07.1-.07h.66c.05 0 .09 0 .12.04.24.29.48.58.73.86.11.12.22.24.32.37.05.06.07.04.11 0 .34-.42.68-.84 1.02-1.25.03-.04.06-.05.11-.05.22 0 .44 0 .66-.01.07 0 .08.01.08.06 0 .78.02 1.57.03 2.35 0 .05-.02.06-.09.07-.19 0-.38.02-.57.03-.09 0-.11-.02-.11-.07 0-.4 0-.8-.01-1.2v-.31h-.03ZM87.32 79.68c.27 0 .53-.02.8-.03.08 0 .11 0 .11.07v.66c0 .18-.04.36-.2.52-.07.07-.17.12-.27.16-.19.07-.4.1-.61.11-.48.03-.96.05-1.44.08-.3.02-.57-.01-.8-.16a.645.645 0 0 1-.29-.44c-.06-.42-.01-.85-.03-1.28 0-.17.03-.34.12-.49.14-.22.38-.33.68-.37.57-.08 1.14-.05 1.72-.06.23 0 .46.02.67.09.26.08.36.24.41.43.02.07.07.16.02.21-.06.05-.2.02-.3.02-.14 0-.29 0-.44.01-.05 0-.07 0-.08-.05-.02-.13-.08-.17-.26-.19-.11-.01-.23 0-.34 0-.3 0-.6.01-.9.02-.12 0-.23.02-.33.05-.17.05-.2.18-.2.3v1.03c.01.23.15.34.47.32.43-.03.85-.04 1.28-.06.26-.01.33-.1.35-.26.03-.25.02-.25-.31-.23-.22 0-.43.01-.65.03-.08 0-.1-.02-.1-.08v-.32c0-.05.02-.07.09-.07.28 0 .56-.02.83-.03ZM79.59 81.59c-.29.02-.56.03-.83.05-.06 0-.07-.03-.08-.06-.06-.13-.13-.26-.18-.39-.02-.04-.04-.05-.08-.05-.57.03-1.14.06-1.7.08-.06 0-.09.03-.11.08-.05.13-.1.25-.15.37-.02.06-.06.1-.14.1-.22 0-.45.02-.67.04-.06 0-.09 0-.06-.07.19-.41.36-.83.56-1.23.3-.61.57-1.23.86-1.84.02-.04.05-.05.09-.05.32 0 .64 0 .96-.02.06 0 .08.03.1.06.35.72.7 1.44 1.06 2.15.13.26.26.51.4.78Zm-2.04-2.47s-.03.05-.03.06c-.19.45-.39.9-.58 1.35-.03.07 0 .08.07.07.37-.02.74-.03 1.1-.05.08 0 .1-.01.06-.09-.13-.26-.25-.53-.37-.8-.08-.18-.16-.35-.25-.56ZM69.3 82.17c-.27.02-.49.03-.71.04-.29 0-.56-.04-.77-.23-.19-.17-.26-.4-.27-.64-.01-.43 0-.85 0-1.28 0-.23-.01-.46.06-.68.11-.36.38-.54.73-.61.54-.1 1.08-.06 1.62-.06.23 0 .47.03.69.13.25.11.35.32.38.56v.05q.02.22-.21.22c-.17 0-.33 0-.5.01-.03 0-.07.02-.09-.04-.06-.22-.11-.27-.34-.27-.41 0-.83-.01-1.24.04-.26.03-.33.18-.33.37 0 .46-.02.92 0 1.38.02.28.1.37.4.37.38 0 .76-.03 1.14-.05.23-.01.33-.09.36-.31 0-.04.02-.05.05-.05.24 0 .48-.02.72-.03.04 0 .05.02.05.05-.03.28-.03.56-.31.77-.15.11-.32.16-.49.19-.33.06-.67.06-.95.08ZM82.54 81.43c-.32.02-.59.04-.85.05-.33 0-.63-.05-.82-.29a.734.734 0 0 1-.15-.35c-.06-.48-.02-.96-.03-1.44 0-.17.05-.35.18-.51.15-.19.38-.28.64-.32.51-.08 1.03-.05 1.54-.05.24 0 .49.02.72.1.23.08.36.23.4.42.06.27.06.28-.3.28-.11 0-.22 0-.32.01-.11.01-.16-.02-.17-.11 0-.07-.07-.11-.15-.12-.11-.02-.23-.04-.35-.03-.36.02-.72 0-1.08.04-.18.02-.29.11-.31.25-.05.39 0 .78-.02 1.17 0 .07.02.14.06.21.06.12.19.16.34.15l1.19-.06c.2-.01.3-.08.34-.24.01-.05.03-.06.08-.06.21 0 .42-.02.63-.03.04 0 .08-.02.08.04 0 .23-.03.45-.26.62-.14.1-.31.15-.49.18-.32.06-.64.04-.91.07Z"
							/>
						</g>
						<path
							id="tshirt_path_1"
							d="m104.86 107.01-34.31.84c1.23-1.87 2.72-4.21 4.36-6.85 1.35-2.19 2.79-4.59 4.25-7.11.05-.1.11-.19.16-.28 1.26-2.19 2.52-4.47 3.74-6.77.05-.11.11-.21.17-.32 1.11-2.13 2.18-4.28 3.17-6.4.03-.05.05-.11.08-.16a99.12 99.12 0 0 0 2.82-6.7c.83-2.22 1.49-4.35 1.94-6.31.4-1.8.63-3.47.63-4.94l.57.15c.76 1.49 1.49 3.03 2.21 4.63.61 1.33 1.2 2.71 1.77 4.12.27.66.53 1.32.78 1.98.09.22.17.43.25.64.74 1.96 1.42 3.9 2.02 5.82.03.05.04.1.05.15.67 2.09 1.26 4.14 1.79 6.17.03.1.06.21.08.31.57 2.22 1.06 4.4 1.49 6.53.01.09.03.18.05.27.46 2.35.84 4.64 1.14 6.86.35 2.55.6 5.02.79 7.37Z"
							style={{
								fill: '#282828',
								mixBlendMode: 'overlay',
								opacity: 0.2
							}}
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
);
export const AvatarAccessoryAlienSvg = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		id="Layer_2"
		viewBox="0 0 150 200"
		{...props}
	>
		<defs>
			<linearGradient
				id="D\xE9grad\xE9_sans_nom_4"
				x1={441.99}
				x2={445.28}
				y1={483.69}
				y2={483.69}
				gradientTransform="matrix(.93 0 0 .96 -351.74 -427.82)"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset={0} stopColor="#091135" />
				<stop offset={1} stopColor="#282828" />
			</linearGradient>
			<linearGradient
				xlinkHref="#D\xE9grad\xE9_sans_nom_4"
				id="D\xE9grad\xE9_sans_nom_4-2"
				x1={-1167.1}
				x2={-1163.8}
				y1={-193.54}
				y2={-193.54}
				gradientTransform="matrix(0 -.93 -.96 0 -107.18 -1049.61)"
			/>
			<style>
				{
					'.alien_path_04{fill:#fff}.alien_path_01{fill:#329e51}.alien_path_02{fill:#207235}.alien_path_03{fill:#4e778c}'
				}
			</style>
		</defs>
		<g id="Accessory">
			<g id="alien">
				<path
					d="m59.483 35.708 1.732-1a.781.781 0 0 1 1.066.286c.12.208.05.467-.157.587l-2.347 1.355a.427.427 0 0 1-.588-.157.781.781 0 0 1 .286-1.066Z"
					className="alien_path_03"
				/>
				<ellipse
					cx={60.68}
					cy={35.69}
					rx={1.53}
					ry={0.54}
					style={{
						fill: 'url(#D\xE9grad\xE9_sans_nom_4)'
					}}
					transform="rotate(-29.01 60.687 35.702)"
				/>
				<ellipse
					cx={54.48}
					cy={22.05}
					className="alien_path_01"
					rx={2.16}
					ry={1.85}
					transform="rotate(-25.88 54.478 22.048)"
				/>
				<path
					d="m61.75 35.76-1.37.66c-3.62-3.33-6.09-12.55-6.09-12.55l1.43-.69c2.3 8.98 5.94 12.49 6.03 12.58Z"
					className="alien_path_01"
				/>
				<path
					d="M56.43 21.11c.37.76.08 1.7-.65 2.28 2.3 8.82 5.88 12.28 5.97 12.37l-.55.27c-3.25-2.99-5.57-10.73-6.01-12.28a.31.31 0 0 1-.02-.08c.15-.12.28-.26.4-.42.4-.56.51-1.25.22-1.84-.4-.83-1.44-1.17-2.42-.85.09-.07.19-.13.3-.18 1.08-.52 2.31-.2 2.76.72Z"
					className="alien_path_02"
				/>
				<path
					d="M52.79 21.36s-.42.71-.03 1.42c0 0 .13.18.21-.03s-.4-.42.06-1.33c0 0-.05-.29-.23-.07Z"
					className="alien_path_04"
				/>
				<path
					d="m62.34 35.94-2.35 1.36c-.2.11-.46.04-.58-.16l-.24-.42a.418.418 0 0 1 .11-.55c-.03.08-.03.15 0 .21.15.26.73-.07 1.47-.48s1.32-.74 1.19-1.01c-.03-.07-.1-.11-.21-.13.19-.09.41-.01.52.18l.24.42c.12.2.05.46-.15.58ZM79.398 34.896l-2.566-.872a.427.427 0 0 1-.268-.546.781.781 0 0 1 .989-.487l1.894.643a.781.781 0 0 1 .487.99.427.427 0 0 1-.545.269Z"
					className="alien_path_03"
				/>
				<ellipse
					cx={78.28}
					cy={33.85}
					rx={0.54}
					ry={1.53}
					style={{
						fill: 'url(#D\xE9grad\xE9_sans_nom_4-2)'
					}}
					transform="rotate(-72.21 78.288 33.847)"
				/>
				<ellipse
					cx={81.71}
					cy={19.26}
					className="alien_path_01"
					rx={1.85}
					ry={2.16}
					transform="rotate(-75.34 81.72 19.254)"
				/>
				<path
					d="m77.25 34.12 1.47.38c2.9-3.98 3.53-13.5 3.53-13.5l-1.54-.4c-.51 9.25-3.39 13.41-3.46 13.51Z"
					className="alien_path_01"
				/>
				<path
					d="M79.62 18.71c-.21.81.25 1.68 1.08 2.11-.54 9.1-3.38 13.19-3.45 13.3l.59.15c2.61-3.57 3.38-11.61 3.51-13.21v-.08c-.17-.09-.33-.2-.47-.33-.5-.47-.74-1.12-.57-1.76.23-.89 1.18-1.43 2.21-1.3-.1-.05-.21-.09-.33-.12-1.16-.3-2.31.25-2.57 1.24Z"
					className="alien_path_02"
				/>
				<path
					d="M83.23 18.25s.55.62.31 1.39c0 0-.1.2-.21.01s.31-.49-.31-1.29c0 0-.01-.29.21-.11Z"
					className="alien_path_04"
				/>
				<path
					d="m76.7 34.42 2.57.88c.22.07.46-.05.54-.27l.15-.46a.42.42 0 0 0-.21-.52c.04.07.06.14.04.21-.1.28-.73.07-1.53-.19-.81-.26-1.43-.47-1.36-.75.02-.08.08-.13.18-.17-.2-.05-.4.07-.48.28l-.15.46c-.08.22.04.46.26.54Z"
					className="alien_path_03"
				/>
			</g>
		</g>
	</svg>
);
export const AvatarAccessoryBatSvg = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" id="Layer_2" viewBox="0 0 150 200" {...props}>
		<defs>
			<style>
				{
					'.bat_path_01{fill:#3d3d3d}.bat_path_02{fill:#303030}.bat_path_03{fill:#333}.bat_path_04{fill:#f9f20d}.bat_path_05{fill:#e5d907}.bat_path_06{fill:#353535}.bat_path_07{fill:#383838}.bat_path_08{fill:#fff878}'
				}
			</style>
		</defs>
		<g id="Accessory">
			<g id="bat">
				<path
					d="M60.21 36.53c-1.72 1.4-3.6 2.68-3.6 2.68-.13-.4 1.57-17.86 1.57-17.86s.06.15.16.41c.74 1.99 3.99 10.64 4.62 11.57.34.5-1.13 1.9-2.75 3.2Z"
					className="bat_path_07"
				/>
				<path
					d="M60.21 36.53c-.46-3.19-1.44-11.26-1.87-14.76.74 1.99 3.99 10.64 4.62 11.57.34.5-1.13 1.9-2.75 3.2Z"
					className="bat_path_02"
				/>
				<path
					d="m84.81 36.16-3.79-1.31-2.15-.75 3.76-11.19.09-.28c1.11 1.64 1.97 13.35 2.09 13.53Z"
					className="bat_path_01"
				/>
				<path
					d="m81.02 34.85-2.15-.75 3.76-11.19c.26 2.03-1.07 9-1.61 11.94Z"
					className="bat_path_02"
				/>
				<path
					d="M89.49 51.4s-.48 1.73-.81.39c-.34-1.35-9.89-3.64-9.89-3.64l-2.98 2.28-4.08-2.04s-10.22 3.15-15.32 5.64c-.45.23-.85.44-1.21.65-.77.44-1.31.85-1.52 1.2-.19.31-.44.37-.72.19l-.17-.13-.04-.03c-1.8-1.73-4.04-11.68 4.17-18.8 3.28-2.84 6.73-4.82 10.6-5.56 4.01-.77 8.46-.22 13.63 2.07 10.19 4.49 8.34 17.78 8.34 17.78Z"
					className="bat_path_01"
				/>
				<path d="m71.73 43.16-14.51-2.24 4.33 6.11 10.18-3.87z" className="bat_path_03" />
				<path
					d="m70.72 43.56-1.44.55-1.55.59-4.99 1.9-2.47-3.49-.84-1.19-.08-.11 7.24 1.11 4.13.64z"
					className="bat_path_04"
				/>
				<path
					d="m67.73 44.7-4.99 1.9-2.47-3.49-.84-1.19c1.55.87 3.18 3.87 8.3 2.78Z"
					className="bat_path_05"
				/>
				<path
					d="M86.7 41.27c-.49 0-8.62 2.32-8.62 2.32l8.09 2.11.53-4.43Z"
					className="bat_path_03"
				/>
				<path
					d="m85.6 42-.02.09-.54 3.3-2.7-.7-3.31-.86-.96-.25s1.81-.41 3.66-.81c1.82-.39 3.66-.78 3.87-.77Z"
					className="bat_path_04"
				/>
				<path
					d="m57.72 59.64-2.44-1.83-2.32-1.74-.17-.13-.04-.03 2.5-2.89.73-.84.43 1.85 1.31 5.61zM88.06 50.43c0 .11-2.23 7.48-2.17 7.4s3.75-5.46 3.6-6.43-1.43-.97-1.43-.97Z"
					className="bat_path_01"
				/>
				<path
					d="m85.58 42.09-.54 3.3-2.7-.7c1.17-.59 2.56-1.47 3.24-2.6Z"
					className="bat_path_05"
				/>
				<path
					d="m70.72 43.56-1.44.55c-.64-.36-1.56-.82-2.69-1.19l4.13.64ZM81.73 42.77l-2.7 1.06-.96-.25s1.81-.41 3.66-.81Z"
					className="bat_path_08"
				/>
				<path
					d="M53.63 51.62c-.03.54.23 2.42.38 2.94.27.96.54 1.89 1.27 3.26l-2.32-1.74-.17-.13-.04-.03c-1.8-1.73-4.04-11.68 4.17-18.8 3.28-2.84 6.73-4.82 10.6-5.56-4.92 2.55-13.24 7-13.89 20.07Z"
					className="bat_path_07"
				/>
				<path
					d="M75.71 49.82c-.03-.09-1.14-6.22-1.14-6.22l-2.84 4.11s-.07.66 0 .69l4.08 2.04-.11-.61ZM77.39 41.27l8.21-2.18s-2.2-2.89-3.52-3.17c0 0 2.32 2.75-4.69 5.35ZM71.7 41.67s-11.59-3.3-11.34-5.89c0 0-3.15 3.85-2.96 3.85s14.31 2.04 14.31 2.04Z"
					className="bat_path_03"
				/>
				<g id="cape">
					<path
						d="M50.5 116.14c-.38 1.21-.61 2.36-.75 3.44-1.34-.62-3.15-.97-5.14-.89-2.76.11-5.13 1-6.29 2.23-.14.12-.24.26-.34.39-.02-.01-.04-.01-.07-.01a3.57 3.57 0 0 0-.32-.51c-.97-1.37-3.08-2.6-5.68-3.2-2.53-.57-5.19-.02-6.67.74.03-.27 0-.2-.06-.62-.52-1.44-1.73-2.99-3.38-4.36-1.62-1.34-3.37-2.2-4.86-2.48-.02-1.21-.34-2.62-.95-4.06-.11-.26-.23-.52-.36-.78-.84-1.67-1.94-3.03-3.07-3.91 1.26-1.18 2.03-3.81 1.83-6.79-.19-2.81-1.18-5.19-2.49-6.31 5.14.32 10.98-1.78 16.73-4.93-.4.43-.79.97-1.07 1.67-1.11 2.76.65 5.24.77 5.4-.13.36-.66 1.95.08 3.71.87 2.05 2.78 2.73 3.08 2.83.54-.09 1.09-.19 1.66-.31.07.16.15.33.23.49 0 0 .42.88 1.85 3.07.62.97 1.45 2.19 2.52 3.72-.31.3-.59.58-.83.84l2.25 4.29c.76.44 1.52.88 2.27 1.31.47.83.93 1.66 1.4 2.48-.68-.02-2.64-.01-3 .88-.43 1.05 1.48 3.01 3.35 3.69 2.84 1.01 5.83-.86 7.31-2.02ZM52.75 101.03c-.19-.91-.4-1.7-.61-2.37-.28.01-.58.02-.91.05-.79-2.29-1.58-4.57-2.38-6.86.28-.21.76-.68.93-1.44.2-.91-.18-1.65-.42-2l2.88-5.13c.14 1.98.25 3.99.34 6.05.17 4.04.22 7.93.17 11.7ZM74.61 59.93c-.2 0-18.41-.36-21.88 2.54s-.32 1.51-.32 1.51l22.19-4.06ZM76.2 59.92s14.19-1.39 18.23 3.49c0 0-17.94-3.63-18.23-3.49Z"
						className="bat_path_01"
					/>
					<path
						d="M50.5 116.14c-.38 1.21-.61 2.36-.75 3.44-1.34-.62-3.15-.97-5.14-.89-2.76.11-5.13 1-6.29 2.23-.24-.05-.48-.09-.73-.13-.97-1.37-3.08-2.6-5.68-3.2-2.53-.57-5.19-.02-6.67.74.03-.27 0-.2-.06-.62-.52-1.44-1.73-2.99-3.38-4.36-1.62-1.34-3.37-2.2-4.86-2.48-.02-1.21-.34-2.62-.95-4.06 3.17-.33 11.26-1.47 19.24-5.86.62.97 1.45 2.19 2.52 3.72-.31.3-.59.58-.83.84l2.25 4.29c.76.44 1.52.88 2.27 1.31.47.83.93 1.66 1.4 2.48-.68-.02-2.64-.01-3 .88-.43 1.05 1.48 3.01 3.35 3.69 2.84 1.01 5.83-.86 7.31-2.02ZM52.75 101.03c-.19-.91-.4-1.7-.61-2.37-.28.01-.58.02-.91.05-.79-2.29-1.58-4.57-2.38-6.86.28-.21.76-.68.93-1.44.2-.91-.18-1.65-.42-2l2.88-5.13c.14 1.98.25 3.99.34 6.05.17 4.04.22 7.93.17 11.7Z"
						className="bat_path_06"
					/>
				</g>
			</g>
		</g>
	</svg>
);
export const AvatarAccessoryCookerSvg = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 200" {...props}>
		<defs>
			<style>{'.cooker_path_01{fill:#fff}.cooker_path_02{fill:#ededed}'}</style>
		</defs>
		<g
			style={{
				isolation: 'isolate'
			}}
		>
			<g id="Layer_2">
				<g id="Accessory">
					<g id="cook_hat">
						<path
							d="M78.06 33.88c-.38.04-.66.1-1.21.17-1.57.06-4.75.47-6.47.77-.54.07-1.08.15-1.59.25a29.294 29.294 0 0 0-3.92 1.05c-4.23 1.28-7.93 4.19-10.68 6.12.3-.6.64-1.18 1.02-1.74-.03.02-.05.04-.08.06l-2.06-6.63 8-2.19.73-.2c.82.7 1.62 1.35 2.37 1.95 1.09-.43 2.19-.74 3.29-.94 3.57-.64 7.28-.09 10.6 1.33Z"
							style={{
								fill: '#c1c1c1'
							}}
						/>
						<path
							d="M76.11 33.39c-.67.06-1.36.14-2.06.24-1.41.07-2.9.26-4.44.57-.49.07-.97.15-1.43.25-.71.16-1.39.34-2.04.55-.51.16-1.01.33-1.48.52-3.79 1.3-7.07 3.08-9.53 5.04l-2.07-6.67-.04-.27 8.23-2.55 12.87-3.99.12.25 1.87 6.06Z"
							className="cooker_path_01"
						/>
						<path
							d="m74.24 27.33-12.75 3.94-8.44 2.62-.04-.27-.4-2.46c-.05-.3-.12-.59-.21-.88l-5.36-15.82a6.188 6.188 0 0 1-.03-3.59c.31-1.04.88-1.97 1.66-2.73a6.22 6.22 0 0 1 2.45-1.44l9.32-2.88c3.28-1.01 6.76.82 7.77 4.1l4.68 16.44c.13.5.33.98.56 1.44l.64 1.28.13.25Z"
							className="cooker_path_01"
						/>
						<path
							d="M65.34 30.21h-.18c.06 0 .12-.02.17-.04v.04Z"
							className="cooker_path_02"
						/>
						<path
							d="M66.14 35c-.51.16-1.01.33-1.48.52-3.75 1.29-7 3.04-9.45 4.98-.03.02-.05.04-.08.06l-2.06-6.63v-.04l-.05-.27-.39-2.46c-.06-.3-.12-.58-.22-.87l-5.36-15.82a6.186 6.186 0 0 1-.02-3.59c.31-1.04.88-1.98 1.66-2.73 1.91 7.63 7.14 18.19 12.56 22.92.08.06.17.14.25.21.1.09.2.17.3.26.82.7 1.62 1.35 2.37 1.95.7.55 1.37 1.06 1.97 1.51Z"
							style={{
								mixBlendMode: 'darken',
								opacity: 0.02
							}}
						/>
						<path
							d="M62.56 31.03c-.09.04-.22.09-.37.15v-.03c.12-.04.24-.09.37-.12ZM65.34 30.21h-.18c.06 0 .12-.02.17-.04v.04Z"
							className="cooker_path_02"
						/>
						<path
							d="M74.24 27.33c-.58.13-1.16.26-1.76.4-.82-.31-1.27-1.13-1.36-1.26v.03-.05L65.26 7.59h-.18l5.47 19.39c.17.46.14.89.08 1.2-.75.19-1.51.39-2.28.6L61.26 7.49l-.11.23 6.5 21.24c-.71.2-1.43.4-2.16.62-.3-.28-.51-.62-.57-.66L57.87 7.3l-.16.06 6.39 21.22c.09.61.1 1.06.07 1.39-.24.07-.48.15-.72.22-.48.15-.96.3-1.43.45L54.78 8.3l-.13.08 6.7 22.48c-.84.28-1.66.56-2.46.84l-7.14-21.37-.15.22 6.61 21.39c-.82.29-1.62.58-2.41.88l-6.29-20.35-.17.17 5.28 18.59v.02c.22 1.26.01 1.84-.2 2.1-.46.18-.91.36-1.36.54.07.23.15.47.22.7.66-.29 1.34-.59 2.04-.88.22-.1.44-.19.67-.28.77-.32 1.56-.63 2.39-.94h.01c.22-.09.44-.17.67-.26.64-.23 1.29-.46 1.95-.69h.01c.16-.06.32-.11.48-.17.22-.07.45-.15.68-.22.13-.04.25-.09.38-.12.11-.04.17-.07.17-.07.3-.09.61-.19.91-.28.14-.04.28-.09.41-.12.2-.07.4-.13.59-.18.07-.02.14-.05.21-.07.1-.03.2-.05.29-.08h.02c.06-.02.12-.04.17-.06.27-.08.54-.16.8-.23h.03c.56-.16 1.11-.31 1.66-.44.24-.07.48-.13.71-.18.86-.22 1.7-.42 2.52-.59.24-.06.48-.11.71-.16.93-.2 1.83-.37 2.7-.53-.07-.24-.15-.47-.22-.71ZM54.1 33.57l.1-.03c-.06.03-.1.03-.1.03Z"
							className="cooker_path_02"
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
);
export const AvatarAccessoryDanceDressSvg = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 200" {...props}>
		<defs>
			<style>
				{
					'.dance_path_01{fill:#ffaaed}.dance_path_02{fill:#ffb6f1}.dance_path_03{mix-blend-mode:overlay;opacity:.2}.dance_path_04{fill:#f4a2e5}'
				}
			</style>
		</defs>
		<g
			style={{
				isolation: 'isolate'
			}}
		>
			<g id="Layer_2">
				<g id="Accessory">
					<g id="dance_dress">
						<path
							d="M101.89 88.64c-3.55-.77-13.26-.72-24.62.24-11.85.99-21.77 2.67-24.71 4.06-.02-1.08-.05-2.18-.1-3.28-.2-4.94-.56-9.66-1.04-14.15 8.25-4.9 30.28-15.61 46.52-1.76 1.47 4.54 2.83 9.52 3.95 14.89Z"
							className="dance_path_02"
						/>
						<path
							d="m104.9 107.83-.11.13-.19.21c-.86 1.15-1.8 2.33-2.8 3.54-.38.46-.78.92-1.18 1.39-.38.44-.77.88-1.15 1.3-1.1 1.23-2.19 2.37-3.24 3.43h-.01a97.575 97.575 0 0 1-3.84 3.7 100.2 100.2 0 0 1-10.41 8.27c-.49.12-.96.23-1.41.32-.89.03-1.94.05-3.12 0a66.456 66.456 0 0 0-6.26-6.09 66.553 66.553 0 0 0-13.58-8.9c-.36-.17-.71-.35-1.06-.51-1.48-.69-2.9-1.29-4.22-1.81-.03-.02-.06-.03-.09-.04.15-2.4.27-4.87.34-7.41.1-3.53.12-7.19.04-10.98 0-.48-.02-.96-.04-1.44 2.94-1.39 12.86-3.07 24.71-4.06 11.36-.96 21.07-1.01 24.62-.24.12.55.23 1.09.34 1.65.02.08.03.16.05.24l1.74 11.49.08.54.8 5.27ZM60.65 73.69l-1.75.19c-.63-6.37-2.91-9.13-4.46-10.29.6-.19 1.22-.37 1.85-.55 4.14 2.13 4.36 10.65 4.36 10.65ZM92.81 73.44l-1.68-.52c1.57-4.92 1.23-8.1.53-10.03.78.22 1.52.46 2.25.7h.01c1.27 3.94-1.11 9.85-1.11 9.85Z"
							className="dance_path_02"
						/>
						<path
							d="M103.33 89.39c.02.28-.36.58-1.1.9-3.18 1.37-12.92 3-24.5 3.97-11.96 1.01-22.09 1.02-25.13.12-.59-.18-.91-.39-.93-.63-.02-.25.29-.52.89-.81 2.94-1.39 12.86-3.07 24.71-4.06 11.36-.96 21.07-1.01 24.62-.24.91.19 1.41.44 1.44.75Z"
							className="dance_path_01"
						/>
						<path
							d="M127.22 95.24c.25 2.98-21.55 7.25-48.7 9.54-27.15 2.29-47.95 1.97-48.2-1.01 8.43-1.87 12.39-4.13 15.77-5.84 8.48-1.51 19.47-2.91 31.52-3.93 13.19-1.11 25.22-1.56 34.13-1.37 7.51 1.93 15.21 2.11 15.21 2.11.16.16.25.32.27.5Z"
							className="dance_path_01"
						/>
						<path
							d="m126.95 94.74-96.86 9.47c8.43-1.87 12.62-4.57 16-6.28 3.43-1.74 4.83-3.17 5.33-3.81.19-.24.25-.37.25-.37l51.66-4.36c2.44 1.42 5.41 2.47 8.41 3.24 7.51 1.93 15.21 2.11 15.21 2.11Z"
							className="dance_path_01"
						/>
						<path
							d="M28.91 109.58s.1-.54.42-.99l-.42.99ZM104.79 107.96l-.19.21c-.86 1.15-1.8 2.33-2.8 3.54-.38.46-.78.92-1.18 1.39-.38.44-.77.88-1.15 1.3-2.04.15-3.51-1.58-3.51-1.58-4.26-4.52-7.41 1.49-7.41 1.49-3.71 6.22-8.4.48-8.4.48-4.61-6.41-8.09.89-8.09.89-2.91 6.35-7.96.47-7.96.47-2.91-4.4-5.33-2.54-6.51-1.02-.36-.17-.71-.35-1.06-.51-1.48-.69-2.9-1.29-4.22-1.81.11-2.24.2-4.53.25-6.87l51.46-3.92.08.63.69 5.31Z"
							className="dance_path_03"
						/>
						<path
							d="M28.91 106.98s1.03-5.45 6.77 4.08c0 0 3.72 5.01 6.85.59 0 0 3.43-6.25 7.58-.06 0 0 3.62 4.74 6.69.06 0 0 3.14-5.56 7.3-.19 0 0 5.05 5 7.96-.4 0 0 3.49-6.23 8.09-.76 0 0 4.69 4.89 8.4-.41 0 0 3.14-5.12 7.41-1.26 0 0 3.83 3.83 7.68-1.37 0 0 2.9-5.26 7.57-1.41 0 0 4.48 2.59 7.07-1.89 0 0 1.52-5.02 6-2.07 0 0 5.14-1.33 2.27-5.13l-17.53 2.34-78.94 5.13-1.18 2.76Z"
							style={{
								fill: '#ffdefa'
							}}
						/>
						<path
							d="M28.91 106.98s1.03-8.49 6.77 1.05c0 0 3.72 5.01 6.85.59 0 0 3.43-6.25 7.58-.06 0 0 3.62 4.74 6.69.06 0 0 3.14-5.56 7.3-.19 0 0 5.05 5 7.96-.4 0 0 3.49-6.23 8.09-.76 0 0 4.69 4.89 8.4-.41 0 0 3.14-5.12 7.41-1.26 0 0 3.83 3.83 7.68-1.37 0 0 2.9-5.26 7.57-1.41 0 0 4.48 2.59 7.07-1.89 0 0 1.52-5.02 6-2.07 0 0 5.8.2 2.93-3.6l-18.19.81-76.13 7.49-3.99 3.43Z"
							className="dance_path_01"
						/>
						<path
							d="M50.38 106.66c.06-.24.2-.45.4-.6 1.48-1.02 7.66-5.38 8.3-9.26 0 0 1.26-1.07 1.56-.06.28.93-3.68 10.33-4.35 11.91-.07.16-.17.29-.31.4-.64.49-2.67 1.71-4.9-.17-.64-.54-.91-1.41-.72-2.22ZM102.13 102.58c-.06-.26-.22-.49-.44-.65-1.52-1.05-7.63-5.39-8.28-9.24 0 0-1.26-1.07-1.56-.06-.26.86 3.12 8.99 4.15 11.44.23.55.63 1.01 1.16 1.28 1.03.52 2.85.94 4.75-1.06.31-.33.44-.79.34-1.22l-.12-.49ZM116.61 98.35a1.78 1.78 0 0 0-1.12-.62c-2.19-.31-9.08-1.44-11.3-4.46 0 0-1.61-.39-1.42.65.16.91 7.25 6.95 9.05 8.47.32.27.72.43 1.14.46 1.09.07 3.09-.18 3.99-2.86.19-.56.05-1.19-.33-1.64ZM36.37 104.28c.22-.27.54-.45.89-.5 2.02-.29 9.16-1.46 11.41-4.56 0 0 1.6-.4 1.43.64-.15.87-6.57 6.45-8.71 8.29-.6.52-1.37.78-2.16.7-1.12-.11-2.6-.72-3.32-2.98-.15-.47-.05-.99.27-1.36l.2-.24ZM71.32 107.73c.44-.58.39-12.97.62-13.96s-1.29-1.24-1.66-.13c-.32.95-4.31 9.78-5.4 12.18-.18.39-.16.84.06 1.19.88 1.42 3.39 4.61 6.37.72ZM87.58 104.27c.03-.75-7.2-11.3-7.57-12.28s-1.78-.31-1.44.84c.29 1 2.13 10.83 2.63 13.5.08.44.36.81.74.98 1.54.71 5.45 1.99 5.64-3.04Z"
							className="dance_path_04"
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
);
export const AvatarAccessoryHeadsetSvg = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" id="Layer_2" viewBox="0 0 150 200" {...props}>
		<defs>
			<style>{'.headset_path_01{fill:#19538c}.headset_path_02{fill:#4b9cff}'}</style>
		</defs>
		<g id="Accessory">
			<g id="headset">
				<path
					d="M57.4 48.95c.65 3.8-.74 7.2-3.1 7.6l-1.81.31-.11-.65c-1.64-.85-3.03-3.06-3.5-5.8s.12-5.29 1.39-6.63l-.11-.65 1.81-.31c2.36-.4 4.79 2.35 5.43 6.15Z"
					className="headset_path_01"
				/>
				<ellipse
					cx={51.79}
					cy={49.9}
					rx={4.17}
					ry={6.97}
					style={{
						fill: '#06396d'
					}}
					transform="rotate(-9.64 51.804 49.932)"
				/>
				<ellipse
					cx={51.35}
					cy={49.98}
					className="headset_path_02"
					rx={4.17}
					ry={6.97}
					transform="rotate(-9.64 51.379 50.016)"
				/>
				<path
					d="M47.53 49.2c-.1-.02-.16-.12-.15-.22-.01-.57.03-1.31.22-2.14.13-.56.3-1.05.48-1.45 0-.01.02-.08.08-.12.04-.03.09-.04.14-.03.1.02.16.12.15.22-.18.4-.37.9-.51 1.48-.19.83-.22 1.56-.19 2.11 0 .01-.02.08-.22.15Z"
					style={{
						fill: '#fafdff'
					}}
				/>
				<path
					d="M75.5 31.73c-2.42-.42-5.87-1.25-9.88-.39-4.16.89-6.94 2.83-9.16 4.83-.25.13-.6-.1-.9-.35-.19-.16-.34-.4-.41-.7-.13-.59.14-1.15.59-1.25 2.18-1.36 5.27-2.9 9.18-3.78 4-.9 6.71-.55 9.3-.24.45-.1 1.55.2 1.88.63.13.59-.14 1.15-.59 1.25Z"
					className="headset_path_01"
				/>
				<path
					d="M85.12 38.21c-.48-.54-.87-.91-1.08-1.1-.04-.04-.1-.07-.15-.1-.24-.1-.48-.2-.72-.29-3.08-3.88-8.19-6.42-13.98-6.42-8.65 0-15.81 5.68-16.94 13.04-.04.27-.08.53-.1.79-.05.04-.11.06-.18.05l-2.37-.31c-.01-.17-.01-.33-.01-.5 0-.15 0-.3.01-.45.29-7.92 8.39-14.27 18.34-14.27 7.87 0 14.58 3.97 17.18 9.56Z"
					className="headset_path_02"
				/>
				<path
					d="m52.57 43.54-.07.42c-.01.07-.05.14-.11.17-.05.04-.12.06-.2.05l-2.57-.31-.15-.02c-.15-.02-.26-.15-.24-.29l.07-.42c.02-.14.16-.24.31-.22h.01l2.7.33c.08.01.13.04.17.09.05.06.08.13.07.2Z"
					className="headset_path_01"
				/>
			</g>
		</g>
	</svg>
);
export const AvatarAccessoryPirateSvg = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 200" {...props}>
		<defs>
			<style>
				{
					'.pirate_path_01{fill:#d82323}.pirate_path_02{mix-blend-mode:overlay;opacity:.2}.pirate_path_03{fill:#934b1b}.pirate_path_04{fill:#b72323}.pirate_path_05{fill:#5e2800}.pirate_path_06{fill:#ee332d}'
				}
			</style>
		</defs>
		<g
			style={{
				isolation: 'isolate'
			}}
		>
			<g id="Layer_2">
				<g id="Accessory">
					<g id="pirate">
						<path
							d="M76.3 28.39s3.99-3.47 3.17-5.39c-.24-.56 2.02 5.28 2.02 5.28s-3.2 2.58-3.51 2.39-1.68-2.27-1.68-2.27Z"
							style={{
								fill: '#471d00'
							}}
						/>
						<path
							d="M55.64 39.24c.33-.21.66-.4.98-.59-1.37 1.51-2.46 3.24-3.14 5.14-.17.44-.31.9-.42 1.37-.27-.45-.51-.91-.72-1.4-.14-.31-.26-.63-.37-.96-.03-.09-.06-.19-.08-.28-.1-.3-.17-.61-.23-.91.3.02.51.01.6-.06.91-.68 1.8-1.31 2.71-1.89.05-.03.11-.07.16-.1.17-.11.34-.22.51-.32ZM80.91 35.4c-1.13-.71-2.34-1.31-3.6-1.79 1.36.2 2.54.48 3.4.72.04.16.08.32.1.48.04.19.08.39.1.59Z"
							className="pirate_path_05"
						/>
						<path
							d="M80.71 34.33c-1.5-.41-3.96-.96-6.64-1.05-1.56-.05-4.45.21-8.07 1.27-1.37.4-2.85.92-4.4 1.58-1.9.81-3.9 1.83-5.96 3.11a44.985 44.985 0 0 0-3.38 2.31c-.09.07-.3.08-.6.05-.69-3.22.08-6.54 1.94-9.37 1.29-1.98 3.12-3.72 5.37-5 .06-.04.12-.07.18-.1.94-.53 1.94-.97 3.01-1.32.8-.26 1.6-.47 2.4-.6.89-.17 1.77-.25 2.65-.27 4.43-.08 8.51 1.64 11.08 4.64.95 1.11 1.69 2.39 2.16 3.83l.03.09c.09.27.17.55.23.83Z"
							style={{
								fill: '#492302'
							}}
						/>
						<path
							d="M67.77 34.5s-3.21 1.6-6.17 1.63c-2.78.02-5.5.02-5.64-.1-.13-.11-1.21-1.79-2.36-3.8 1.29-1.98 3.12-3.72 5.37-5 .06-.04.12-.07.18-.1.94-.53 1.94-.97 3.01-1.32.8-.26 1.6-.47 2.4-.6-2.27 2.48-1.63 5.82 1.44 9.34.43.49 1.14-.54 1.77-.05Z"
							className="pirate_path_02"
						/>
						<path
							d="M55.51 59.57h-.29l-.19-19.01h.62l-.14 19.01z"
							style={{
								fill: '#1e1d1c'
							}}
						/>
						<ellipse
							cx={55.34}
							cy={46.24}
							rx={1.19}
							ry={1.57}
							style={{
								fill: '#ea8f3d'
							}}
						/>
						<circle
							cx={55.34}
							cy={48.47}
							r={0.75}
							style={{
								fill: '#931403'
							}}
						/>
						<circle
							cx={55.34}
							cy={56.37}
							r={0.75}
							style={{
								fill: '#08b3ff'
							}}
						/>
						<circle
							cx={55.34}
							cy={58}
							r={0.59}
							style={{
								fill: '#fc6232'
							}}
						/>
						<rect
							width={1.28}
							height={2.21}
							x={54.69}
							y={49.39}
							rx={0.2}
							ry={0.2}
							style={{
								fill: '#494949'
							}}
						/>
						<path
							d="M54.89 52.94h.87c.11 0 .2.09.2.2-.08.15-.22.45-.24.86-.01.46.15.8.24.95 0 .01 0 .08-.06.14-.04.04-.09.06-.14.06h-.87a.2.2 0 0 1-.2-.2c.08-.13.28-.48.26-.97-.01-.41-.17-.71-.26-.84 0-.01 0-.08.2-.2Z"
							style={{
								fill: '#d3d3d3'
							}}
						/>
						<rect
							width={1.28}
							height={0.74}
							x={54.69}
							y={51.84}
							rx={0.36}
							ry={0.36}
							style={{
								fill: '#efcd29'
							}}
						/>
						<g className="pirate_path_02">
							<path d="M55.17 49.2s-.04.01-.06.01v-.03s.04.02.06.02ZM55.52 58.47v1.1h-.18v-.98l.01-.03c.06-.02.12-.05.17-.09ZM55.53 56.93v.52l-.01.08a.346.346 0 0 0-.16-.08v-.4c.06-.03.12-.07.17-.12ZM55.54 55.14v.68s-.11-.08-.17-.11v-.56H55.54ZM55.43 54c.01-.25.06-.46.12-.61v1.3c-.07-.18-.13-.41-.12-.69ZM55.56 52.46v.51s-.06-.03-.1-.03h-.07v-.38a.27.27 0 0 0 .17-.1ZM55.58 48.97v.42l-.02 2.22v.35a.275.275 0 0 0-.16-.1v-.25h-.07s.05 0 .07-.02c.08-.02.13-.1.13-.19v-1.8c0-.09-.05-.16-.12-.19-.03-.01-.05-.02-.08-.02h.08v-.18h-.08c-.05 0-.1 0-.15-.02.09-.02.17-.05.24-.09.06-.04.12-.09.16-.14ZM55.59 47.51v.46s-.1-.1-.16-.14c-.02-.01-.04-.02-.05-.03a.442.442 0 0 0-.16-.06c.03 0 .05-.01.08-.03.04-.02.09-.04.13-.07.06-.04.11-.08.16-.13ZM55.09 44.7s-.02.01-.03.01v-.02s.02 0 .03.01ZM55.64 40.56l-.03 4.16v.27s-.1-.1-.16-.13a.876.876 0 0 0-.32-.16c.06-.02.13-.03.2-.03.04 0 .08 0 .12.01l.03-4.12h.16Z" />
							<path d="M55.4 51.59v.02h-.07s.05 0 .07-.02ZM55.17 49.2s-.04.01-.06.01v-.03s.04.02.06.02ZM55.33 49.39h.08v.02s-.05-.02-.08-.02ZM55.42 49.11v.1h-.09c-.05 0-.1 0-.15-.02.09-.02.17-.05.24-.09ZM55.43 47.64v.19s-.04-.02-.05-.03a.442.442 0 0 0-.16-.06c.03 0 .05-.01.08-.03.04-.02.09-.04.13-.07ZM55.09 44.7s-.02.01-.03.01v-.02s.02 0 .03.01ZM55.45 44.68v.18a.876.876 0 0 0-.32-.16c.06-.02.13-.03.2-.03.04 0 .08 0 .12.01Z" />
							<path d="M56.53 46.24c0 .74-.39 1.36-.92 1.52l-.02.01s-.1.03-.16.03c-.01.01-.03.01-.05 0a.442.442 0 0 0-.16-.06c.03 0 .05-.01.08-.03.04-.02.09-.04.13-.07.06-.04.11-.08.16-.13.3-.28.5-.75.5-1.27s-.19-.96-.48-1.25c-.05-.05-.1-.1-.16-.13a.876.876 0 0 0-.32-.16c.06-.02.13-.03.2-.03.04 0 .08 0 .12.01.06.01.11.02.16.04.53.16.92.78.92 1.52ZM55.09 44.7s-.02.01-.03.01v-.02s.02 0 .03.01Z" />
							<path d="M56.09 48.47c0 .32-.21.61-.51.7-.05.03-.1.04-.16.04h-.09c-.05 0-.1 0-.15-.02.09-.02.17-.05.24-.09.06-.04.12-.09.16-.14.13-.13.2-.31.2-.5s-.07-.37-.19-.5c-.04-.05-.1-.1-.16-.14-.02-.01-.04-.02-.05-.03a.442.442 0 0 0-.16-.06c.03 0 .05-.01.08-.03h.13c.06 0 .11.02.16.04h.02c.28.11.48.39.48.71ZM55.17 49.2s-.04.01-.06.01v-.03s.04.02.06.02ZM56.09 56.37c0 .35-.24.64-.56.73-.05.02-.11.03-.17.03v-.08c.06-.03.12-.07.17-.12a.754.754 0 0 0 .01-1.11.99.99 0 0 0-.17-.11v-.08c.06-.01.12 0 .17.03.32.08.55.37.55.71ZM55.92 58c0 .26-.16.48-.4.55s-.11.04-.17.04v-.03c.06-.02.12-.05.17-.09.14-.1.24-.27.24-.47s-.1-.37-.24-.47a.346.346 0 0 0-.16-.08v-.04c.06 0 .11.01.16.04.24.07.4.29.4.55ZM55.96 49.6v1.8c0 .12-.09.21-.2.21h-.43s.05 0 .07-.02c.08-.02.13-.1.13-.19v-1.8c0-.09-.05-.16-.12-.19-.03-.01-.05-.02-.08-.02h.43c.11 0 .2.09.2.21ZM55.73 54c-.02.46.15.8.23.95 0 .02 0 .09-.06.15-.03.03-.08.05-.14.05h-.3.08c.03-.01.05-.03.06-.04.06-.06.06-.13.06-.15-.03-.06-.08-.15-.12-.26a1.876 1.876 0 0 1 .01-1.3c.04-.11.08-.19.11-.25 0-.07-.04-.14-.1-.17a.169.169 0 0 0-.1-.03h.3c.11 0 .2.09.2.2-.08.15-.22.45-.23.86ZM55.96 52.21c0 .2-.16.37-.37.37h-.2v-.02a.27.27 0 0 0 .17-.1c.06-.07.1-.15.1-.25s-.04-.19-.1-.25a.275.275 0 0 0-.16-.1v-.02h.19c.21 0 .37.16.37.37Z" />
						</g>
						<path
							d="M82.74 36.52c-.18-.07-.36-.13-.55-.19-.39-.22-.81-.41-1.24-.58-3.82-1.54-8.91-1.74-14.24-.22-5.55 1.58-10.21 4.7-13.07 8.34-.17.22-.34.44-.5.67.05-.27.1-.54.17-.81.24-1.03.6-2.04 1.1-3.02.04-.1.09-.2.14-.3.13-.25.27-.5.42-.75.06-.11.13-.21.19-.31.42-.69.91-1.36 1.45-2.01 2.21-2.66 5.35-4.85 9.01-6.07.66-.22 1.32-.4 1.97-.54 1.65.87 3.39 1.46 5.62 1.06.02 0 .05 0 .07-.01.67-.07 1.38-.24 2.16-.54.21-.08.41-.16.6-.25 1.35.43 2.58 1.05 3.65 1.86.27.2.54.42.79.65.36.33.7.68 1 1.06.07.08.14.16.2.24.01.02.03.03.04.05.11.14.21.28.31.43.27.39.5.8.71 1.24Z"
							className="pirate_path_04"
						/>
						<path
							d="M82.78 34.06c-.14.2-.28.4-.44.6-.03.05-.07.1-.11.15 0 0-.27-.1-.75-.25.07.08.14.16.2.24.01.02.03.03.04.05.11.14.21.28.31.43-.4-.18-.81-.33-1.22-.47-10.17-3.55-21.21 2.44-26.4 5.9-1.16.77-1.85 2.13-2.34 2.52-.1-.3-.35-1.32-.41-1.62s.34-1.68.34-1.68l4.61-2.59 8.25-4.64 14.83.15h.26l2.83 1.21Z"
							className="pirate_path_02"
						/>
						<path
							d="M53.48 43.79c-.25.68-.45 1.4-.58 2.12-.03.13-.05.26-.06.39-.03 0-.05 0-.08.01-.13.03-.24.09-.35.19-.01 0-.02 0-.03-.01h-.01s.01-.01.01-.02c.02-.06.05-.12.07-.18l.87-2.56c.06.02.12.04.17.06Z"
							className="pirate_path_06"
						/>
						<path
							d="m53.31 43.73-.87 2.56c-.02.06-.05.12-.07.18 0 .01 0 .02-.01.02-.04-.01-.07-.03-.11-.05-.11-.05-.21-.11-.3-.19-.02-.02-.04-.03-.06-.05a1.447 1.447 0 0 1 .45-2.44c.1-.04.2-.07.31-.09.07-.01.15-.02.22-.02.15 0 .3.02.44.08Z"
							className="pirate_path_04"
						/>
						<path
							d="M52.37 46.47v.05s-.03.02-.04.04c-.05.04-.09.1-.14.15-.32.4-.55 1.07-.68 1.85-.11.7-.14 1.48-.07 2.25v.02c.03.29.07.59.13.87 0 .04 0 .07.02.11.01.06.03.12.04.18-.1.33-.21.65-.33.93-.01.05-.04.11-.06.16-1.28 3.01-3.19 3.04-3.19 3.04-.06-.24-.09-.48-.1-.74-.14-3.06 2.76-7.5 3.94-9.18.1.1.23.18.36.24.04.02.07.04.11.05.01 0 .01-.01.01-.02Z"
							className="pirate_path_04"
						/>
						<path
							d="M53.78 55.89c-.53 1.89-1.53 2.37-1.71 2.43-.02.02-.03.02-.03.02-.72-1.34-.89-3.28-.8-5.26.04-.75.11-1.51.2-2.25.03.33.08.66.15.98.01.06.03.12.04.18.22.91.61 1.84 1.09 2.6.33.55.7 1.01 1.06 1.3Z"
							className="pirate_path_04"
						/>
						<path
							d="M52.9 45.91c-.03.13-.05.26-.06.39-.03 0-.05 0-.08.01-.13.03-.25.09-.36.19-.01 0-.02.01-.03.02-.06.05-.12.12-.18.19.03-.1.05-.19.06-.27.05-.18.09-.35.13-.5.15-.59.25-.94.25-.94.1.31.19.62.27.91Z"
							className="pirate_path_06"
						/>
						<path
							d="M82.79 34.06h-.01c-.14.2-.28.4-.44.6-.03.05-.07.1-.11.15 0 0-.27-.1-.75-.25-.21-.07-.47-.15-.77-.23-1.5-.41-3.96-.96-6.64-1.05-2.88-.09-10.26.86-18.43 5.96-.17.1-.34.21-.51.32-.05.03-.11.07-.16.1-.5.32-1 .66-1.5 1.01-.4.28-.8.58-1.21.88-.09.07-.3.08-.6.05-2.53-.29-11.74-4-14.69-5.2a48.917 48.917 0 0 0-.91-.38c.04-.05 1.21-.68 3.04-1.59 4.98-2.47 14.83-6.95 19.87-7.2.14-.01.28-.01.42-.01 3.65 0 6 1.98 8.54 3.34h.02l.12.06c1.65.87 3.39 1.46 5.62 1.06.02 0 .05 0 .07-.01a9.06 9.06 0 0 0 1.61-.44c.23-.08.44-.16.64-.25.96-.4 1.71-.88 2.28-1.4 1.33-1.21 1.71-2.64 1.71-3.86 0-.09 0-.19-.01-.28a6.387 6.387 0 0 0-.5-2.23c-.06-.13-.1-.21-.12-.23.4.1 10.32 1.46 3.42 11.08Z"
							className="pirate_path_05"
						/>
						<path
							d="M51.44 50.83c.03.29.07.59.13.87l-.27 1.22s-.04.11-.06.16c-1.28 3.01-3.19 3.04-3.19 3.04-.06-.24-.09-.48-.1-.74.94-1.53 2.29-3.91 3.56-6.82-.11.7-.14 1.48-.07 2.25v.02ZM53.31 43.73l-.56 2.58c-.13.03-.24.09-.35.19-.01 0-.02 0-.03-.01v.03s-.03.02-.04.04c.01-.02.02-.04.03-.07.01 0 .01-.01.01-.02.02-.06.05-.12.07-.18l.87-2.56ZM53.78 55.89c-.53 1.89-1.53 2.37-1.71 2.43.21-.96.47-2.26.65-3.73.33.55.7 1.01 1.06 1.3Z"
							className="pirate_path_01"
						/>
						<path
							d="m53.31 43.73-.87 2.56c-.02.06-.05.12-.07.18 0 .01 0 .02-.01.02-.04-.01-.07-.03-.11-.05-.11-.05-.21-.11-.3-.19.7-.79.74-1.94.7-2.58.07-.01.15-.02.22-.02.15 0 .3.02.44.08Z"
							className="pirate_path_01"
						/>
						<path
							d="M53.47 40.67c-.4.28-.8.58-1.21.88-.09.07-.3.08-.6.05-2.53-.29-11.74-4-14.69-5.2a48.917 48.917 0 0 0-.91-.38c.04-.05 1.21-.68 3.04-1.59 4.61 2.23 10.99 5.2 14.37 6.24Z"
							className="pirate_path_02"
						/>
						<path
							d="M72.12 28.38c.08.68.24 1.34.39 1.99.35-.02.81-.32 1.02-.74-.05-.04-.11-.07-.16-.11.19-.14.38-.28.57-.41.01.23.03.46.05.71-.07-.02-.14-.05-.21-.07-.05.08-.1.17-.15.25-.27.41-.63.73-1.09.92-.21.08-.41.05-.62 0-.45-.1-.84-.32-1.17-.64-.02-.01-.03-.03-.05-.05-.06.04-.12.08-.18.13-.06-.24-.12-.47-.18-.69.21.07.44.14.66.22l-.12.15c.3.32.81.48 1.2.4-.06-.67-.1-1.35-.24-2.02-.18.03-.36.06-.53.08-.02 0-.03.03-.05.04-.07.07-.18.08-.26.02a.215.215 0 0 1-.05-.25c.05-.08.16-.11.25-.08.05.02.1.02.15.02l.43-.06c-.02-.14-.04-.26-.06-.39 0-.05-.03-.07-.08-.09a.466.466 0 0 1-.3-.49c.03-.21.19-.37.41-.41.2-.03.41.09.49.28.08.2.02.42-.15.55-.04.03-.05.05-.04.1.02.12.04.25.06.38.16-.03.33-.05.5-.08.02 0 .04-.03.05-.04.08-.07.19-.08.27-.02.08.06.09.18.04.26-.06.09-.16.11-.26.06-.02-.01-.04-.02-.06-.02-.17.02-.34.05-.52.08Zm-.02-1.14a.306.306 0 0 0-.35-.25c-.16.03-.27.18-.25.34.03.16.18.28.35.25.16-.03.27-.18.25-.34Z"
							className="pirate_path_03"
						/>
						<path
							d="M80.17 23.88c.2.24 1.69 6.11-4.28 8.45-.2.09-.41.16-.64.24-.57.2-1.11.33-1.63.41-.02.01-.05.01-.07.01-2.25.38-4-.18-5.67-1l-.12-.06h-.02c-2.56-1.29-4.93-3.16-8.62-3.16-5.55 0-17.99 5.6-22.15 7.63-.33-.14-.59-.25-.74-.31 3.16-1.59 16.95-8 22.89-8 3.69 0 6.06 1.88 8.62 3.16h.02l.12.06c1.67.83 3.42 1.38 5.67 1.01.02 0 .05 0 .07-.01.52-.09 1.06-.22 1.63-.42.23-.08.44-.15.64-.24 3.51-1.38 4.19-3.97 4.11-5.93 0-.09 0-.19-.01-.28-.09-1.23-.46-2.14-.54-2.24.01 0 .02 0 .04.01.5.11 4.59 1.09 5.54 4.22-1.12-2.68-4.61-3.49-4.86-3.55Z"
							className="pirate_path_03"
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
);
export const AvatarAccessoryApronSvg = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 200" {...props}>
		<defs>
			<style>
				{
					'.apron_path_01{opacity:.3;mix-blend-mode:overlay}.apron_path_02{fill:#e2c281}.apron_path_03{fill:#7a4300}.apron_path_04{fill:#f2daaa}.apron_path_05{opacity:.1;fill:#1c1c1c;mix-blend-mode:multiply}.apron_path_06{fill:#c19f63}.apron_path_07,.apron_path_08{stroke-width:.21px;fill:none;stroke:#515151;stroke-linecap:round;stroke-miterlimit:10}.apron_path_08{stroke-width:.25px}'
				}
			</style>
		</defs>
		<g
			style={{
				isolation: 'isolate'
			}}
		>
			<g id="Layer_2">
				<g id="Accessory">
					<g id="apron">
						<path
							d="m58.47 68.16-.51.96s2.4 10.54.79 19.03l1.6-.8-.7-16.49-1.18-2.69ZM48.64 134.51l28.07-1.74c-.62 3.31-1.26 6.66-1.94 10.03-14.29.56-23.55-2.45-26.85-3.76l.72-4.53ZM109.98 135.34c-9.17 3.41-17.46 5.42-24.8 6.49-.7-3.35-1.5-6.5-2.35-9.44l26.61-1.65c.2 1.5.38 3.04.54 4.6ZM54.31 63.58s4.02 2.23 4.81 4.1l1.33-.36-5.1-4.06-1.04.32Z"
							className="apron_path_05"
						/>
						<path
							d="m56.52 62.26-2.51.66s-.2.82-.16.8 3.06-.85 3.06-.85l-.39-.62Z"
							className="apron_path_06"
						/>
						<path
							d="M111.22 132.47s-1.39.43-3.79 1.09c-.5.13-1.05.28-1.65.44-1.11.29-2.38.61-3.76.95-.53.13-1.08.26-1.64.39-1.09.26-2.23.52-3.43.78-.6.13-1.2.26-1.82.38-.96.21-1.95.4-2.96.6-.58.11-1.17.22-1.76.33-1.03.19-2.09.37-3.16.54-.58.1-1.17.2-1.76.29-1.44.22-2.9.42-4.38.61-.58.07-1.17.14-1.77.2-1.23.15-2.48.27-3.73.37-.59.05-1.17.1-1.76.14-1.1.08-2.2.14-3.3.18-.61.02-1.21.04-1.82.05-1.54.03-3.08.02-4.58-.03-.63-.02-1.26-.05-1.88-.09a62.108 62.108 0 0 1-4.31-.41c-.4-.05-.8-.11-1.19-.17-.25-.04-.5-.08-.75-.13-1.81-.31-3.55-.72-5.18-1.24-.45-.14-.9-.29-1.34-.46l-.57-.21c-.87-.34-1.71-.72-2.51-1.14l5.43-44.64.13-.07.6-.32 1.83-.96 1.63-.86.19-.1 1.58-.83.16-.09 1.54-.81c.28-2.78.4-6.18.05-10.03-.32-3.52-.96-6.58-1.65-9.11 0 0 .29-.08.81-.22.36-.09.82-.21 1.39-.35.61-.15 1.35-.32 2.18-.5.5-.1 1.05-.21 1.62-.32 1.09-.21 2.29-.42 3.58-.61.53-.09 1.08-.17 1.64-.24 1.24-.16 2.54-.3 3.87-.4.55-.05 1.1-.08 1.66-.11 1.44-.08 2.91-.11 4.38-.07.56.01 1.11.03 1.67.06 1.07.07 2.13.17 3.18.32.58.08 1.15.17 1.71.28.97.19 1.91.42 2.82.7.6.18 1.19.39 1.77.62.17.07.34.14.5.21.86 2.43 1.68 5.26 2.31 8.46.76 3.85 1.06 7.34 1.13 10.3.34.13.67.26 1.01.39h.01c.6.24 1.2.47 1.81.7.49.19.98.38 1.48.57l1.86.72c.02 0 .04 0 .06.02 0 0 10.8 35.81 10.86 43.83Z"
							style={{
								fill: '#f9eac7'
							}}
						/>
						<path
							d="M107.43 133.56c-.5.13-1.05.28-1.65.44.01-4.93-1.03-17.12-7.34-46.1l1.86.72c1.72 7.84 7.26 34 7.13 44.94ZM102.02 134.95c-.53.13-1.08.26-1.64.39.4-3.79.44-15.42-5.23-48.71.6.24 1.2.47 1.81.7 1.14 6.6 6.28 37.28 5.06 47.62ZM96.95 136.12c-.6.13-1.2.26-1.82.38.23-4.91.24-22.76-6.71-69.85.6.18 1.19.39 1.77.62 1.28 8.19 8.29 54.19 6.76 68.85ZM92.17 137.1c-.58.11-1.17.22-1.76.33.25-3.51.8-20.72-6.52-71.76.58.08 1.15.17 1.71.28 1.19 7.8 8.55 57.19 6.57 71.15ZM87.25 137.97c-.58.1-1.17.2-1.76.29.26-3.64.81-21.19-6.45-72.97.56.01 1.11.03 1.67.06.92 6.13 8.59 58.17 6.54 72.62ZM81.11 138.87c-.58.07-1.17.14-1.77.2.27-4.47.58-22.78-6.34-73.6.55-.05 1.1-.08 1.66-.11.88 6.09 8.39 58.39 6.45 73.51ZM75.61 139.44c-.59.05-1.17.1-1.76.14.26-4.64.52-23.06-6.36-73.47.53-.09 1.08-.17 1.64-.24.82 5.59 8.41 58.3 6.48 73.57ZM70.55 139.76c-.61.02-1.21.04-1.82.05.22-6.04.04-25.25-6.44-72.77.5-.1 1.05-.21 1.62-.32.29 1.99 8.23 56.04 6.64 73.04ZM64.15 139.78c-.63-.02-1.26-.05-1.88-.09.44-7.28.71-26.99-3.55-71.8.36-.09.82-.21 1.39-.35l.25.16s5.7 53.54 3.79 72.08ZM57.96 139.28c-.4-.05-.8-.11-1.19-.17-.25-.04-.5-.08-.75-.13.58-7.39 1.17-22.32.21-50l1.74-.92c.68 16.15 1.28 38.93-.01 51.22ZM54.41 89.94c-.53 15.57-1.58 36.09-3.57 47.8-.65-.2-1.29-.43-1.91-.67 1.1-7.39 2.62-21.39 3.65-46.17l1.83-.96Z"
							className="apron_path_04"
						/>
						<path
							d="M54.01 62.92s6.37 2.95 7.51 7.78l2.7-.53s-1.27-3.93-7.7-7.91l-2.51.66ZM88.01 61.07s1.69 4.43-.75 8.34l2.74.31s1.66-.77.02-7.66L88 61.08Z"
							className="apron_path_02"
						/>
						<path
							d="m77.6 80.323 1.645-.47 4.963 17.364-1.644.47z"
							className="apron_path_03"
						/>
						<path
							d="M80.38 76.44c.5 1.77.12 3.49-.88 4.31-.22.19-.48.33-.77.41-.06.02-.13.04-.19.04-.23.05-.46.05-.69.02-1.27-.18-2.52-1.43-3.02-3.2-.6-2.08.06-4.12 1.47-4.66.05-.03.12-.05.18-.07 1.53-.44 3.27.97 3.89 3.14Z"
							className="apron_path_03"
						/>
						<path
							d="m76.31 73.37 6.9 24.14-.64.18-4.71-16.47c-1.27-.18-2.52-1.43-3.02-3.2-.6-2.08.06-4.12 1.47-4.66Z"
							style={{
								opacity: 0.1,
								mixBlendMode: 'overlay'
							}}
						/>
						<path
							d="M80 76.55c.53 1.87-.1 3.69-1.42 4.07-.07.02-.13.04-.19.04-1.27.22-2.66-.96-3.17-2.74s.04-3.5 1.22-4c.06-.03.13-.05.2-.07 1.32-.38 2.82.83 3.35 2.7Z"
							style={{
								fill: '#602f02'
							}}
						/>
						<path
							d="M78.39 80.66c-1.27.22-2.66-.96-3.17-2.74s.04-3.5 1.22-4c-.68 3.35.89 5.64 1.95 6.74Z"
							className="apron_path_01"
						/>
						<path
							d="M71.81 86.45c1.78-.4 11.47-2.38 18.42.07 0 0 1.44 14.23 1.25 16.29s-15.72 5.45-19.41 1.42a.634.634 0 0 1-.16-.5c.12-1.86.75-12.5-.31-16.94-.04-.16.06-.31.22-.34Z"
							className="apron_path_06"
						/>
						<path
							d="M72 86.36s11.03-2.65 18.71 0c0 0 1.44 14 1.25 16.02s-16.26 5.48-19.6 1.18c0 0 .9-12.62-.36-17.2Z"
							className="apron_path_02"
						/>
						<path d="M61.36 70.85c0-.06.69-2.94 1.47-3.43" className="apron_path_08" />
						<path d="M64.32 69.85s-2.43-2.25-3.96-1.64" className="apron_path_08" />
						<path d="M90.05 69.57s-.95-2.36-1.67-2.68" className="apron_path_07" />
						<path d="M87.45 69.12s1.74-2.19 3.09-1.88" className="apron_path_07" />
						<path
							d="M58.85 139.39c-.3-.03-.6-.07-.89-.11-.4-.05-.8-.11-1.19-.17-.25-.04-.5-.08-.75-.13-1.81-.31-3.55-.72-5.18-1.24-.45-.14-.9-.29-1.34-.46-1.12-.55-2.13-1.07-2.94-1.49l5.42-44.57.6-.32 1.83-.96 1.63-.86.19-.1 1.58-.83c-1.65 8.66-2.86 18.85-1.79 31.61.46 5.55 1.75 14.36 2.83 19.63Z"
							className="apron_path_01"
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
);
export const AvatarAccessoryKnightSvg = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 200" {...props}>
		<defs>
			<style>
				{
					'.knight_path_4,.knight_path_5,.knight_path_6{isolation:isolate}.knight_path_4,.knight_path_8{fill:#282828}.knight_path_6{fill:#919191}'
				}
			</style>
		</defs>
		<g className="knight_path_5">
			<g id="Layer_2">
				<g id="Accessory">
					<g id="knight">
						<path
							d="m97.02 64.8-18.59 7.09S51.55 67 46.53 67.65c0 0 .18-.31.67-.8l.03-.03c.17-.18.38-.37.63-.57.04-.04.09-.07.14-.11 2.62-2.12 9.45-5.69 25.57-5.73 0 0 16.2.69 22.21 3.63.15.08.29.15.43.23.31.17.58.35.81.53Z"
							className="knight_path_4"
						/>
						<path
							d="m95.38 63.83-17.09 6.66s-25.42-5.16-30.03-4.56c0 0 4.52-5.94 25.57-5.98 0 0 .36.01.99.04.56.03 1.34.07 2.27.13 5.24.35 15.26 1.31 18.29 3.71Z"
							style={{
								fill: '#999',
								isolation: 'isolate'
							}}
						/>
						<path
							d="m78.52 68.69-1.6.09c.41-5.04-1.61-8.12-2.1-8.79.56.03 1.34.07 2.27.13 1.95 2.75 1.43 8.57 1.43 8.57Z"
							className="knight_path_8"
						/>
						<path
							d="M88.77 77.49c.09 1.58-.62 3.1-1.9 4.05l-4.74 3.5L79.47 87c-.4.29-.94.33-1.37.08l-2.56-1.45-5.45-3.08a4.695 4.695 0 0 1-2.37-3.79l-.97-14.61c.19-.37.32-.38.35-.39 1.03-.17 2.13-.32 3.31-.45 1.18-.13 2.43-.23 3.75-.28 1.05-.05 2.15-.07 3.28-.06 3.89.04 7.39.86 10.22 1.39.21-.02.38.14.39.34l.72 12.79Z"
							className="knight_path_4"
						/>
						<path
							d="m86.7 65.8.69 11.48c.08 1.38-.54 2.71-1.65 3.53l-6.45 4.76a1.1 1.1 0 0 1-.84.2c-.12-.02-.24-.06-.36-.12l-6.98-3.95a4.107 4.107 0 0 1-2.06-3.31l-.84-12.72c-.01-.18.12-.33.3-.34a45.426 45.426 0 0 1 17.84.17c.02 0 .13 0 .34.3Z"
							style={{
								fill: '#ad0011'
							}}
						/>
						<path
							d="m86.7 65.8.69 11.48c.08 1.38-.54 2.71-1.65 3.53l-6.45 4.76a1.1 1.1 0 0 1-.84.2c.25-3.63.61-7.77.24-12.36-.26-3.22-.62-6.21-1.14-8.88 1.37 0 2.48.07 4.1.24 1.72.18 3.29.44 4.7.74.02 0 .13 0 .34.3Z"
							style={{
								fill: '#e5d400'
							}}
						/>
						<g className="knight_path_5">
							<path
								d="M81.43 70.79c.26.22.52.42.81.6-.02.03-.05.06-.07.09-1.27 1.7-2.54 3.41-3.8 5.11-.69.93-1.39 1.86-2.08 2.79-.32.43-.67.83-1.04 1.21-.4.4-.82.78-1.27 1.12-.03.02-.06.05-.09.07h-.01v-.04c.16-.38.32-.76.49-1.13.2-.42.43-.83.69-1.22.18-.27.37-.54.56-.8l5.77-7.75c.01-.02.03-.04.05-.06Zm-6.94 10.14h.01c.01 0 .02-.02.03-.03.12-.14.25-.28.37-.43 2.02-2.71 4.04-5.41 6.06-8.12.05-.07.1-.13.15-.2.01-.02.03-.04.03-.06v-.07c-.02 0-.05 0-.07.02-.03.02-.05.05-.07.08-2.05 2.75-4.1 5.49-6.14 8.24-.13.17-.24.36-.35.53 0 0 0 .02-.01.03Z"
								className="knight_path_8"
							/>
							<path
								d="M82.38 70.35c.05.04.1.07.15.11.04.03.08.06.1.1.06.12.16.19.25.28.17.16.33.32.44.53.08.16.13.32.07.5-.03.07-.07.14-.11.21-.03.05-.06.04-.09 0-.11-.23-.26-.41-.46-.56-.1-.07-.22-.12-.34-.16a.906.906 0 0 1-.26-.13c-.18-.12-.35-.25-.52-.39a.952.952 0 0 1-.19-.21c-.22-.32-.52-.5-.9-.57h-.02c-.05-.01-.06-.04-.03-.09.18-.23.4-.29.67-.23.2.04.39.13.56.23.08.05.16.1.25.15.02.01.04.02.07.03.12.02.21.08.3.15.02.02.05.04.07.05ZM84.34 67.73c-.09-.08-.19-.15-.24-.25-.16-.3.02-.65.36-.69.05 0 .1-.02.13-.05.15-.12.37-.11.51.03.13.12.17.27.1.44-.01.04-.01.09 0 .13.02.13 0 .24-.07.35-.13.19-.37.26-.58.16-.07-.03-.14-.08-.21-.12ZM82.91 69.08c.04-.05.08-.11.12-.16.01-.01.04-.03.06-.03.02 0 .03.03.03.05.04.26.07.53.1.79 0 .02 0 .06-.02.08l-.23.32c-.01.02-.04.02-.06.04-.01-.02-.03-.04-.03-.06-.04-.26-.07-.52-.1-.79 0-.04 0-.06.03-.09.04-.05.07-.1.11-.14ZM83.28 68.61c.04-.05.08-.11.12-.16.01-.02.04-.03.06-.04.01.02.03.04.03.06.03.26.07.51.1.77 0 .02 0 .06-.02.08-.07.11-.15.21-.23.32-.01.02-.04.03-.06.03-.01 0-.03-.03-.03-.05-.03-.19-.05-.38-.07-.57 0-.07-.02-.15-.03-.22 0-.02 0-.05.02-.06.04-.05.08-.11.12-.16ZM83.81 68.99c-.04.05-.08.11-.12.16-.01.01-.04.03-.05.03-.02-.01-.04-.03-.04-.05l-.03-.26-.06-.49c0-.03 0-.08.03-.11.07-.1.15-.19.22-.29.01-.02.04-.03.06-.04.01.02.03.05.04.07.02.14.03.27.05.41.01.11.03.21.04.32 0 .03 0 .07-.03.1-.03.05-.07.1-.11.15ZM82.69 70.5l-.18-.15c-.02-.01-.03-.04-.03-.06l-.06-.5c0-.04 0-.06.03-.09.07-.09.14-.19.22-.28.02-.02.04-.03.06-.05.01.03.04.05.04.08.04.26.07.52.1.78v.06l-.16.22ZM84.06 67.57c.06.06.12.11.17.16.01.01.02.04.02.06l.06.44c0 .04 0 .07-.03.11-.08.1-.15.2-.22.3-.01.02-.04.04-.05.03-.02 0-.03-.03-.04-.05-.03-.25-.07-.5-.09-.75 0-.03 0-.06.02-.08.05-.08.11-.15.16-.22ZM82.42 70.3l-.28-.21c.05-.07.11-.15.17-.22 0-.01.04-.02.04-.02.01 0 .03.03.03.05l.03.26c0 .04 0 .08.01.13 0 0-.01 0-.02.01ZM84.28 67.77c.1.06.19.12.29.18l-.16.22c-.02.03-.06.02-.07-.01-.02-.12-.04-.25-.05-.38Z"
								className="knight_path_8"
							/>
						</g>
						<g className="knight_path_5">
							<path
								d="M73.9 71.03c.29-.25.55-.51.8-.79l.09.09 4.83 4.92c.88.9 1.76 1.79 2.64 2.69.4.41.78.85 1.12 1.32.36.5.69 1.02.98 1.56.02.04.04.07.06.11v.02c-.01 0-.03 0-.04-.01-.38-.23-.76-.46-1.13-.7-.42-.28-.82-.59-1.2-.94-.26-.24-.52-.48-.76-.74-2.44-2.49-4.89-4.98-7.33-7.47l-.06-.06Zm9.71 9.1h.01c0-.01-.01-.03-.03-.04-.13-.16-.26-.32-.4-.47l-7.68-7.83-.19-.19c-.02-.02-.04-.04-.06-.04h-.07v.08c.02.03.05.06.07.08l7.79 7.94c.16.16.34.31.51.46 0 0 .02.01.03.02ZM73.6 69.92l.15-.15c.04-.03.08-.07.13-.09.14-.05.24-.15.35-.23.2-.16.41-.31.66-.4.19-.07.37-.1.56 0 .07.04.14.09.2.15.05.04.04.08-.02.09-.27.08-.5.22-.69.42-.1.1-.17.22-.24.34-.05.09-.11.19-.19.27-.17.18-.34.35-.52.51-.08.07-.17.14-.26.18-.39.19-.64.5-.79.9v.02c-.02.06-.06.06-.1.02-.21-.23-.24-.48-.13-.76.08-.21.21-.4.35-.58.07-.08.14-.16.21-.25.02-.02.03-.04.04-.07.04-.12.12-.22.22-.3l.07-.07ZM71.13 67.38c-.1.09-.19.18-.32.23-.36.13-.7-.12-.69-.5 0-.05 0-.11-.03-.15-.1-.18-.05-.42.13-.55.16-.12.32-.14.5-.05.04.02.09.03.14.03.14 0 .27.03.37.13.18.17.21.45.07.66-.05.08-.12.14-.17.21ZM72.33 69.15c-.05-.05-.1-.1-.15-.16-.01-.02-.03-.05-.02-.06 0-.02.04-.03.06-.03.29 0 .59 0 .88.01.03 0 .06.02.08.03l.3.3c.02.02.02.05.03.07-.02 0-.05.02-.07.02h-.87c-.04 0-.07-.01-.1-.04-.04-.05-.09-.09-.14-.14ZM71.88 68.68l-.15-.15c-.02-.02-.02-.05-.03-.07.02 0 .05-.03.07-.03.29 0 .57 0 .86.01.03 0 .06.02.08.03l.3.3c.02.02.03.05.03.07 0 .01-.04.03-.06.03h-.88c-.02 0-.05-.01-.06-.03l-.15-.15ZM72.39 68.16l.15.15c.01.01.03.05.02.06a.09.09 0 0 1-.07.03H71.66a.16.16 0 0 1-.11-.05c-.09-.09-.18-.19-.27-.28-.02-.02-.02-.05-.04-.07.03-.01.06-.03.08-.03h.81c.03 0 .07.02.1.04.05.04.1.1.15.15ZM73.83 69.6c-.07.06-.13.12-.19.18-.02.02-.05.03-.07.03h-.56c-.04 0-.07-.01-.1-.04-.09-.09-.18-.18-.27-.28-.02-.02-.03-.05-.04-.07.03-.01.06-.03.09-.03h.86c.02 0 .05 0 .07.02l.21.21ZM70.9 67.67c.07-.06.14-.12.21-.17.02-.01.04-.01.07-.01h.49c.05 0 .08.01.11.05.09.1.19.19.29.29.01.02.03.05.03.06-.01.02-.04.03-.06.03h-.83c-.03 0-.06-.02-.09-.04l-.21-.21ZM73.56 69.87l-.27.27c-.07-.07-.14-.14-.21-.22-.01-.01-.02-.04-.01-.05.01-.01.04-.03.06-.03h.43v.02ZM71.16 67.46c.09-.1.17-.19.25-.29l.21.21c.03.03 0 .07-.03.07h-.42Z"
								className="knight_path_8"
							/>
						</g>
						<circle cx={65.44} cy={68.94} r={0.41} className="knight_path_6" />
						<ellipse
							cx={76.79}
							cy={61.47}
							className="knight_path_6"
							rx={0.41}
							ry={0.42}
						/>
						<circle cx={89.03} cy={67.17} r={0.41} className="knight_path_6" />
						<circle cx={91.46} cy={66.15} r={0.37} className="knight_path_6" />
						<circle cx={93.81} cy={65.25} r={0.37} className="knight_path_6" />
						<path
							d="M96.23 64.37c0 .19-.15.35-.35.35a.348.348 0 0 1-.1-.68c.15.08.29.15.43.23.02.03.02.06.02.1Z"
							className="knight_path_6"
						/>
						<circle cx={62.09} cy={68.34} r={0.41} className="knight_path_6" />
						<circle cx={58.29} cy={67.72} r={0.51} className="knight_path_6" />
						<circle cx={54.84} cy={67.24} r={0.51} className="knight_path_6" />
						<circle cx={51.2} cy={66.86} r={0.57} className="knight_path_6" />
						<path
							d="M48.35 66.66c0 .32-.25.58-.57.58-.27 0-.49-.18-.55-.42.17-.18.38-.37.63-.57.04-.04.09-.07.14-.11.21.08.35.29.35.52Z"
							className="knight_path_6"
						/>
						<path
							d="M78.85 65.07s1.8 12.57.58 19.01c0 0 5.36-9.51-.58-19.01Z"
							style={{
								fill: '#d7f1ff',
								mixBlendMode: 'screen',
								opacity: 0.21
							}}
						/>
						<path
							d="m75.54 85.63-5.45-3.08a4.695 4.695 0 0 1-2.37-3.79l-.97-14.61c.19-.37.32-.38.35-.39 1.03-.17 2.13-.32 3.31-.45 1.18-.13 2.43-.23 3.75-.28-1.47 2.58-4.41 10.1 1.38 22.6Z"
							style={{
								mixBlendMode: 'overlay',
								opacity: 0.3
							}}
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
);
export const AvatarAccessorySherifSvg = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 200" {...props}>
		<defs>
			<style>
				{
					'.sherif_path_1{fill:#f9d10d}.sherif_path_2{fill:#fff}.sherif_path_4{isolation:isolate}'
				}
			</style>
		</defs>
		<g className="sherif_path_4">
			<g id="Layer_2">
				<g id="Accessory">
					<g id="sherif_star">
						<path
							d="M70.98 68.93c-.09.42-.48.7-.9.63-.1-.01-.15.01-.2.08l-2.53 2.86c-.08.08-.09.14-.03.24.64 1.1 1.27 2.19 1.91 3.29.04.09.09.13.2.14.41.02.73.36.74.78 0 .42-.3.78-.73.83-.4.04-.78-.24-.85-.65-.02-.12-.07-.18-.18-.23-1.14-.49-2.28-1-3.41-1.51-.11-.04-.17-.04-.25.05-.83.95-1.67 1.9-2.51 2.85-.06.07-.09.12-.06.23.11.4-.11.83-.49.96-.41.14-.85-.04-1.01-.43a.803.803 0 0 1 .36-1.04c.08-.04.11-.08.12-.16.12-1.29.25-2.58.38-3.86 0-.09-.02-.13-.1-.17l-3.51-1.56c-.07-.03-.12-.04-.19.01a.8.8 0 0 1-1.09-.18c-.25-.33-.2-.81.12-1.09.31-.28.78-.27 1.09.04.06.06.11.07.19.05 1.25-.27 2.5-.55 3.74-.82.1-.02.13-.06.14-.15.12-1.28.25-2.55.38-3.83.01-.09-.01-.15-.08-.2a.813.813 0 0 1-.16-1.1.802.802 0 0 1 1.37.83c-.04.09-.04.14.01.22.64 1.1 1.28 2.21 1.92 3.32.05.09.11.1.2.08.62-.14 1.25-.27 1.87-.41l1.83-.39c.09-.02.15-.05.18-.15.16-.41.59-.62.99-.48.39.13.62.54.54.94Z"
							style={{
								fill: '#edc10c'
							}}
						/>
						<path
							d="M67.44 68.91c.61-.13 1.22-.27 1.83-.4.09-.02.15-.05.19-.15.15-.4.58-.6.99-.47.39.13.62.53.54.93-.09.41-.48.68-.9.62-.09-.01-.14.01-.2.08-.84.95-1.68 1.89-2.53 2.83-.07.08-.08.14-.03.24.64 1.09 1.27 2.18 1.91 3.27.05.08.1.13.2.13.41.02.73.36.74.77.01.42-.3.77-.73.82a.796.796 0 0 1-.85-.64c-.02-.12-.07-.18-.19-.23-1.14-.5-2.28-1-3.41-1.5-.1-.05-.16-.05-.25.05-.83.94-1.67 1.88-2.51 2.81-.06.07-.09.13-.06.23.11.4-.11.82-.49.95-.41.14-.85-.04-1.01-.42-.17-.4-.02-.83.36-1.03.07-.04.11-.08.12-.17.13-1.27.25-2.55.38-3.82 0-.09-.02-.13-.1-.16-1.17-.51-2.35-1.03-3.52-1.55a.186.186 0 0 0-.19.01.8.8 0 0 1-.98-1.26c.31-.28.78-.26 1.09.04.06.06.11.07.19.06l3.74-.81c.09-.02.12-.06.13-.15.12-1.26.25-2.53.38-3.79 0-.09 0-.14-.08-.2a.79.79 0 0 1-.16-1.08c.24-.34.7-.44 1.06-.23.36.22.5.67.31 1.05-.04.08-.03.14.01.21.64 1.1 1.28 2.19 1.92 3.29.05.09.11.1.2.08.62-.14 1.25-.27 1.87-.41Zm2.92-.87a.628.628 0 0 0-.78.48c-.02.09-.06.11-.14.13-.66.14-1.32.29-1.99.43-.65.14-1.3.28-1.95.43-.12.03-.17 0-.23-.1-.67-1.16-1.35-2.32-2.03-3.47-.05-.09-.05-.14.01-.23.2-.29.11-.68-.19-.87a.619.619 0 0 0-.69.01c-.07.04-.13.1-.18.18-.18.3-.1.69.21.88.08.04.1.09.09.18-.14 1.34-.27 2.68-.41 4.03-.01.09-.03.14-.14.16-1.32.28-2.64.57-3.95.86-.09.02-.14.01-.2-.07a.613.613 0 0 0-.9-.09.62.62 0 0 0-.08.88c.22.27.62.31.89.07.07-.06.12-.06.19-.03 1.25.55 2.49 1.1 3.73 1.64.08.04.11.08.1.17-.14 1.35-.27 2.7-.4 4.05-.01.09-.04.13-.12.16a.62.62 0 0 0-.38.8c.12.34.48.5.81.38.33-.13.5-.5.36-.83-.03-.09-.03-.14.04-.21l2.68-3.01c.07-.08.13-.1.22-.05.2.09.41.18.61.27 1.02.45 2.03.89 3.05 1.34.1.04.15.08.16.21a.6.6 0 0 0 .68.58c.34-.03.59-.32.57-.66a.625.625 0 0 0-.68-.59c-.1.01-.13-.03-.17-.1-.68-1.17-1.36-2.34-2.05-3.5-.05-.09-.04-.13.02-.2l1.29-1.44c.48-.53.95-1.07 1.43-1.61.05-.06.09-.07.17-.05.36.1.7-.09.79-.44a.633.633 0 0 0-.44-.77Z"
							className="sherif_path_1"
						/>
						<path
							d="M67.51 69.25c.7-.15 1.4-.31 2.1-.45.09-.02.13-.04.13-.15 0-.23.15-.39.36-.44.2-.04.4.04.5.22.1.18.08.41-.07.56a.44.44 0 0 1-.55.08c-.09-.06-.13-.01-.18.05-.5.57-1.01 1.14-1.51 1.71-.45.51-.9 1.01-1.36 1.51-.07.07-.07.13-.02.21.73 1.24 1.45 2.48 2.17 3.72.04.07.07.11.17.07.2-.07.41.03.52.2.11.18.09.41-.06.56-.14.15-.36.19-.54.11a.457.457 0 0 1-.26-.5c.03-.11-.02-.14-.1-.18-1.3-.57-2.61-1.14-3.91-1.72-.11-.05-.17-.03-.24.06-.94 1.06-1.89 2.13-2.84 3.19-.06.07-.09.12-.02.21.13.17.1.4-.03.56-.13.15-.35.2-.54.12a.476.476 0 0 1-.28-.49c.03-.21.18-.37.4-.4.09-.01.11-.04.12-.12.14-1.44.29-2.88.43-4.32.01-.1-.03-.13-.11-.17-.66-.29-1.32-.57-1.98-.86-.66-.29-1.31-.58-1.96-.87-.08-.04-.13-.04-.19.04-.12.17-.36.22-.54.14a.458.458 0 0 1-.28-.47c.02-.2.16-.37.36-.41.21-.05.42.04.51.24.05.1.1.11.2.09 1.39-.31 2.78-.61 4.17-.91.11-.02.15-.06.16-.18.14-1.43.28-2.86.43-4.29 0-.09-.02-.12-.1-.15a.435.435 0 0 1-.3-.47c.02-.2.16-.37.36-.42.2-.05.41.05.51.23.1.19.08.4-.08.55-.08.07-.07.12-.02.19.72 1.24 1.45 2.47 2.16 3.71.06.1.11.12.22.1.69-.16 1.39-.31 2.09-.46Z"
							className="sherif_path_1"
						/>
						<g className="sherif_path_4">
							<path
								d="m61.7 72.5.02.07c.01.05.08.07.16.05s.13-.06.12-.11c-.02-.08-.13-.08-.25-.1-.15-.02-.29-.06-.33-.25-.05-.22.12-.33.3-.37s.35 0 .38.12l.03.15-.22.05v-.06s-.08-.05-.14-.04c-.06.01-.1.04-.09.09.01.07.1.08.2.09.16.02.33.05.37.24.05.23-.13.36-.32.4s-.39 0-.42-.17l-.03-.13.22-.05ZM62.39 72.54l.11-.02-.14-.64-.11.02-.04-.18.47-.1.04.18-.11.02.05.22.36-.08-.05-.22-.11.02-.04-.18.48-.1.04.18-.11.02.14.64.11-.02.04.18-.48.1-.04-.18.11-.02-.05-.22-.36.08.05.22.11-.02.04.18-.47.1-.04-.18ZM63.61 72.28l.11-.02-.14-.64-.11.02-.04-.18.77-.16.06.3-.21.04-.02-.1-.2.04.04.2.29-.06.04.2-.29.06.04.21.22-.05-.02-.1.21-.04.06.3-.79.17-.04-.18ZM64.54 72.08l.11-.02-.14-.64-.11.02-.04-.18.45-.1c.08-.02.14-.03.2-.02.13.01.23.09.26.24a.31.31 0 0 1-.1.31s.04.01.07.05l.11.13s.04.03.07.02h.04l.04.17-.17.04c-.08.02-.12 0-.16-.04l-.17-.21s-.04-.04-.1-.02h-.05l.04.18.11-.02.04.18-.47.1-.04-.18Zm.4-.47c.08-.02.12-.07.1-.16 0-.05-.03-.09-.08-.1h-.1l-.09.02.05.26.11-.02ZM65.58 71.86l.11-.02-.14-.64-.11.02-.04-.18.47-.1.04.18-.11.02.14.64.11-.02.04.18-.47.1-.04-.18ZM66.19 71.73l.11-.02-.14-.64-.11.02-.04-.18.75-.16.06.3-.21.04-.02-.09-.17.04.05.22.29-.06.04.2-.29.06.04.2.13-.03.04.18-.49.1-.04-.18Z"
								className="sherif_path_2"
							/>
						</g>
						<path
							d="M70.8 68.81c-.09.35-.43.54-.79.44-.08-.02-.12 0-.17.05-.48.54-.95 1.08-1.43 1.61l-1.29 1.44c-.06.07-.07.11-.02.2.69 1.16 1.37 2.33 2.05 3.5.04.07.07.11.17.1.36-.03.65.23.68.59.02.34-.23.63-.57.66a.6.6 0 0 1-.68-.58c-.01-.13-.06-.17-.16-.21-1.02-.45-2.03-.89-3.05-1.34 0-.06 0-.12-.01-.19-.12-2.27-.53-5.18-1.65-7.72-.01-.02-.02-.03-.02-.04-.25-.55-.53-1.08-.84-1.58-.17-.26-.34-.52-.55-.76a.285.285 0 0 0-.1-.13c.2-.14.47-.15.69-.01.3.19.39.58.19.87-.06.09-.06.14-.01.23.68 1.15 1.36 2.31 2.03 3.47.06.1.11.13.23.1.65-.15 1.3-.29 1.95-.43.67-.14 1.33-.29 1.99-.43.08-.02.12-.04.14-.13.09-.37.43-.57.78-.48.33.09.53.44.44.77Z"
							style={{
								fill: '#d7f1ff',
								mixBlendMode: 'screen',
								opacity: 0.21
							}}
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
);
export const AvatarAccessorySwordSvg = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 200" {...props}>
		<defs>
			<style>
				{
					'.sword_path_6{fill:#5b3801}.sword_path_7{fill:#dbdbdb}.sword_path_10{opacity:.2}.sword_path_10,.sword_path_11{mix-blend-mode:overlay}.sword_path_14{fill:#d7f1ff;mix-blend-mode:screen;opacity:.21}.sword_path_11{stroke-width:.24px;fill:none;stroke:#282828;stroke-linecap:round;stroke-miterlimit:10}.sword_path_17{fill:#e5e5e5}.sword_path_18{fill:#6b4400}'
				}
			</style>
		</defs>
		<g
			style={{
				isolation: 'isolate'
			}}
		>
			<g id="Layer_2">
				<g id="Accessory">
					<g id="sword">
						<path
							d="M57.73 60.84c-.22.4-.4.83-.5 1.28.04.02.09.04.17.07-.04.09-.06.18-.08.27-.03.11-.05.22-.07.33l-.12.03h-.04c-.27.07-.53.14-.79.22-.27.07-.53.15-.79.23l-.5.15c-.52.15-1.02.32-1.51.48-.16.05-.33.11-.49.16H53s-.09.04-.14.05-.03.01-.04.02h-.06c-.23.04-.5.09-.79.15h-.01c-.12.03-.24.05-.37.09-.6.15-1.23.37-1.69.73-.7.56-1.2 1.15-1.55 1.62-1.01.68-1.97 1.36-2.87 2.05-.01-.01-.02-.02-.03-.02-.19-.1-.38-.19-.56-.27-.49.24-1.09.57-1.74 1.03L33.1 59.17l-.69-.71-.3-.31-.11-.1-1.81-1.87 7.33-6.91 4.94-4.66.02.03 1.9 1.94.3.32h.01l13.23 13.62c-.07.1-.13.2-.19.3ZM126.75 131.36l-.04 11.35v.55l-12.23-.34-4.11-4.23c-.49-5.79-1.24-11.22-2.18-16.25.11-.1.22-.21.33-.31 0-.25-.01-.5-.03-.76-.05-1.37-.19-2.92-.49-4.64s-.03-.01-.03-.01c-.16-.95-.37-1.96-.65-3-.34-1.28-.73-2.45-1.14-3.52l.04.04 5.51 5.67 1.43 1.47 3.73 3.83 1.09 1.13h.01l1.99 2.06h.01l5.37 5.53 1.39 1.43Z"
							className="sword_path_7"
						/>
						<path
							d="M57.73 60.84c-.22.4-.4.83-.5 1.28.04.02.09.04.17.07-.04.09-.06.18-.08.27-.03.11-.05.22-.07.33l-.12.03h-.04c-.27.07-.53.14-.79.22-.27.07-.53.15-.79.23l-.5.15c-.52.15-1.02.32-1.51.48-.16.05-.33.11-.49.16H53s-.09.04-.14.05-.03.01-.04.02h-.06c-.23.04-.5.09-.79.15h-.01c-.12.03-.24.05-.37.09-.08-.07-.15-.14-.22-.22-.49-.52-.96-1.02-1.43-1.51-.58-.62-1.16-1.22-1.71-1.8l-1.61-1.7c-2.35-2.5-4.35-4.63-5.87-6.26-.2-.21-.4-.42-.58-.62a6.39 6.39 0 0 1-.36-.39c-.05-.05-.09-.1-.13-.14-.06-.07-.12-.13-.17-.19-1.28-1.38-1.99-2.2-1.99-2.27.28-.15 3.34-3.07 4.96-4.63l1.89 1.95.31.31h.01l13.23 13.62c-.07.1-.13.2-.19.3ZM126.75 131.36l-.04 11.35c-1.01-1.63-2.34-3.75-3.52-5.57-1.39-2.17-2.57-3.89-2.72-3.81-.07 0-.95-.86-2.45-2.38l-2.01-2.04c-.36-.36-.73-.73-1.1-1.13-1.11-1.13-2.36-2.41-3.73-3.81-.65-.68-1.57-1.57-2.69-2.6-.05-1.37-.19-2.92-.49-4.64s-.03-.01-.03-.01c-.16-.95-.37-1.96-.65-3-.34-1.28-.73-2.45-1.14-3.52l.04.04 5.51 5.67 1.43 1.47 3.73 3.83 1.09 1.13h.01l1.99 2.06h.01l5.37 5.53 1.39 1.43Z"
							className="sword_path_17"
						/>
						<path
							d="M47.6 34.06h-.01Z"
							style={{
								fill: '#664600'
							}}
						/>
						<path
							d="m21.38 27.53-.2 6.81-3.38-.1-3.44-.1.06-1.97.14-4.82.01-.03 6.81.21z"
							style={{
								fill: '#ff9100',
								isolation: 'isolate'
							}}
						/>
						<path
							d="m19.04 33.77-1.24.47-3.44-.1.06-1.97.85 1.11 3.77.49z"
							className="sword_path_10"
						/>
						<path
							d="m21.38 27.53-.12 4.01-.92 1.01-2.02-3.11-3.76-2.09.01-.03 6.81.21z"
							className="sword_path_14"
						/>
						<path
							d="M24.65 29.37h5.02v22.64h-5.02z"
							style={{
								fill: '#282828',
								isolation: 'isolate'
							}}
							transform="rotate(-43.3 27.156 40.685)"
						/>
						<path
							d="M45.33 47.68a52.176 52.176 0 0 1-4.58 5.22c-.33.35-.69.69-1.05 1.03a51.04 51.04 0 0 1-6.6 5.26l-.69-.71-.3-.31-.11-.1c2.26-1.52 4.49-3.26 6.63-5.28.36-.34.72-.68 1.05-1.04 1.7-1.69 3.23-3.43 4.57-5.21l1.08 1.14Z"
							style={{
								mixBlendMode: 'overlay'
							}}
						/>
						<path
							d="m53.13 40.62-2.14-1.03c-.33.42-.68.85-1.03 1.28-3.08 3.8-6.79 7.9-11.18 12.03-4.94 4.65-9.75 8.43-14.09 11.48l.88 2.13c.12.3-.17.59-.47.49-5.32-1.79-5.24-6.15-5.24-6.15 3.81-4.47 8.28-9.24 13.44-14.1 2.24-2.11 4.47-4.09 6.64-5.93 2.68-2.28 5.3-4.36 7.82-6.27h.01c.3.02 4.44.39 5.84 5.7.07.27-.22.5-.47.38Z"
							style={{
								fill: '#ef8200'
							}}
						/>
						<path
							d="m53.6 40.45-2.78-1.33c-.34.43-.69.86-1.05 1.29-3.13 3.84-6.89 7.99-11.33 12.18-5 4.71-9.87 8.54-14.26 11.64l.07.17 1.09 2.68c-6.12-1.58-6.01-6.38-6.01-6.38a180.127 180.127 0 0 1 13.63-14.26c2.27-2.14 4.52-4.14 6.72-6 2.71-2.31 5.37-4.42 7.91-6.36h.01c.32.02 4.81.4 5.99 6.38Z"
							style={{
								fill: '#ff9100'
							}}
						/>
						<path
							d="m22.83 32.44 10.4 11.04c-.55.77-1.26 1.6-2.14 2.43-.47.44-.94.81-1.39 1.15L18.84 35.54c1.26-.78 2.69-1.79 3.98-3.09Z"
							style={{
								fill: '#c93400'
							}}
						/>
						<path
							d="M20.7 37.32c1.26-.45 2.9-1.27 4.02-2.7M22.41 39.14c1.11-.67 2.53-1.78 3.38-3.39M27.87 37.96c-.29 1.95-1.4 3.56-2.26 4.57M28.47 38.59c-.13 2.04-1.18 3.78-2 4.85M27.89 44.94c1.18-.54 2.75-1.47 3.77-2.96M28.76 45.87c1.18-.54 2.75-1.47 3.77-2.96"
							className="sword_path_11"
						/>
						<path
							d="M23.09 39.86c1.07-.77 2.39-2.02 3.07-3.71"
							style={{
								strokeWidth: '.15px',
								fill: 'none',
								stroke: '#282828',
								strokeLinecap: 'round',
								strokeMiterlimit: 10,
								mixBlendMode: 'overlay'
							}}
						/>
						<path
							d="m53.6 40.45-2.78-1.33c-.34.43-.69.86-1.05 1.29-1.23-2.72-5.45-1.92-10.1.02 2.71-2.31 5.37-4.42 7.91-6.36h.01c.32.02 4.81.4 5.99 6.38Z"
							className="sword_path_14"
						/>
						<path
							d="m17.58 34.177.743-.7 13.353 14.17-.743.7z"
							className="sword_path_10"
						/>
						<path
							d="m19.92 31.966 1.31-1.235 13.353 14.17-1.31 1.235zM48.93 51.51l3.3 3.5-2.29 7.66c-1.17-1.24-2.28-2.4-3.31-3.5l2.31-7.66ZM57.23 62.12s.09.04.17.07c-.04.09-.06.18-.08.27-.03.11-.05.22-.07.33l-.12.03h-.04c-.27.07-.53.14-.79.22-.27.07-.53.15-.79.23l-.5.15c-.52.15-1.02.32-1.51.48-.16.05-.33.11-.49.16H53s-.09.04-.14.05-.03.01-.04.02h-.06c-.23.04-.5.09-.79.15h-.01c-.12.03-.24.05-.37.09-.08-.07-.15-.14-.22-.22l2.29-7.64 4.07 4.31c-.22.4-.4.83-.5 1.28ZM116.89 121.21l-1.98 6.57c-1.11-1.13-2.36-2.41-3.73-3.81s1.98-6.59 1.98-6.59l3.73 3.83ZM119.99 124.41l-1.97 6.54-2.01-2.04 1.98-6.56 1.99 2.05h.01ZM125.37 129.9l1.38 1.46-.04 11.35c-1.01-1.63-2.34-3.75-3.51-5.57l2.17-7.24Z"
							className="sword_path_14"
						/>
						<path
							d="m24.24 64.4 1.09 2.68c-6.12-1.58-6.01-6.38-6.01-6.38 1.03-1.2 2.09-2.41 3.21-3.65-.72 3.06-1.19 7.27 1.71 7.35Z"
							className="sword_path_10"
						/>
						<path
							d="M104.21 104.75c-.05-.1-.11-.2-.17-.3l-.01-.01C95.85 90.41 80.99 79.7 69.17 72.86h-.01a142.13 142.13 0 0 0-5.17-2.87l-.02-.01c-.42-.23-.84-.44-1.24-.65-4.13-2.14-7.46-3.63-9.37-4.45-.52-.22-.92-.39-1.22-.51.2-.07.41-.14.62-.22-.23.04-.5.09-.79.15h-.01c-.24-.1-.37-.15-.37-.15l.27-.48.15-.04.99.44h.01l.03.02.23.1 9.08 4.03 1.05.51c.14.07.29.14.46.23a506.55 506.55 0 0 1 3.93 1.91c.59.29 1.21.59 1.81.88.31.15.61.3.9.45 2.66 1.3 4.95 2.43 5 2.48.13.13 19.67 15.13 19.95 15.16.21.02 5.67 8.07 8.31 11.97l.45 2.94Z"
							style={{
								fill: '#7a4f03'
							}}
						/>
						<path
							d="m104.21 104.75-.45-2.94-.17-1.09c-.08-12.82-16.42-24.03-29.68-31.02-.32-.17-.65-.33-.97-.5-.52-.27-1.04-.54-1.55-.8-.15-.07-.3-.14-.44-.22-1.14-.56-2.23-1.09-3.28-1.59-.18-.08-.36-.17-.53-.25-3.2-1.49-5.89-2.62-7.66-3.34-.47-.19-.88-.35-1.21-.47-.39-.16-.69-.27-.87-.34-.08-.03-.13-.05-.17-.07-.03 0-.04-.01-.04-.01l-5.18 1.52-.15.04c.15.07.3.13.44.2.18.08.37.17.55.25h.01l.01.01c.14.06.28.13.42.19 3.43 1.57 6.64 3.15 9.63 4.72 2.37 1.24 4.62 2.48 6.73 3.7 26.21 15.21 33.16 28.86 34.38 31.7l.01.01c.11.26.17.43.2.5l-.03-.2ZM79.84 75.59c.09-.14.41-.11.73.07.31.19.51.45.42.6-.08.15-.42.12-.73-.06-.32-.19-.51-.46-.42-.61Zm5.66 3.73c.1-.14.42-.07.71.15.3.21.47.5.36.64-.1.14-.43.07-.72-.15-.3-.21-.45-.5-.35-.64Zm4.74 3.84c.11-.13.42-.03.7.21.27.24.41.54.3.67-.12.13-.44.03-.71-.21-.28-.24-.41-.54-.29-.67Zm5.44 4.47c.24.29.33.61.2.72s-.44-.04-.67-.32c-.23-.28-.32-.6-.18-.71.13-.11.42.03.65.31Zm4.06 4.98c.2.3.26.63.12.72-.14.1-.43-.07-.63-.38-.21-.3-.26-.63-.11-.72.14-.1.41.07.62.38ZM74.67 72.15c.33.16.55.42.47.57-.07.15-.41.15-.74-.02-.33-.16-.53-.42-.46-.57.08-.15.41-.14.73.02Zm-6.31-3.23c-.07.16-.41.15-.74-.02-.33-.16-.53-.41-.45-.57.07-.15.4-.14.73.02.33.16.54.42.46.57Zm-8.11-3.97c.33.16.54.41.46.57-.07.15-.41.14-.74-.02s-.53-.42-.45-.57c.07-.16.4-.15.73.02Z"
							style={{
								fill: '#8c5d00'
							}}
						/>
						<path
							d="M73.88 69.05c-1.28-.85-4.7-2.41-5.85-2.89-.24-.1-.58-.02-.8.12l-4.37 2.8c-.21.13-.16.44.07.52 3.86 1.34 5.39 2.55 5.93 3.1.19.19.48.22.71.09 1.08-.62 3.38-2.36 4.32-3.07.23-.17.22-.51-.01-.67Zm-1.06.41c-.76.57-2.63 1.97-3.51 2.47a.47.47 0 0 1-.57-.07c-.44-.44-1.68-1.42-4.81-2.5a.232.232 0 0 1-.05-.42l3.54-2.26c.17-.11.39-.13.58-.05.93.39 3.78 1.73 4.81 2.42.19.12.19.27 0 .41Z"
							className="sword_path_6"
						/>
						<path
							d="M74.75 72c-.39-.2-.79-.18-.89 0-.1.21.14.53.53.72.39.19.79.18.89-.02.09-.2-.14-.52-.53-.71Zm.39.72c-.07.15-.41.15-.74-.02-.33-.16-.53-.42-.46-.57.08-.15.41-.14.73.02.33.16.55.42.47.57ZM67.97 68.2c-.39-.2-.79-.18-.88.01-.1.21.13.53.52.72.39.2.79.18.89-.02.1-.2-.14-.52-.53-.71Zm.39.72c-.07.16-.41.15-.74-.02-.33-.16-.53-.41-.45-.57.07-.15.4-.14.73.02s.54.42.46.57ZM60.32 64.79c-.39-.19-.79-.18-.88.02-.1.2.13.52.52.72.39.19.79.18.89-.02.1-.2-.14-.52-.53-.72Zm.39.73c-.07.15-.41.14-.74-.02s-.53-.42-.45-.57c.07-.16.4-.15.73.02.33.16.54.41.46.57ZM80.65 75.51c-.38-.21-.77-.23-.88-.04-.12.2.09.53.47.75.38.22.78.24.89.04.11-.19-.1-.53-.48-.75Zm.34.75c-.08.15-.42.12-.73-.06-.32-.19-.51-.46-.42-.61.09-.14.41-.11.73.07.31.19.51.45.42.6ZM86.31 79.33c-.35-.26-.74-.32-.87-.14-.14.18.04.54.39.8.35.26.75.31.88.13s-.04-.53-.4-.79Zm.26.78c-.1.14-.43.07-.72-.15-.3-.21-.45-.5-.35-.64.1-.14.42-.07.71.15.3.21.47.5.36.64ZM91.05 83.24c-.33-.29-.71-.38-.86-.22-.15.17-.01.55.32.83.32.29.71.39.86.22.15-.17 0-.54-.32-.83Zm.19.8c-.12.13-.44.03-.71-.21-.28-.24-.41-.54-.29-.67.11-.13.42-.03.7.21.27.24.41.54.3.67ZM95.82 87.52c-.28-.33-.65-.48-.82-.34-.17.14-.09.53.19.87.28.33.64.49.82.34.17-.14.09-.53-.19-.87Zm.06.83c-.13.11-.44-.04-.67-.32-.23-.28-.32-.6-.18-.71.13-.11.42.03.65.31.24.29.33.61.2.72ZM99.88 92.51c-.24-.36-.59-.55-.78-.42-.18.12-.14.52.1.88.25.36.6.55.79.42.18-.12.14-.52-.11-.88Zm-.02.82c-.14.1-.43-.07-.63-.38-.21-.3-.26-.63-.11-.72.14-.1.41.07.62.38.2.3.26.63.12.72Z"
							className="sword_path_18"
						/>
						<path
							d="M71.32 67.94c-.07.01-4.37 3.03-4.37 3.03l.37.21 4.49-3.07-.49-.18Z"
							className="sword_path_6"
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
);
export const AvatarAccessoryList: AvatarAccessorySvg[] = [
	{
		name: AvatarAccessory.CAPE,
		component: <AvatarAccessoryCapeSvg key={'avatar_accessory_cape'} />
	},
	{
		name: AvatarAccessory.TIE,
		component: <AvatarAccessoryTieSvg key={'avatar_accessory_tie'} />
	},
	{
		name: AvatarAccessory.DIVING_MASK,
		component: <AvatarAccessoryDivingMaskSvg key={'avatar_accessory_mask'} />
	},
	{
		name: AvatarAccessory.ANGEL,
		component: <AvatarAccessoryAngelSvg key={'avatar_accessory_angel'} />
	},
	{
		name: AvatarAccessory.SPACE_BAG,
		component: <AvatarAccessoryBagSvg key={'avatar_accessory_bag'} />
	},
	{
		name: AvatarAccessory.BLACK_BELT,
		component: <AvatarAccessoryBlackBeltSvg key={'avatar_accessory_black_belt'} />
	},
	{
		name: AvatarAccessory.BOB,
		component: <AvatarAccessoryBobSvg key={'avatar_accessory_bob'} />
	},
	{
		name: AvatarAccessory.BOW_TIE,
		component: <AvatarAccessoryBowTieSvg key={'avatar_accessory_bow_tie'} />
	},
	{
		name: AvatarAccessory.CAP,
		component: <AvatarAccessoryCapSvg key={'avatar_accessory_cap'} />
	},
	{
		name: AvatarAccessory.LEAF,
		component: <AvatarAccessoryLeafSvg key={'avatar_accessory_leaf'} />
	},
	{
		name: AvatarAccessory.HAT,
		component: <AvatarAccessoryHatSvg key={'avatar_accessory_hat'} />
	},
	{
		name: AvatarAccessory.RED_CAP,
		component: <AvatarAccessoryRedCapSvg key={'avatar_accessory_red_cap'} />
	},
	{
		name: AvatarAccessory.SCARF,
		component: <AvatarAccessoryScarfSvg key={'avatar_accessory_scarf'} />
	},
	{
		name: AvatarAccessory.TSHIRT,
		component: <AvatarAccessoryTshirtSvg key={'avatar_accessory_tshirt'} />
	},
	{
		name: AvatarAccessory.ALIEN,
		component: <AvatarAccessoryAlienSvg key={'avatar_accessory_alien'} />
	},
	{
		name: AvatarAccessory.TUTU,
		component: <AvatarAccessoryDanceDressSvg key={'avatar_accessory_tutu'} />
	},
	{
		name: AvatarAccessory.HEADSET,
		component: <AvatarAccessoryHeadsetSvg key={'avatar_accessory_headset'} />
	},
	{
		name: AvatarAccessory.BAT,
		component: <AvatarAccessoryBatSvg key={'avatar_accessory_bat'} />
	},
	{
		name: AvatarAccessory.PIRATE,
		component: <AvatarAccessoryPirateSvg key={'avatar_accessory_pirate'} />
	},
	{
		name: AvatarAccessory.COOKER,
		component: <AvatarAccessoryCookerSvg key={'avatar_accessory_cooker'} />
	},
	{
		name: AvatarAccessory.APRON,
		component: <AvatarAccessoryApronSvg key={'avatar_accessory_apron'} />
	},
	{
		name: AvatarAccessory.KNIGHT,
		component: <AvatarAccessoryKnightSvg key={'avatar_accessory_knight'} />
	},
	{
		name: AvatarAccessory.SHERIF,
		component: <AvatarAccessorySherifSvg key={'avatar_accessory_serif'} />
	},
	{
		name: AvatarAccessory.SWORD,
		component: <AvatarAccessorySwordSvg key={'avatar_accessory_sword'} />
	}
];

export const AvatarColorList = [
	'#FE757D',
	'#0BE3CD',
	'#329E51',
	'#4B9CFF',
	'#f79637',
	'#8b2442',
	'#ffaaed',
	'#818586',
	'#2D2D2D',
	'#9F75FC',
	'#F9EE7C',
	'#D60D56',
	'#5E2800'
];

export const ChestAccessorieColorList = ['red'];

// LOGO

export const CMACGMLogo = (props: SVGProps<SVGSVGElement>) => (
	<svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1010.17 616.18" {...props}>
		<defs>
			<style>{'.cls-1{fill:#fff}'}</style>
		</defs>
		<g id="Layer_1-2">
			<path
				className="cls-1"
				d="M460.27 616.04c-7.5 0-15.02.35-22.49-.07-15.75-.9-31.47-2.33-46.68-6.94-4.7-1.43-5.54-3.25-2.39-6.75 10.84-12.05 21.58-24.21 34.26-34.47 4.2-3.4 8.47-7.15 11.74-11.2 7.42-9.19 16.42-9.56 26.47-7.38 11.68 2.53 23.55 3.49 35.37 4.89 11.92 1.42 23.87 2.24 35.83 2.8 9.97.47 20.01.48 29.97-.16 19.12-1.22 38.22-2.31 57.24-5.46 24.87-4.12 49.22-9.82 72.98-18.12 25.53-8.91 49.82-20.31 72.84-34.67 21.65-13.5 40.72-29.86 57.97-48.43 6.51-7 12.26-14.73 17.3-22.94.73-1.19 1.36-4.28 3.66-2.92 2.24 1.32.09 3.47-.73 4.64a664.835 664.835 0 0 1-16.33 22.43c-10.49 13.79-22.06 26.66-34.62 38.59-14.13 13.41-29.11 25.81-45.01 37.1-20.62 14.65-42.32 27.48-65.21 38.22-29.08 13.63-59.04 24.8-90.17 33.03-19.91 5.26-40.06 9.02-60.26 12.61-9.94 1.77-20.18 2.13-30.21 3.42-13.86 1.78-27.69 1.68-41.56 1.78ZM559.51 69c-6.46-1.06-14.14-2.47-21.92-3.25-6.13-.61-12.18-2.1-18.32-2.65-16.37-1.45-32.74-3.04-49.14-3.76-15.03-.65-30.07.42-45.11 1.45-9.82.68-19.5 2.18-29.24 3.28-9.33 1.05-18.61 2.81-27.82 4.86-19.23 4.26-38.22 9.39-56.67 16.22-23.2 8.59-45.41 19.22-66.46 32.43-19.23 12.06-36.97 25.83-52.74 42.08-8.98 9.26-17.1 19.29-23.96 30.27-.78 1.24-1.39 3.43-3.24 2.17-1.89-1.29-.23-2.69.69-4.13 8.6-13.49 18.55-25.92 28.99-38.03 9.46-10.97 19.69-21.21 30.32-30.92 19.11-17.45 39.86-32.85 62.21-46.05 12.26-7.24 24.57-14.37 37.36-20.62 35.29-17.24 72.2-29.75 110.51-38.49 16.79-3.83 33.66-7.17 50.65-9.56 11.99-1.69 24.17-2.59 36.3-3.52 11.79-.9 23.55-.92 35.28-.62 20.28.52 40.52 2.06 60.35 6.88 5.41 1.31 6.08 3.44 2.45 7.55-16.96 19.22-35.63 36.66-55.14 53.24-1.33 1.13-2.6 1.21-5.34 1.15ZM282.87 288.93c-4.6 7.83-9.12 15.71-13.82 23.48-10.27 16.96-20.62 33.87-30.98 50.77-1.39 2.28-2.6 3.02-4.46-.05-12.7-20.95-25.65-41.75-38.35-62.7-2.35-3.88-3.97-8.21-7.49-11.96.98 30.17.26 59.65.54 89.12.02 2.58-1.08 3.02-3.29 3-7.66-.09-15.34-.29-22.99.07-4.14.2-3.98-1.89-3.97-4.8.06-38.15.04-76.31.04-114.46 0-7 .13-14-.06-20.99-.08-2.83.77-3.65 3.6-3.59 8.99.18 17.99.13 26.99.02 2.44-.03 3.63.79 4.91 3 13.45 23.29 27.09 46.47 40.71 69.67 1.59 2.71 3.1 3.25 5.01-.03 8.18-14.07 16.54-28.04 24.81-42.06 5.64-9.57 11.32-19.12 16.75-28.81.86-1.54 1.76-1.7 3.08-1.7 9.33-.01 18.66.12 27.99-.08 3.55-.08 3.06 2.02 3.06 4.18v74.98c0 19.99-.11 39.99.09 59.98.04 3.83-1.07 4.82-4.76 4.68-7.32-.28-14.67-.31-21.99 0-3.69.16-4.27-1.18-4.25-4.49.13-27.99.07-55.98.07-83.97 0-.96-.09-1.92-.14-2.87l-1.08-.36ZM978.04 289.07c-6.14 10.32-12.2 20.7-18.46 30.95-8.74 14.31-17.76 28.44-26.36 42.83-2.34 3.92-3.72 1.55-4.84-.26-6.86-11.1-13.56-22.3-20.26-33.5-7.36-12.31-14.69-24.63-21.98-36.98-.6-1.02-1.01-2.28-2.39-1.83-1.2.4-.62 1.73-.61 2.61.12 11.97.38 23.94.44 35.91.08 15.83-.05 31.66.08 47.48.03 3.12-.66 4.42-4.09 4.31-7.49-.25-15-.22-22.49-.01-3.15.09-3.87-1.04-3.86-4.02.08-45.32.09-90.63-.02-135.95 0-3.21 1.03-3.88 3.98-3.82 8.83.17 17.66.1 26.49.04 2.13-.01 3.43.42 4.67 2.57 9.5 16.46 19.22 32.8 28.92 49.14 4.11 6.93 8.54 13.69 12.43 20.75 2.22 4.04 3.1 2.91 4.94-.21 13.66-23.18 27.51-46.25 41.13-69.45 1.2-2.04 2.31-2.83 4.55-2.81 8.83.08 17.66.13 26.49-.03 2.6-.05 3.36.66 3.35 3.32-.08 45.65-.09 91.3 0 136.95 0 2.94-.95 3.58-3.68 3.52-7.66-.17-15.33-.26-22.99.03-3.73.14-4.3-1.34-4.29-4.62.06-27.15-.05-54.31-.1-81.46v-5.29l-1.06-.18ZM795.13 301.87c10.67 0 21.33.1 32-.06 3.08-.05 4.31.54 4.24 4-.23 11.99.24 24.01-.19 35.99-.35 9.72-1.79 19.33-8.06 27.46-2.91 3.78-6.84 6.06-11.06 7.68-7.81 2.98-16.11 3.91-24.38 4.02-19.33.25-38.66 0-57.99.11-11.86.06-23.01-2.31-32.09-10.3-6.91-6.09-10.53-14.33-11.43-23.43-2.14-21.87-.26-43.82-.93-65.72-.27-8.78 1.11-17.2 5.05-25 5.66-11.18 15.39-16.67 27.44-18.57 22.95-3.61 46.06-1.5 69.08-1.62 9.13-.05 18.3 1.6 27.03 5.45 10.56 4.67 14.45 13.33 16.21 23.64.66 3.85 2.94 8.85.54 11.42-2.61 2.78-7.88.77-11.97.9-5.83.19-11.66 0-17.5.08-1.91.02-2.88-.2-3.11-2.6-.68-7.24-3.04-9.16-10.34-10.33-4.62-.74-9.22-.75-13.84-.76-12-.02-24 .03-36-.02-4.63-.02-9.27.72-13.45 2.28-6.8 2.55-8.02 9.24-8.15 15.36-.38 17.82-.54 35.66 0 53.47.37 11.9 5.91 18.04 18.79 17.81 17.15-.31 34.32.02 51.48-.11 10.57-.09 13.12-4.49 13.95-13.22 1.25-13.21.92-13.24-12.38-13.24-8.67 0-17.34-.17-26 .08-3.41.1-4.19-1.06-4.06-4.23.24-5.66.22-11.34 0-16.99-.11-2.83.75-3.64 3.59-3.6 11.16.16 22.33.07 33.5.07ZM483.97 380.55c-11.43 0-22.39-.11-33.34.09-2.46.04-2.67-1.7-3.18-2.95-2.56-6.24-5.13-12.49-7.16-18.91-.67-2.14-1.46-2.58-3.32-2.58-22.82.02-45.65.04-68.47-.02-2.6 0-3.7 1.09-4.49 3.54-1.84 5.68-4.1 11.22-6.19 16.82-.98 2.63-2.27 4.24-5.67 4.12-8.99-.31-17.99-.13-26.99-.09-2.47.01-3.59.03-2.21-3.25 7.65-18.16 14.54-36.65 22.45-54.69 12.08-27.56 23.03-55.58 34.64-83.33.8-1.91 1.87-2.43 3.69-2.43 12.83.03 25.66.12 38.48-.08 2.46-.04 3.21 1.4 3.83 2.9 15.88 38.44 31.69 76.91 47.5 115.38 3.38 8.23 6.73 16.47 10.41 25.48Zm-82.05-120c-8.57 22.62-16.61 43.79-24.61 64.97-.99 2.61.42 3.05 2.7 3.04 14.98-.06 29.96-.09 44.94 0 3.49.02 3.71-.77 2.37-3.98-5.27-12.64-10.24-25.42-15.13-38.22-3.12-8.18-5.86-16.5-10.27-25.83ZM70.64 381.04c-11.09 0-20.6.35-30.08-.08-14.01-.64-26.56-4.83-34.4-17.57C2.23 357 .28 349.76.18 342.3c-.23-17.32.02-34.65-.11-51.97-.07-9.37-.51-18.76 2.29-27.86 4.5-14.57 15.29-21.86 29.58-24.35 21.57-3.77 43.38-1.75 65.07-1.65 9.4.05 19.03 1.55 27.86 5.85 10.2 4.98 13.95 13.83 15.23 24.31.08.66-.03 1.33.02 2q.67 9.25-8.61 9.25c-6.66 0-13.33.04-19.99-.04-1.28-.01-2.87.77-3.46-1.63-2.22-9.1-4.34-11.62-13.53-11.77-16.62-.27-33.3-1.3-49.88.62-10.19 1.18-13.26 7.13-13.42 14.98-.37 18.98-.24 37.98-.07 56.97.09 9.89 6.49 15.97 16.46 16.02 15.32.08 30.64.07 45.96 0 9.2-.04 12.89-3.15 14.46-12.32.35-2.05 1.46-1.83 2.75-1.83 9.16 0 18.32.05 27.48-.04 2.09-.02 3.16.46 2.84 2.75-1.31 9.44-1.03 19.2-7.91 27.18-5.06 5.88-11.4 8.78-18.67 10.27-15.06 3.07-30.31 1.71-43.9 2.01ZM600.01 381.04c-10.49 0-21.01.48-31.47-.12-13.29-.77-25.61-4.34-33.43-16.48-3.35-5.2-5.16-11.04-5.81-17.15-2.46-23.35-.68-46.78-1.03-70.16-.28-18.65 9.95-32.61 25.64-37.46 7.03-2.17 14.32-3.22 21.6-3.36 15.65-.31 31.33-.47 46.97.04 10.16.33 20.39 1.13 29.9 5.67 9.32 4.46 14.01 12.05 15.8 21.84.68 3.71 1.09 7.43.99 11.23-.05 2.16-.71 2.86-2.88 2.83-8.83-.1-17.66-.04-26.48-.05-1.31 0-2.36.18-2.76-1.85-2.12-10.74-5.05-10.71-16.19-11.56-13.75-1.05-27.63-.3-41.46-.21-3.11.02-6.3.2-9.31.91-5.24 1.23-8.98 4.72-9.78 9.99-.56 3.67-1.34 7.36-1.28 11.21.23 14.82.2 29.64.02 44.45-.05 3.84.54 7.59 1.51 11.14 2.38 8.65 6.94 10.76 14.67 10.97 15.81.43 31.65.53 47.45-.03 8.34-.3 12.31-1.6 14.27-11.36.54-2.67 1.58-2.67 3.51-2.66 8.49.04 16.99-.01 25.49.05 1.28 0 3.15-.82 3.19 1.82.17 11.24-.9 22.1-9.71 30.42-5.78 5.46-13.14 7.35-20.68 8.96-6.41 1.37-12.83.79-19.24.91-6.49.12-12.99.03-19.49.03Z"
			/>
		</g>
	</svg>
);

export const ExploreLogo = () => (
	<img src={logo} style={{ height: '130px', width: 'fit-content' }} alt="login" />
);

export const TangramLogo = () => (
	<img
		src={logoTangram}
		style={{ height: '55px', width: 'fit-content', marginLeft: '65px' }}
		alt="login"
	/>
);
